/**
 * WordPress loads jQuery in noConflict mode. This IIFE binds `$` to jQuery for this file only
 * (see https://developer.wordpress.org/plugins/javascript/jquery/ — "use jQuery, or pass $ into a closure").
 */
(function ($) {

/* Earliest probe: if this never appears, site.min.js is not loading or an error runs before this line. */
try {
    console.log('[HMHB DrinksCalendar] custom.js reached (top of file, before SparkDigital)');
} catch (ignore) {}

var SparkDigital = window.SparkDigital || {};

SparkDigital = (function () {

    /***********************************************************
    // GLOBAL - FOR STORING REUSABLE VARIABLES (EG. DOM)
    ***********************************************************/
    var global = {

        ajax_endpoints: window["ajax_endpoints"],

        google_recaptcha: window["google_recaptcha_site_key"],

        wp_nonce: window["wp_nonce"],

        wp_uid: window["wp_uid"],

        breakpoint: {}, // bootstrap viewport

        assets_dir: window["assets_dir"],

        debug_mode: $('body').hasClass('debug-mode'), // Debug on-off state

        // Define ones that are being called everywhere
        elements: {
            body: $("body"),
            iframes: $("body.single iframe"), // Be specific where the iframes might be added
            inlineSmoothScroll: $("a[smooth-scroll], a[href^='#'], a[href^='/#']"), // Select all inline anchors
            inlinePopUps: $('[inline-modal]'), // For all inline popups
            iframePopUps: $('[inline-youtube], [inline-video], [inline-gmaps]'), // For all iframe popups
            lazyload: $('[data-bg], img[data-src], iframe[data-src], video[data-src], .lazy'), // Lazy load bg images, img/iframe/video HTML elements. 
        },

        site_lang: $('html').attr('lang'), // get site language
        site_url: window["site_url"], // get site url

        storage_names: {
            venue_search: "venue-search",
            venue_search_mp: "venue-search-mp",
            user_bookmark: "user-bookmark",
            user_contact: "user-contact"
        },


    },
        /***********************************************************
        // COMPONENTS THAT ARE USED ON MORE THAN ONE PAGE & CALLABLE
        ***********************************************************/
        components = {

            modal: {
                init: function(){

                    const _self = this;

                    // alert( $(".modal:not([initialised])").length );

                    // Move all modal to the bottom of the HTML
                    $(".modal:not([initialised])").each(function(){
                        $(this).appendTo($("body"));
                        $(this).attr("initialised");
                    });
                },
                inline: function (elements) {
                    

                    const _self = this;
                    
                    _self.init();

                    var elements = $(elements).length != 0 ? $(elements) : global.elements.inlinePopUps;

                    // if ($(elements).length > 0) {
                    //     $(elements).magnificPopup({
                    //         type: 'inline',
                    //         closeOnContentClick: true,
                    //         fixedContentPos: true,
                    //         mainClass: 'mfp-fade',
                    //         removalDelay: 160,
                    //     });
                    // }

                },
                iframe: function (elements) {

                    const _self = this;
                    
                    _self.init();

                    var elements = $(elements).length != 0 ? $(elements) : global.elements.iframePopUps;

                    if ($(elements).length > 0) {
                        // $(elements).magnificPopup({
                        //     //disableOn: 700,
                        //     type: 'iframe',
                        //     mainClass: 'mfp-fade',
                        //     removalDelay: 160,
                        //     preloader: false,
                        //     fixedContentPos: false
                        // });
                    }
                },
                gallery: function (elements) {
                    
                    var elements = $(elements).length != 0 ? $(elements) : global.elements.galleries;
                    //console.log($(elements).length);
                    if ($(elements).length > 0) {

                        $(elements).magnificPopup({
                            type: 'image',
                            callbacks: {
                                open: function () {
                                    $('.headerFix').css('padding-right', 15);
                                }, //Fix for header moving when popup triggered
                                close: function () {
                                    $('.headerFix').css('padding-right', 0);
                                }
                            },
                            image: {
                                verticalFit: true,
                                titleSrc: function (item) {
                                    return item.el.parents('.gallery-item').find('.gallery-caption').text();
                                }

                            },
                            gallery: {
                                enabled: true,
                            },
                            mainClass: 'mfp-fade',
                            removalDelay: 160,
                            fixedContentPos: true,
                        });

                        // Separate remote trigger button to fire the magnificPopup gallery
                        var galleryHeaderImage = $(".postTopImage");
                        if ($(galleryHeaderImage).length > 0) {
                            $(galleryHeaderImage).click(function () {
                                $(elements).eq(0).trigger('click');
                                return false;
                            });
                        }
                    }

                },
            },
            privacy_consent: function () {
                // Generator: https://cookieconsent.insites.com
                // Doc: https://www.osano.com/cookieconsent/documentation/about-cookie-consent/
                jQuery(function () {

                    // Ensure CookieConsent JS Plugin exists
                    if (typeof window.cookieconsent !== "undefined") {

                        // Multisite    
                        switch (global.site_lang) {
                            // case "fr-FR": // French
                            //    var privacy_content = {
                            //         "message": "Ce site Internet utilise des cookies pour améliorer et personnaliser votre expérience. Pour plus d’informations sur la collecte et l’utilisation de vos informations, y compris l’utilisation de cookies, merci de consulter notre ",
                            //         "link": "politique de confidentialité",
                            //         "dismiss": "Ok",
                            //         "href": "/fr-fr/politique-de-confidentialite",
                            //         "target": "_blank",
                            //    };
                            // 	break;

                            default: // Defaults to English
                                var privacy_content = {
                                    "message": "This website uses cookies to ensure you get the best experience on our website. Please check out our ",
                                    "link": "privacy policy",
                                    "dismiss": "ACCEPT COOKIES",
                                    "href": "/privacy",
                                    "target": "_blank",
                                };
                        };

                        window.cookieconsent.initialise({
                            //dismissOnTimeout: 10,
                            position: "bottom-right",
                            palette: {
                                "popup": {
                                    //"text": "#fff",
                                    "background": "rgba(102, 201, 186, 1)"
                                }
                            },
                            elements: {
                                //header: '<span class="cc-header">{{header}}</span>&nbsp;',
                                //"message": "<div id='cookieconsent:desc'><p class='small cc-message' style='color:#fff'>{{message}}.</p></div>",
                                "messagelink": "<div id='cookieconsent:desc'><p class='small cc-message' style='color:#fff'>{{message}} <a aria-label='learn more about cookies' tabindex='0' class='cc-link' href='{{href}}' target='_blank'>{{link}}</a>.</p></div>",
                                "dismiss": "<a aria-label='dismiss cookie message' tabindex='0' class='buttonDefault cc-btn cc-dismiss small'>{{dismiss}}</a>"
                            },
                            content: privacy_content,
                        });

                    }

                });
            },
            smoothScroll: function (elements) {

                var elements = $(elements).length != 0 ? $(elements) : global.elements.inlineSmoothScroll;

                if ($(elements).length > 0) {
                    elements.on('click',function () {

                        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname && this.hash.slice(1) != "#" && this.hash.slice(1) != "") {
                            var target = $(this.hash);
                            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

                            if (target.length) {

                                // If have parent section have 'hidden' class, remove before sliding in
                                if ($(target).closest('section.hidden')) {
                                    $(target).closest('section.hidden').removeClass('hidden');
                                }

                                var headerHeight = $("header.sticky-top").length > 0 ? parseInt($("header.sticky-top").css("height")) : 0;

                                // Target y position within the browser (24px is faux offset).
                                var scroll_top = target.offset().top + 24;

                                // Sticky menu
                                if (global.breakpoint.index > 1) {
                                    scroll_top = scroll_top - (headerHeight);
                                } else {
                                    scroll_top = scroll_top - headerHeight;
                                }

                                // alert(scroll_top);

                                // Wordpress Adminbar (Only on desktop, ignored on mobile)
                                if ($("#wpadminbar").length > 0) {
                                    scroll_top = scroll_top - ($("#wpadminbar").css("postiion") == "fixed" ? parseInt($("#wpadminbar").css("height")) : 0);
                                }

                                $('html, body').animate({
                                    scrollTop: scroll_top
                                }, 1500);
                                return false;
                            }
                        }

                    });
                }
            },

            /**
             * Block paste and text drop on:
             * - fields with class no-paste
             * - Formidable confirmation fields: name item_meta[conf_ID] or nested ...[conf_ID]...
             * Uses capture + beforeinput and Formidable AJAX events.
             */
            noPasteFields: function () {
                var noPasteSelector = 'input.no-paste, textarea.no-paste, input[name^="item_meta[conf_"], textarea[name^="item_meta[conf_"], input[name*="[conf_"], textarea[name*="[conf_"]';

                function isNoPasteTarget(el) {
                    if (!el || el.nodeType !== 1) {
                        return false;
                    }
                    var tag = el.tagName;
                    if (tag !== 'INPUT' && tag !== 'TEXTAREA') {
                        return false;
                    }
                    if (el.classList && el.classList.contains('no-paste')) {
                        return true;
                    }
                    var name = el.getAttribute('name') || '';
                    if (name.indexOf('item_meta[conf_') === 0) {
                        return true;
                    }
                    // Repeating sections: item_meta[section][n][conf_fieldId]
                    if (/\[conf_\d+\]/.test(name)) {
                        return true;
                    }
                    return false;
                }

                function eventPrimaryTarget(e) {
                    if (typeof e.composedPath === 'function') {
                        var path = e.composedPath();
                        var i;
                        for (i = 0; i < path.length; i++) {
                            var node = path[i];
                            if (node && node.nodeType === 1 && (node.tagName === 'INPUT' || node.tagName === 'TEXTAREA')) {
                                return node;
                            }
                        }
                    }
                    return e.target;
                }

                function onPasteDropCapture(e) {
                    if (isNoPasteTarget(eventPrimaryTarget(e))) {
                        e.preventDefault();
                    }
                }

                function onBeforeInputCapture(e) {
                    if (e.inputType !== 'insertFromPaste' && e.inputType !== 'insertFromDrop') {
                        return;
                    }
                    if (isNoPasteTarget(eventPrimaryTarget(e))) {
                        e.preventDefault();
                    }
                }

                if (!document.documentElement.getAttribute('data-hmhb-no-paste-capture')) {
                    document.documentElement.setAttribute('data-hmhb-no-paste-capture', '1');
                    document.addEventListener('paste', onPasteDropCapture, true);
                    document.addEventListener('drop', onPasteDropCapture, true);
                    document.addEventListener('beforeinput', onBeforeInputCapture, true);
                }

                function bindDirectHandlers() {
                    $(noPasteSelector)
                        .off('paste.noPasteDirect drop.noPasteDirect')
                        .on('paste.noPasteDirect drop.noPasteDirect', function (e) {
                            e.preventDefault();
                        });
                }

                bindDirectHandlers();

                $(document)
                    .off('frmPageChanged.noPasteFields frmFormComplete.noPasteFields frmFormErrors.noPasteFields')
                    .on('frmPageChanged.noPasteFields frmFormComplete.noPasteFields frmFormErrors.noPasteFields', function () {
                        bindDirectHandlers();
                    });
            },

            formidableForms: function() {
                jQuery(document).ready(function ($) {

                    function getStickyHeaderBottom() {
                        var header = document.querySelector('header.main-header.sticky-top');

                        if (!header) {
                            return 0;
                        }

                        return header.getBoundingClientRect().bottom;
                    }

                    function scrollToFirstFormError(form) {
                        var $form = form instanceof jQuery ? form : $(form);

                        if (!$form.length) {
                            return;
                        }

                        var $field = $form.find('.frm_blank_field').filter(function () {
                            return $(this).is(':visible');
                        }).first();

                        if (!$field.length) {
                            return;
                        }

                        var $target = $field.find('.frm_primary_label').first();
                        if (!$target.length) {
                            $target = $field;
                        }

                        var target_el = $target.get(0);
                        var gap = 8;
                        var current_scroll = window.pageYOffset || document.documentElement.scrollTop || 0;
                        var scroll_top = current_scroll + target_el.getBoundingClientRect().top - getStickyHeaderBottom() - gap;

                        $('html, body').stop(true).animate({
                            scrollTop: Math.max(0, scroll_top)
                        }, 500);
                    }

                    // Server-side AJAX validation (after error markup is inserted).
                    $(document).on('frmFormErrors', function (event, form) {
                        window.setTimeout(function () {
                            scrollToFirstFormError(form);
                        }, 150);
                    });

                    // Client-side JS validation (frm_js_validate — does NOT trigger frmFormErrors).
                    document.addEventListener('frm_get_ajax_form_errors', function (event) {
                        var data = event.frmData;

                        if (!data || !data.formEl || !data.errors || !Object.keys(data.errors).length) {
                            return;
                        }

                        window.setTimeout(function () {
                            scrollToFirstFormError(data.formEl);
                        }, 50);
                    });

                    // Multi-page Next/Prev: scroll to page top (frm_scroll_offset disables Formidable's form scroll).
                    $(document).on('frmPageChanged', function () {
                        $('html, body').animate({
                            scrollTop: 0
                        }, 500);
                    });

                    // Page load: stay at top (Formidable auto-scroll disabled via frm_scroll_offset).
                    if ($('form.frm_ajax_submit, .frm_forms form').length > 0) {
                        window.scrollTo(0, 0);
                    }

                });

                /**
                 * Formidable Forms Pro: Dynamic Drag-and-Drop Sync (Checked Only)
                 * Handles jQuery Compatibility Mode for WordPress.
                 * 
                 * This script identifies "Target" hidden fields via a specific CSS class,
                 * extracts the ID of a "Source" checkbox field, and enables drag-and-drop 
                 * reordering. It captures ONLY the values of checked items in their new order.
                 * 
                 * Features:
                 * - Works with both single-page and multi-page forms
                 * - Automatically reinitializes when navigating between form pages
                 * - Supports collapsible sections (frm_section_conf_show)
                 * - Only checked items are draggable and included in output
                 * 
                 * Usage:
                 * Add class 'drag-drop-checkboxes-310' to a Hidden Field to target Checkbox #310.
                 * 
                 * Event Listeners:
                 * - Document ready: Initial setup
                 * - frmPageChanged: Reinitialize when navigating multi-page forms
                 * - frm_section_conf_show: Reinitialize when collapsible sections are shown
                 */


                function initFrmsSelectiveDragDrop() {
                    (function($) {
                        "use strict";

                        /**
                         * Updates the hidden target with current order of CHECKED items.
                         */
                        function updateSerializedOrder($container, $input) {
                            let checkedValues = [];
                            // We iterate through ALL inputs in DOM order, but only collect checked ones
                            $container.find('input:checked').each(function() {
                                checkedValues.push($(this).val());
                            });
                            $input.val(checkedValues.join(', ')).trigger('change');
                        }

                        /**
                         * Refreshes which items are draggable based on their checked state.
                         */
                        function refreshDraggableState($container) {
                            // Apply a class for styling and tell Sortable which items to handle
                            $container.find('.frm_checkbox, .frm_radio').each(function() {
                                const $optionRow = $(this);
                                const isChecked = $optionRow.find('input').is(':checked');
                                
                                if (isChecked) {
                                    $optionRow.addClass('is-draggable').css('cursor', 'move');
                                } else {
                                    $optionRow.removeClass('is-draggable').css('cursor', 'default');
                                }
                            });

                            // Update the sortable "items" selector dynamically
                            if ($container.hasClass('ui-sortable')) {
                                $container.sortable("option", "items", ".is-draggable");
                                $container.sortable("refresh");
                            }
                        }

                        function initDynamicSortables() {
                            $('[class*="drag-drop-checkboxes-"]').each(function() {
                                const $targetContainer = $(this);
                                const classList = $targetContainer.attr('class').split(/\s+/);
                                let srcFieldId = null;

                                $.each(classList, function(i, className) {
                                    if (className.indexOf('drag-drop-checkboxes-') === 0) {
                                        srcFieldId = className.replace('drag-drop-checkboxes-', '');
                                    }
                                });

                                if (!srcFieldId) return;

                                const $srcWrapper = $('#frm_field_' + srcFieldId + '_container');
                                const $optContainer = $srcWrapper.find('.frm_opt_container');
                                const $hiddenInput = $targetContainer.find('input');

                                if ($optContainer.length && typeof $.fn.sortable !== 'undefined' && !$optContainer.hasClass('ui-sortable')) {
                                    
                                    // Initialize Sortable targeting ONLY items with the 'is-draggable' class
                                    $optContainer.sortable({
                                        items: ".is-draggable",
                                        cursor: "move",
                                        opacity: 0.8,
                                        placeholder: "ui-state-highlight",
                                        update: function() {
                                            updateSerializedOrder($optContainer, $hiddenInput);
                                        }
                                    }).disableSelection();

                                    // When a checkbox is clicked: Update draggable state AND the hidden field
                                    $optContainer.on('change', 'input', function() {
                                        refreshDraggableState($optContainer);
                                        updateSerializedOrder($optContainer, $hiddenInput);
                                    });

                                    // Initial Run
                                    refreshDraggableState($optContainer);
                                    updateSerializedOrder($optContainer, $hiddenInput);
                                }
                            });
                        }

                        $(function() {
                            initDynamicSortables();
                            $(document).on('frm_section_conf_show', function() {
                                initDynamicSortables();
                            });
                            $(document).on('frmPageChanged', function() {
                                initDynamicSortables();
                            });
                        });

                    })(jQuery);
                }

                if (typeof jQuery !== 'undefined') {
                    initFrmsSelectiveDragDrop();
                } else {
                    document.addEventListener('DOMContentLoaded', function() {
                        if (typeof jQuery !== 'undefined') initFrmsSelectiveDragDrop();
                    });
                }

                
            },

            stickyHeader: function () {
                // Uses Polyfill for browsers that does not support IntersectionObserver API

                //  Navigation target
                var sticky_nav = document.querySelector(".sticky-top");

                // Sticky Target
                var sticky_target = document.querySelector("#sticky-header-target");

                if ($(sticky_nav).length > 0 && $(sticky_target).length > 0) {

                    var observer = new IntersectionObserver(function (entries) {
                        // no intersection with screen
                        if (entries[0].intersectionRatio === 0) {
                            $(sticky_nav).addClass('scrolled');
                            if (global.debug_mode) {
                                console.log("Sticky Target: Outside");
                            }
                        }
                        // fully intersects with screen
                        else if (entries[0].intersectionRatio === 1) {
                            $(sticky_nav).removeClass('scrolled');
                            if (global.debug_mode) {
                                console.log("Sticky Target: Inside");
                            }
                        }

                    }, { threshold: [0, 1] });

                    observer.observe(sticky_target);
                }

            },

            navBarToggle: function () {

                $(".nav-mobile-btn button").on("click", function () {
                    $(this).toggleClass('opened');
                    $(".nav-elements").toggleClass('swiped');
                });

            },

            // Compiles HandleBars
            handlebars: {

                // Use for tracking initialisation state
                init: false,

                // Use for storing cached template that has been compiled
                cached_template: {},

                // Render Template
                render: function (templateElement) {

                    // console.log("handlebars.render");

                    // Initialise helper if haven't 
                    if (this.init === false) this.extend();

                    if (templateElement === "" || templateElement === null) {
                        return false;
                    }

                    // Get ID and used for cached
                    var templateName = $(templateElement).attr("ID");

                    // console.log("Template Name: "+templateName);
                    // console.log(this.cached_template[templateName]);

                    if (this.cached_template[templateName] != undefined) {

                        // console.log("CACHED TEMPLATE");
                        return this.cached_template[templateName];

                    } else {

                        var templateSource = $(templateElement).html();

                        if (templateSource !== "" || templateSource !== null) {

                            // Compile handlebars and return
                            this.cached_template[templateName] = Handlebars.compile(templateSource);
                            return this.cached_template[templateName];
                        }
                    }

                    return false;
                },

                // Extend such as additional kelpers
                extend: function () {

                    // debug helper
                    // usage: {{debug}} or {{debug someValue}}
                    // from: @commondream (http://thinkvitamin.com/code/handlebars-js-part-3-tips-and-tricks/)
                    Handlebars.registerHelper("debug", function (optionalValue) {
                        console.log("Current Context");
                        console.log("====================");
                        console.log(this);

                        if (optionalValue) {
                            console.log("Value");
                            console.log("====================");
                            console.log(optionalValue);
                        }
                    });

                    Handlebars.registerHelper('reverse', function (arr) {

                        //console.log(typeof(arr))
                        if (global.polyfill_isArray(arr)) {
                            arr.reverse();
                        } else {
                            arr;
                        }

                    });

                    Handlebars.registerHelper('str_concatnate', function (a, b, opts) {
                        var str_combined = a + '' + b;
                        return new Handlebars.SafeString(str_combined);
                    });

                    Handlebars.registerHelper('str_replace', function (a, b, c, opts) {
                        var str_replaced = a.replace(b, c);
                        return new Handlebars.SafeString(str_replaced);
                    });

                    // Provides conditional string checks
                    Handlebars.registerHelper('if_eq', function (a, b, opts) {
                        if (a === b) {
                            return opts.fn(this);
                        } else {
                            return opts.inverse(this);
                        }
                    });

                    // Checks if string contains
                    Handlebars.registerHelper('if_contains', function (a, b, opts) {
                        if (a.indexOf(b) >= 0) {
                            return opts.fn(this);
                        } else {
                            return opts.inverse(this);
                        }
                    });

                    // Checks if obj contains
                    Handlebars.registerHelper('if_obj_contains', function (a, b, c, opts) {

                        var obj_founds = global.search_object_by_key(a, b, c);

                        if (obj_founds.length > 0) {
                            return opts.fn(this);
                        } else {
                            return opts.inverse(this);
                        }
                    });

                    // Checks if it's an object
                    Handlebars.registerHelper('is_obj', function (item, options) {
                        if (typeof item === "object") {
                            return options.fn(this);
                        } else {
                            return options.inverse(this);
                        }
                    });

                    // Comparsion Check
                    Handlebars.registerHelper('if_compare', function (lvalue, operator, rvalue, opts) {

                        var operators, result;

                        if (arguments.length < 3) {
                            throw new Error("Handlerbars Helper 'compare' needs 2 parameters");
                        }

                        if (opts === undefined) {
                            opts = rvalue;
                            rvalue = operator;
                            operator = "===";
                        }

                        operators = {
                            '==': function (l, r) {
                                return l == r;
                            },
                            '===': function (l, r) {
                                return l === r;
                            },
                            '!=': function (l, r) {
                                return l != r;
                            },
                            '!==': function (l, r) {
                                return l !== r;
                            },
                            '<': function (l, r) {
                                return l < r;
                            },
                            '>': function (l, r) {
                                return l > r;
                            },
                            '<=': function (l, r) {
                                return l <= r;
                            },
                            '>=': function (l, r) {
                                return l >= r;
                            },
                            'typeof': function (l, r) {
                                return typeof l == r;
                            }
                        };

                        if (!operators[operator]) {
                            throw new Error("Handlerbars Helper 'compare' doesn't know the operator " + operator);
                        }

                        result = operators[operator](lvalue, rvalue);

                        if (result) {
                            return opts.fn(this);
                        } else {
                            return opts.inverse(this);
                        }

                    });

                    //  Format a date
                    //  @link https://github.com/phstc/jquery-dateFormat
                    Handlebars.registerHelper('DateFormat', function (input, dateformat) {

                        // Normalize date to unix time
                        var unixTimestamp = new Date().getTime(input);
                        unixTimestamp = new Date(unixTimestamp).toISOString();

                        dateformat = dateformat == '' ? 'dd/MM/yyyy' : dateformat;

                        if (dateformat == 'pretty') {
                            return new Handlebars.SafeString($.format.prettyDate(new Date(unixTimestamp)));
                        } else {
                            return new Handlebars.SafeString($.format.date(new Date(unixTimestamp), dateformat));
                        }

                    });

                    // Finished initialisation
                    this.init = true;

                }


            },

            lazyLoad: function () {

                if (typeof (LazyLoad) != 'undefined') {

                    // @link https://github.com/verlok/lazyload
                    // Instantiate LazyLoad and make available for in Global JS scope
                    window.lazyLoadInstance = new LazyLoad({
                        //use_native: false, // Use browser native implementation if available
                        load_delay: 300, // Set delay loading when there's inline anchor so that it scrolls to the right spot
                    }, global.elements.lazyload);


                    /* 
                    BROWSER'S NATIVE PRINT EVENTS LISTENERS
                    --------------------------------------- 
                    In order to make browsers load all the images before printing
                    even if the user doesn't press the custom print button. 
                    NOTE that this works only partially in some browsers! */
                    var isSafari = /^((?!chrome|android).)*safari/i.test(
                        navigator.userAgent
                    );
                    if (!isSafari) {
                        window.onbeforeprint = function () {
                            window.lazyLoadInstance.loadAll();
                        };
                    } else {
                        // Safari doesn't support the onbeforeprint event
                        var mediaQueryList = window.matchMedia("print");
                        mediaQueryList.addListener(function (mql) {
                            if (mql.matches) {
                                window.lazyLoadInstance.loadAll();
                            }
                        });
                    }

                }

            },

            tabs: {
            },

            wow: function () {

                if (typeof (WOW) != 'undefined') {
                    //Wow js
                    wow = new WOW({
                        mobile: true,
                    })
                    wow.init();
                }

            },

            // Vertical Carousel Sync
            verticalCarouselSync: function () {
                
                $('.vertical-carousel-wrapper').each(function() {
                    var $wrapper = $(this);
                    var $imagesCarousel = $wrapper.find('.vertical-carousel-images');
                    var $contentCarousel = $wrapper.find('.vertical-carousel-content');
                    
                    if ($imagesCarousel.length && $contentCarousel.length) {
                        
                        // Content carousel is the sole master: drives image carousel on change
                        $contentCarousel.on('changed.owl.carousel', function(event) {
                            var position = event.item.index - (event.relatedTarget._clones.length / 2);
                            var count = event.item.count;
                            position = ((position % count) + count) % count;
                            $imagesCarousel.trigger('to.owl.carousel', [position, 0, false]);
                        });
                    }
                });

            },

            // Bootstrap Carousel
            // Only allow carousel to initialise and rotate within viewport
            bs_carousel: function () {


                // Uses Polyfill for browsers that does not support IntersectionObserver API

                var carouselTarget = document.querySelector(".carousel[data-ride='false']");


                if ($(carouselTarget).length > 0) {


                    var observer = new IntersectionObserver(function (entries) {

                        // fully intersects with screen
                        if (entries[0].intersectionRatio === 1) {


                            if ($(carouselTarget).attr("data-ride") == "false" || $(carouselTarget).attr("data-ride") == "1") {
                                // Set to true 
                                $(carouselTarget).attr("data-ride", "carousel");

                                // Autuplays carousel
                                $(carouselTarget).carousel({
                                    ride: 'carousel',
                                    // interval: 2800,
                                })
                            } else {
                                // re-activate carousel
                                $(carouselTarget).carousel('cycle');
                            }

                            if (global.debug_mode) {
                                console.log("Coursel Target: Inside viewport");
                            }
                        } else {

                            if ($(carouselTarget).attr("data-ride") == "carousel" || $(carouselTarget).attr("data-ride") == "0") {

                                // activate carousel
                                $(carouselTarget).carousel('pause');

                                if (global.debug_mode) {
                                    console.log("Coursel Target: Outside viewport");
                                }

                            }
                        }

                    }, { threshold: [0, 1] });

                    observer.observe(carouselTarget);

                }



            },

            forms: {

                // Default Bootstrap form validation
                init: function (forms) {

                    // Fetch all the forms we want to apply custom Bootstrap validation styles to
                    forms = !!!forms && forms != undefined ? forms : $('form.needs-validation');

                    $(forms).each(function () {

                        const _form = this;

                        // MaxLength 
                        // @link https://github.com/mimo84/bootstrap-maxlength/
                        $(this).find('textarea[maxlength]').maxlength({
                            appendToParent: true
                        });

                        $(this).find('textarea').on('autosize:resized', function () {
                            $(this).trigger('maxlength.reposition');
                        });

                        $(this).on("submit", function (event) {

                            if ($(this).get(0).checkValidity() === false) {
                                event.preventDefault();
                                event.stopPropagation();
                                // alert("isDefaultPrevented");
                            }

                            $(this).addClass('was-validated');


                        });


                    });

                    // Initialize year field limits for all fields with .min-age-* classes
                    // This sets up automatic min/max year restrictions on both existing forms
                    // and dynamically loaded forms (e.g., Formidable Forms loaded via AJAX)
                    this.init_year_field_limits();

                    // DEBUG: Create and activate modal for use for confirmation or error
                    // components.bs_modal.show('Form successfully submitted!', '<p>CONTENT</p>');
                    // components.bs_modal.success('Form successfully submitted!','<p>CONTENT</p>');
                    // components.bs_modal.failed('Form successfully submitted!','<p>CONTENT</p>');

                },

                // Search form for searching for venues
                contact: {

                    selector: "form#contact-form", // Jquery selector

                    // Collect forms
                    elements: function (element) {
                        // Get all tbe                    
                        var forms = $(element).length != 0 ? $(element) : $(this.selector);

                        if ($(forms).length > 0) {
                            return forms;
                        } else {
                            return null;
                        }

                    },

                    // Initialisation
                    init: function () {

                        const _self = this;

                        var forms = this.elements();
                        if (forms === null) return false;

                        // Submit function
                        _self.submit();

                        // Pre-popualate form fields 
                        // _self.updateFormFields();

                    },

                    // Enable or disable submit button, use during ajax 
                    disableFormFields: function (disabled = true, label = 'Please wait...') {

                        var forms = this.elements();
                        if (forms === null) return;

                        $(forms).find("[type='submit']").each(function () {

                            // Show/hide spinner and button text
                            if (disabled) {

                                let labelDefault = $(this).attr("aria-label");
                                $(this).attr("aria-label-default", labelDefault);
                                $(this).attr("aria-label", label);

                                $(this).find(".label").hide();
                                $(this).find(".spinner-border").prop("hidden", false);
                            } else {

                                let labelRevert = $(this).attr("aria-label-default");
                                labelRevert = labelRevert != "" ? labelRevert : $(this).attr("aria-label-default");
                                $(this).attr("aria-label", labelRevert);

                                $(this).find(".label").show();
                                $(this).find(".spinner-border").prop("hidden", true);
                            }

                        });



                    },

                    // Updates form fields (input fields) with the data stored in browser
                    updateFormFields: function (data) {

                        var forms = this.elements();
                        if (forms === null) return;

                        var data = data != null && data != "" ? data : get_storage(global.storage_names.user_contact);

                        if (data != null && data != "") {

                            $.each(data, function (key, value) {

                                var formFields = $(forms).find("[name='" + key + "']");

                                if ($(formFields).length > 0) {

                                    $(formFields).val(value);
                                }
                            });

                            return true;

                        } else {
                            return false;
                        }


                    },



                    // Form submit process
                    submit: function () {

                        const _self = this;
                        var forms = this.elements();
                        if (forms === null) return;

                        $(forms).each(function (index, form) {

                            // Submit Event
                            $(this).on("submit", function (e) {

                                // Return immediately if not validated
                                if (e.isDefaultPrevented()) {
                                    return false;
                                }

                                if (global.google_recaptcha != undefined && global.google_recaptcha != '') {

                                    grecaptcha.ready(function () {
                                        grecaptcha.execute(global.google_recaptcha, { action: 'submit' }).then(function (token) {

                                            // When Google Recaptcha token is ready, call ajax function
                                            $.when(

                                                $.ajax({
                                                    url: global.ajax_endpoints.post_contact_form,
                                                    method: "POST",
                                                    dataType: "json",
                                                    data: $(form).serialize(),
                                                    statusCode: {
                                                        404: function () {
                                                            if (global.debug_mode) {
                                                                console.log("Request method not found");
                                                            }
                                                        },
                                                        406: function () {
                                                            if (global.debug_mode) {
                                                                console.log("Some data missing from the form");
                                                            }
                                                        },
                                                        503: function () {
                                                            console.log("Email did not send or other server related error while processing the request");
                                                        }
                                                    },
                                                    beforeSend: function (xhr) {
                                                        // console.log("Site Key: "+global.google_recaptcha);
                                                        // console.log("Token: "+token);
                                                        xhr.setRequestHeader('X-Recaptcha-Token', token);

                                                        // console.log( global.wp_nonce );
                                                        if (global.wp_nonce != undefined && global.wp_nonce != "") {
                                                            xhr.setRequestHeader('X-WP-Nonce', global.wp_nonce);
                                                        }
                                                        // Disable submit button
                                                        _self.disableFormFields(true);
                                                    },
                                                    complete: function () {
                                                        $(form).removeClass('was-validated');
                                                        // Enable submit button
                                                        _self.disableFormFields(false);
                                                    },

                                                })

                                            ).then(

                                                function (response, textStatus, jqXHR) {

                                                    // Success
                                                    if (response.success !== undefined && !!response.success) {

                                                        // Store user form data and allow reuse for other contacts
                                                        if (!!response.user) {
                                                            set_storage(global.storage_names.user_contact, {
                                                                'first_name': response.user.first_name,
                                                                'last_name': response.user.last_name,
                                                                'phone': response.user.phone,
                                                                'email': response.user.email,
                                                            });
                                                        }

                                                        // DEBUG RELATED
                                                        if (global.debug_mode) {
                                                            console.log(response);
                                                        }

                                                        components.gtm.dataLayerGAEventTracking('Forms', 'Submit', 'Contact Form - ' + response.user.contact_type);

                                                        components.bs_modal.success('Thank you for contacting us!', '<p>Thank you for contacting us ' + response.user.first_name + '. We will be in touch shortly.</p>');

                                                        $(form)[0].reset();

                                                        return false;

                                                    }


                                                    if (global.debug_mode) {
                                                        console.log(response);
                                                    }


                                                    // Spam Filter exists and failed
                                                    if (global.google_recaptcha != undefined && global.google_recaptcha != '' && response.spam_failed !== undefined && !!response.spam_failed) {
                                                        // Show error if the response was unsuccessful
                                                        components.bs_modal.failed('Something not quite right!', '<p>Our spam filter has detected abnomalities with your form submission. Please try again later or kindly call us directly should the problem persist.</p><p>We apologise for the inconvenience caused.</p>');

                                                        return false;
                                                    }

                                                    // Show error if the response was unsuccessful
                                                    components.bs_modal.failed('We\'re unable to submit the form', '<p>There was some issue trying to submit the form. Please try again later or kindly call us should the issue persist.</p><p>We apologise for the inconvenience caused.</p>');

                                                    return false;


                                                }

                                            );

                                        });
                                    });

                                }

                                // Prevent Browser Default
                                return false;

                            });

                        });

                    }

                },

                // Registration form for programs
                registration: {

                    selector: "form[name='registration']", // Jquery selector

                    // Collect forms
                    elements: function (element) {
                        // Get all tbe                    
                        var forms = $(element).length != 0 ? $(element) : $(this.selector);

                        if ($(forms).length > 0) {
                            return forms;
                        } else {
                            return null;
                        }

                    },

                    // Initialisation
                    init: function () {

                        const _self = this;

                        var forms = this.elements();
                        if (forms === null) return false;
                        
                        // Match password field validation
                        _self.match_field_value_validation($('input[name="user_pass"]'), $('input[name="user_pass_confirm"]'));

                        // Submit function
                        _self.submit();

                    },

                    // Check two field values matches (Eg. Password confirmation)
                    match_field_value_validation: function (fieldOne, fieldTwo, checkOnly = false) {


                        if ($(fieldOne).length > 0 && $(fieldTwo).length > 0) {


                            // Check value only
                            if (checkOnly) {

                                $(fieldTwo).trigger('keyup');

                                if (($(fieldOne).val() != $(fieldTwo).val())) {

                                    $(fieldTwo).closest('form').removeClass('was-validated');

                                    return false;

                                } else {

                                    return true;

                                }

                            } else {

                                // Check password field match
                                $(fieldOne).on("focusout", function () {

                                    if ($(this).val() != $(fieldTwo).val()) {
                                        $(fieldTwo).removeClass("is-valid").addClass("is-invalid");
                                    } else {
                                        $(fieldTwo).removeClass("is-invalid").addClass("is-valid");
                                    }
                                });

                                $(fieldTwo).on("keyup", function () {

                                    if ($(fieldOne).val() != $(this).val()) {
                                        $(this).removeClass("is-valid").addClass("is-invalid");
                                    } else {
                                        $(this).removeClass("is-invalid").addClass("is-valid");
                                    }
                                });
                            }

                        }

                    },

                    // Enable or disable submit button, use during ajax 
                    disableFormFields: function (disabled = true, label = 'Please wait...') {

                        var forms = this.elements();
                        if (forms === null) return;

                        $(forms).find("[type='submit']").each(function () {

                            // Show/hide spinner and button text
                            if (disabled) {

                                let labelDefault = $(this).attr("aria-label");
                                $(this).attr("aria-label-default", labelDefault);
                                $(this).attr("aria-label", label);

                                $(this).find(".label").hide();
                                $(this).find(".spinner-border").prop("hidden", false);

                                $(this).text(label);
                                $(this).prop('disabled', true);

                            } else {

                                let labelRevert = $(this).attr("aria-label-default");
                                labelRevert = labelRevert != "" ? labelRevert : $(this).attr("aria-label-default");
                                $(this).attr("aria-label", labelRevert);

                                $(this).find(".label").show();
                                $(this).find(".spinner-border").prop("hidden", true);

                                $(this).text(labelRevert);
                                $(this).prop('disabled', false);

                            }

                        });

                    },

                    // Form submit process
                    submit: function () {

                        const _self = this;
                        var forms = this.elements();
                        if (forms === null) return;

                        $(forms).each(function (index, form) {

                            // Submit Event
                            $(this).on("submit", function (e) {

                                // Return immediately if not validated
                                if (e.isDefaultPrevented()) {
                                    return false;
                                }

                                // Return if password fields don't match
                                if (false === _self.match_field_value_validation($('input[name="user_pass"]'), $('input[name="user_pass_confirm"]'), true)) {
                                    return false;
                                }

                                if (global.google_recaptcha != undefined && global.google_recaptcha != '') {

                                    grecaptcha.ready(function () {
                                        grecaptcha.execute(global.google_recaptcha, { action: 'submit' }).then(function (token) {

                                            // When Google Recaptcha token is ready, call ajax function
                                            $.when(

                                                $.ajax({
                                                    url: global.ajax_endpoints.post_user_registration_form,
                                                    method: "POST",
                                                    dataType: "json",
                                                    data: $(form).serialize(),
                                                    statusCode: {
                                                        404: function () {
                                                            if (global.debug_mode) {
                                                                console.log("Request method not found");
                                                            }
                                                        },
                                                        406: function () {
                                                            if (global.debug_mode) {
                                                                console.log("Some data missing from registration form or other problem during the process.");
                                                            }
                                                        },
                                                        503: function () {
                                                            console.log("Requests did not send or other server related error while processing the request");
                                                        }
                                                    },
                                                    beforeSend: function (xhr) {

                                                        // console.log("Site Key: "+global.google_recaptcha);
                                                        // console.log("Token: "+token);
                                                        xhr.setRequestHeader('X-Recaptcha-Token', token);

                                                        // console.log( global.wp_nonce );
                                                        if (global.wp_nonce != undefined && global.wp_nonce != "") {
                                                            xhr.setRequestHeader('X-WP-Nonce', global.wp_nonce);
                                                        } else {
                                                            xhr.setRequestHeader('X-WP-Nonce', global.wp_nonce);
                                                        }

                                                        // Disable submit button
                                                        _self.disableFormFields(true);

                                                        // return false;

                                                    },
                                                    complete: function () {

                                                        $(form).removeClass('was-validated');
                                                        // Enable submit button
                                                        _self.disableFormFields(false);

                                                    },

                                                })

                                            ).then(

                                                function (response, textStatus, jqXHR) {


                                                    if (global.debug_mode) {
                                                        console.log(response);
                                                    }

                                                    // Success
                                                    if (response.success != undefined && !!response.success) {

                                                        // Store user form data and allow reuse for other contacts
                                                        if (!!response.user) {
                                                            set_storage(global.storage_names.user_contact, {
                                                                'first_name': response.user.user_fn,
                                                                'phone': response.user.user_phone,
                                                                'email': response.user.user_email,
                                                            });
                                                        }

                                                        // DEBUG RELATED
                                                        if (global.debug_mode) {
                                                            console.log(response);
                                                        }

                                                        components.gtm.dataLayerGAEventTracking('Forms', 'Submit', 'Program Registration');

                                                        if (response.is_existing_user != undefined && !!response.is_existing_user && response.user_enrolled != undefined && !!response.user_enrolled) {



                                                            // Existing user,existed in Wordpress site for other programs but new registration for this program

                                                            var successMessage = $('<h3>Registration completed</h3><p>Thank you ' + response.user.user_fn + ' for your registration. You\'ll receive an email confirming your registration shortly. Please <a href="/login/?registration=success&email=' + encodeURIComponent(response.user.user_email) + '">follow link</a> to login using your email address and password.</p><p><strong>Please Note:</strong> Your password hasn\'t been updated so please use your existing password to login.</p><p><a href="/login/?registration=success&email=' + encodeURIComponent(response.user.user_email) + '" class="btn btn-primary px-5" tabindex="-1" role="button">Login</a></p>');

                                                       

                                                        } else {

                                                            // Completely new user, never existed in Wordpress site for other sites
                                                            // var successMessage = $('<h3>Registration completed</h3><p>Thank you ' + response.user.user_fn + ' for your registration. You\'ll receive an email confirming your registration shortly. Please <a href="/login/?registration=success&email=' + encodeURIComponent(response.user.user_email) + '">follow link</a> to login using your email address and password.</p><p><a href="/login/?registration=success&email=' + encodeURIComponent(response.user.user_email) + '" class="btn btn-primary px-5" tabindex="-1" role="button">Login</a></p>');

                                                            var successMessage = $('<h3>Registration completed</h3><p>Thank you ' + response.user.user_fn + ' for your registration. You\'ll receive an email confirming your registration shortly. Please wait while we redirect to the program...');

                                                            // Automatically logged in user and send to homepage 

                                                            // Get the current URL
                                                            const currentUrl = window.location.href;

                                                            // Use URL object for robust URL parsing
                                                            const url = new URL(currentUrl);
                                                        
                                                            // Get the pathname (e.g., /path/to/page)
                                                            const pathname = url.pathname;
                                                        
                                                            // Split the pathname by slashes
                                                            const pathParts = pathname.split('/');
                                                        
                                                            // Handle cases where there's no path or just a leading slash
                                                            if (pathParts.length <= 2 || (pathParts.length === 2 && pathParts[1] === "")) {
                                                                // Redirect to the base URL (domain) if no path or just "/"
                                                                window.location.href = url.origin; 
                                                                return;
                                                            }
                                                        
                                                            // Extract the first level directory (e.g., /path)
                                                            const firstLevelDirectory = "/" + pathParts[1];
                                                        
                                                            // Reconstruct the URL with just the first level directory
                                                            const newUrl = url.origin + firstLevelDirectory;
                                                        
                                                            // alert(newUrl);

                                                            // Redirect to the new URL
                                                            window.location.href = newUrl;
                                                            
                                                            return;

                                                        }



                                                        $(form).fadeOut();

                                                        $(form).before($(successMessage));

                                                        var headerHeight = $("header.sticky-top").length > 0 ? parseInt($("header.sticky-top").css("height")) : 0;

                                                        // Target y position within the browser (24px is faux offset).
                                                        var scroll_top = $(successMessage).offset().top + 24;

                                                        // Sticky menu
                                                        if (global.breakpoint.index > 1) {
                                                            scroll_top = scroll_top - (headerHeight);
                                                        } else {
                                                            scroll_top = scroll_top - headerHeight;
                                                        }

                                                        // Scroll to incompleted quiz
                                                        $('html, body').animate({
                                                            scrollTop: $(successMessage)
                                                        }, 800);

                                                        return false;

                                                    }

                                                },

                                                function (jqXHR, textStatus, errorThrown) {

                                                    if (global.debug_mode) {
                                                        console.log(response);
                                                    }

                                                    var response = jqXHR.responseJSON;
                                                    var statusCode = jqXHR.status; // Eg. 406

                                                    // console.log(jqXHR);
                                                    // console.log(response);
                                                    // console.log(statusCode);


                                                    // Default error message
                                                    // Show error if the response was unsuccessful
                                                    // components.bs_modal.failed('Registration Failed!', '<p>There was some issue trying to submit the form. Please try again later or kindly call us should the issue persist.</p><p>We apologise for the inconvenience caused.</p>');
                                                    var failedMessage = $('<h3>Registration failed!</h3><p>There were issues with your registration or you\'re already enrolled. If you\'re already enrolled, please <a href="/login">login here</a>.</p><p>Please try again later or <a href="#office-location">contact us</a> should the issue persist. We apologise for the inconvenience caused.</p>');


                                                    if (response != undefined) {

                                                        // RedCap ID miss match in backend.
                                                        if (response.rc_invalid != undefined && !!response.rc_invalid) {
                                                            // components.bs_modal.failed('Registration Disallowed!', '<p>There was an error with your registration.<!-- REDCAP ID miss match --></p>');

                                                            var failedMessage = $('<h3 aria-label="failed RC validation">Registration disallowed!</h3><p>There was an error with your registration. Please <a href="#office-location">contact us</a> for support.</p>');

                                                        }


                                                        // Spam Filter exists and failed
                                                        if (global.google_recaptcha != undefined && global.google_recaptcha != '' && response.spam_failed !== undefined && !!response.spam_failed) {
                                                            // Show error if the response was unsuccessful
                                                            // components.bs_modal.failed('Registration Failed!', '<p>Our spam filter has detected abnomalities with your form submission. Please try again later or kindly call us directly should the problem persist.</p><p>We apologise for the inconvenience caused.</p>');


                                                            var failedMessage = $('<h3>Registration failed!</h3><p>Our spam filter has detected abnomalities with your form submission. Please try again later or kindly call us directly should the problem persist.</p><p>We apologise for the inconvenience caused.</p>');

                                                        }

                                                    }


                                                    $(form).fadeOut();

                                                    $(form).before($(failedMessage));

                                                    var headerHeight = $("header.sticky-top").length > 0 ? parseInt($("header.sticky-top").css("height")) : 0;

                                                    // Target y position within the browser (24px is faux offset).
                                                    var scroll_top = $(failedMessage).offset().top + 24;

                                                    // Sticky menu
                                                    if (global.breakpoint.index > 1) {
                                                        scroll_top = scroll_top - (headerHeight);
                                                    } else {
                                                        scroll_top = scroll_top - headerHeight;
                                                    }

                                                    // Scroll to incompleted quiz
                                                    $('html, body').animate({
                                                        scrollTop: $(failedMessage)
                                                    }, 800);


                                                    return false;


                                                }

                                            );

                                        });
                                    });

                                }

                                // Prevent Browser Default
                                return false;

                            });

                        });

                    }

                
                },

                /**
                 * Limit year field based on minimum age requirement
                 * 
                 * IMPORTANT: For Formidable Forms number fields, the min/max attributes are added via PHP hook
                 * in the FormidableForms class (wpThemes/hmhb/inc/FormidableForms.php). This JavaScript function
                 * serves as a fallback for non-Formidable forms, select dropdowns, and edge cases.
                 * 
                 * Dynamically restricts year input fields (number inputs and dropdowns) based on a minimum
                 * age requirement specified in the field's CSS class name using the pattern .min-age-{number}.
                 * 
                 * Examples:
                 *   - .min-age-18 = User must be at least 18 years old (max year = current year - 18)
                 *   - .min-age-21 = User must be at least 21 years old (max year = current year - 21)
                 *   - .min-age-16 = User must be at least 16 years old (max year = current year - 16)
                 * 
                 * The function always sets a minimum boundary of 100 years ago to prevent unrealistic dates.
                 * 
                 * @param {string} selector - jQuery selector for target fields. Defaults to '[class*="min-age-"]'
                 *                            which matches all elements with a class containing "min-age-"
                 * 
                 * Usage:
                 *   HTML: <input type="number" class="form-control min-age-18" name="birth_year">
                 *   HTML: <select class="form-control min-age-21" name="birth_year">...</select>
                 *   Formidable Forms: Add "min-age-18" to the field's "CSS Layout Classes" setting
                 */
                limit_year_field: function (selector) {

                    // Default selector matches all elements with .min-age-* class pattern
                    // This allows the function to be called without parameters and automatically
                    // find and process all relevant fields on the page
                    selector = selector || '[class*="min-age-"]';
                    
                    var currentYear = new Date().getFullYear();
                    
                    // Process each matching field individually
                    $(selector).each(function() {
                        var $field = $(this);
                        
                        // Extract the minimum age requirement from the class name
                        // Pattern: .min-age-(\d+) where (\d+) captures one or more digits
                        // Example: "min-age-18" will match and capture "18"
                        var classes = $field.attr('class') || '';
                        var match = classes.match(/min-age-(\d+)/);
                        
                        // Skip this field if no matching class pattern found
                        if (!match) {
                            return;
                        }
                        
                        // Extract the minimum age from the regex capture group
                        var minAge = parseInt(match[1], 10);
                        
                        // Calculate year boundaries
                        var minYear = currentYear - 100;      // Nobody should be entering a birth year more than 100 years ago
                        var maxYear = currentYear - minAge;   // Maximum year based on minimum age requirement
                        
                        // Apply limits to number input fields
                        // Sets the HTML5 min/max attributes for client-side validation
                        // Supports both standard number inputs and Formidable Forms number fields
                        // (Formidable uses type="number" by default, or type="text" with .frm_field_number class when custom formatting is enabled)
                        if ($field.is('input[type="number"], input[type="text"][class*="frm_field_number"]')) {
                            $field.attr('min', minYear);
                            $field.attr('max', maxYear);
                        }
                        
                        // Apply limits to dropdown select fields
                        // Removes options that fall outside the valid year range
                        if ($field.is('select')) {
                            $field.find('option').each(function() {
                                var optionYear = parseInt($(this).attr('value'), 10);
                                // Remove option if it's a valid year but outside our boundaries
                                if (!isNaN(optionYear) && (optionYear < minYear || optionYear > maxYear)) {
                                    $(this).remove();
                                }
                            });
                        }
                    });

                },

                /**
                 * Initialize year field limits with support for dynamically loaded forms
                 * 
                 * This function ensures year field restrictions are applied both:
                 * 1. On initial page load for existing fields
                 * 2. Automatically when new forms are dynamically added to the DOM
                 * 
                 * This is essential for forms loaded via AJAX, Formidable Forms, or any other
                 * dynamic form loading system that adds content after DOMContentLoaded event.
                 * 
                 * Uses MutationObserver API to watch for DOM changes and automatically apply
                 * year field restrictions to newly added fields with .min-age-* classes.
                 * 
                 * Called automatically from components.forms.init()
                 */
                init_year_field_limits: function () {
                    var _self = this;
                    
                    // Apply year field restrictions to all existing fields on initial page load
                    _self.limit_year_field();
                    
                    // Set up MutationObserver to watch for dynamically added forms
                    // This handles cases like Formidable Forms or other AJAX-loaded forms
                    if (typeof MutationObserver !== 'undefined') {
                        var observer = new MutationObserver(function(mutations) {
                            // Process each DOM mutation (addition/removal of nodes)
                            mutations.forEach(function(mutation) {
                                // Only process if nodes were added to the DOM
                                if (mutation.addedNodes.length) {
                                    // Check each added node
                                    $(mutation.addedNodes).each(function() {
                                        // Case 1: The added node itself has a min-age class
                                        // Example: <input class="min-age-18"> is directly inserted
                                        if ($(this).is('[class*="min-age-"]')) {
                                            _self.limit_year_field($(this));
                                        }
                                        // Case 2: The added node contains child elements with min-age classes
                                        // Example: A <form> is inserted that contains <input class="min-age-18">
                                        $(this).find('[class*="min-age-"]').each(function() {
                                            _self.limit_year_field($(this));
                                        });
                                    });
                                }
                            });
                        });
                        
                        // Start observing the entire document body for changes
                        // childList: true - Watch for additions/removals of child nodes
                        // subtree: true - Watch all descendants, not just direct children
                        observer.observe(document.body, {
                            childList: true,
                            subtree: true
                        });
                    }
                }

            },

            geo: {

                /**
                 * Get User geolocation 
                 */
                get_user_geolocation: function () {

                    // Try HTML5 geolocation.
                    if (navigator.geolocation) {
                        navigator.geolocation.getCurrentPosition(
                            (position) => {
                                const pos = {
                                    lat: position.coords.latitude,
                                    lng: position.coords.longitude,
                                };

                                return pos;
                            }
                        );
                    }

                    return false;

                },
            },

            gtm: {

                /**
                 *  Google Tag Manager
                 */

                // dataLayerUserID: function () {

                //     window.dataLayer = window.dataLayer || [];

                //     // Ensure GTM is load in initiated
                //     if (typeof window.dataLayer !== 'undefined') {
                //         window.dataLayer.push({
                //             'user_id': global.wp_uid,
                //         });

                //         // console.log(window.dataLayer);
                //     }

                // },

                dataLayerGAEventTracking: function (category, action, label, value) {

                    window.dataLayer = window.dataLayer || [];

                    // Ensure GTM is load in initiated
                    if (typeof window.dataLayer !== 'undefined') {
                        // dataLayer.push({'eventCategory': 'Find A Workout - View Provider Details', 'eventAction' : 'Click', , 'eventLabel': 'Club: TennisWorld | Coach: Matt Ebden' });
                        window.dataLayer.push({
                            'event': 'ga_event',
                            'eventCategory': category,
                            'eventAction': action,
                            'eventLabel': label,
                            'eventValue': value
                        });


                        // console.log({
                        //     'event': 'ga_event',
                        //     'eventCategory': category,
                        //     'eventAction': action,
                        //     'eventLabel': label,
                        //     'eventValue': value
                        // });

                    }


                },

            },

            // Create modal for use for confirmation or error
            bs_modal: {

                success: function (title = "", content = '', classname = '') {

                    // if(content == "" ) return false;

                    title = title != "" ? title : "Form successfully submitted!";
                    classname = "modal-dialog-centered" + (classname != "" ? " " + classname : "");

                    let modal = $('#bs_modal_success.modal');
                    // Re-use existing if available
                    if (modal.length > 0) {

                        // Reset and add classes
                        $(modal).find('.modal-dialog').removeClass().addClass('modal-dialog ' + classname);
                        $(modal).find('.modal-title > #m-title').html(title);
                        $(modal).find('.modal-body').html(content);
                        $(modal).modal('show');

                    } else {

                        let modal = $('\
                            <div id="bs_modal_success" class="modal fade show" tabindex="-1" aria-hidden="true">\
                                <div class="modal-dialog '+ classname + '">\
                                    <div class="modal-content">\
                                        '+ (title != "" ? '<div class="modal-header bg-dark">\
                                            <h5 class="modal-title text-white"><strong id="m-title">'+ title + '</strong></h5>\
                                            <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">\
                                                <span aria-hidden="true">&times;</span>\
                                            </button>\
                                        </div>' : '<div class="modal-header">\
                                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">\
                                                <span aria-hidden="true">&times;</span>\
                                            </button>\
                                        </div>') + '\
                                        <div class="modal-body">\
                                            '+ content + ' \
                                        </div> \
                                        <!--<div class="modal-footer"> \
                                            <button type="button" class="btn btn-primary mx-auto" data-dismiss="modal">Close</button> \
                                        </div>--> \
                                    </div> \
                                </div> \
                            </div> \
                        ');

                        $("body").append(modal);
                        $(modal).modal('show');
                    }

                },
                failed: function (title = "", content = '', classname = '') {

                    if (content == "") return false;

                    title = title != "" ? title : "Failed";
                    classname = "modal-dialog-centered" + (classname != "" ? " " + classname : "");

                    let modal = $('#bs_modal_failed.modal');

                    // Re-use existing if available
                    if (modal.length > 0) {

                        // Reset and add classes
                        $(modal).find('.modal-dialog').removeClass().addClass('modal-dialog ' + classname);
                        $(modal).find('.modal-title > #m-title').html(title);
                        $(modal).find('.modal-body').html(content);
                        $(modal).modal('show');

                    } else {

                        let modal = $('\
                            <div id="bs_modal_failed" class="modal fade show" tabindex="-1" aria-hidden="true">\
                                <div class="modal-dialog '+ classname + '">\
                                    <div class="modal-content">\
                                        '+ (title != "" ? '<div class="modal-header bg-dark">\
                                            <h5 class="modal-title text-white"><strong id="m-title">'+ title + '</strong></h5>\
                                            <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">\
                                                <span aria-hidden="true">&times;</span>\
                                            </button>\
                                        </div>' : '<div class="modal-header">\
                                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">\
                                                <span aria-hidden="true">&times;</span>\
                                            </button>\
                                        </div>') + '\
                                        <div class="modal-body">\
                                            '+ content + ' \
                                        </div> \
                                        <!--<div class="modal-footer"> \
                                            <button type="button" class="btn btn-primary mx-auto" data-dismiss="modal">Close</button> \
                                        </div>-->\
                                    </div> \
                                </div> \
                            </div> \
                        ');

                        $("body").append(modal);
                        $(modal).modal('show');
                    }

                },
                show: function (title = "", content = '', classname = '') {

                    if (content == "") return false;

                    title = title != "" ? title : "";
                    classname = "modal-dialog-centered" + (classname != "" ? " " + classname : "");

                    let modal = $('#bs_modal_show.modal');

                    // Re-use existing if available
                    if ($(modal).length > 0) {

                        // Reset and add classes
                        $(modal).find('.modal-dialog').removeClass().addClass('modal-dialog ' + classname);
                        $(modal).find('.modal-title > #m-title').html(title);
                        $(modal).find('.modal-body').html(content);
                        $(modal).modal('show');

                    } else {

                        let modal = $('\
                            <div id="bs_modal_show" class="modal fade show" tabindex="-1" aria-hidden="true">\
                                <div class="modal-dialog '+ classname + '">\
                                    <div class="modal-content">\
                                        '+ (title != "" ? '<div class="modal-header bg-dark">\
                                            <h5 class="modal-title text-white"><strong id="m-title">'+ title + '</strong></h5>\
                                            <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">\
                                                <span aria-hidden="true">&times;</span>\
                                            </button>\
                                        </div>' : '<div class="modal-header">\
                                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">\
                                                <span aria-hidden="true">&times;</span>\
                                            </button>\
                                        </div>') + '\
                                        <div class="modal-body">\
                                            '+ content + ' \
                                        </div> \
                                        <!--<div class="modal-footer"> \
                                            <button type="button" class="btn btn-primary mx-auto" data-dismiss="modal">Close</button> \
                                        </div>--> \
                                    </div> \
                                </div> \
                            </div> \
                        ');

                        $("body").append(modal);
                        $(modal).modal('show');

                    }

                },
                dialog: function (title = "", content = '', classname = '') { // NO close function

                    if (content == "") return false;

                    title = title != "" ? title : "";
                    classname = "modal-dialog-centered" + (classname != "" ? " " + classname : "");

                    let modal = $('#bs_modal_dialog.modal');

                    // Re-use existing if available
                    if (modal.length > 0) {

                        // Reset and add classes
                        $(modal).find('.modal-dialog').removeClass().addClass('modal-dialog ' + classname);
                        $(modal).find('.modal-title > #m-title').html(title);
                        $(modal).find('.modal-body').html(content);
                        $(modal).modal('show');

                    } else {

                        modal = $('\
                             <div id="bs_modal_dialog" class="modal fade show" tabindex="-1" aria-hidden="true" data-backdrop="static" data-keyboard="false">\
                                <div class="modal-dialog '+ classname + '">\
                                    <div class="modal-content">\
                                        '+ (title != "" ? '<div class="modal-header bg-dark">\
                                            <h5 class="modal-title text-white"><strong id="m-title">'+ title + '</strong></h5>\
                                        </div>' : '') + '\
                                        <div class="modal-body">\
                                            '+ content + ' \
                                        </div> \
                                    </div> \
                                </div> \
                            </div> \
                        ');

                        $("body").append(modal);
                        $(modal).modal('show');
                    }

                },
            },

            // Related custom JS function for LearnDash related 
            learndash: {

                // Default Bootstrap form validation
                init: function () {

                    _self = this;

                    if ($('body').hasClass('learndash-cpt')) {

                        // User bookmarks
                        _self.bookmark.init();

                        // Disable mark complete form/button if there's a quiz block attached to the page every click
                        _self.disable_paging_next_btn();

                        // Show Quiz after LD JS has been loaded and initialised. This is to avoid scrollTo quiz auto by LD plugin
                        // Force the quiz element to be at the top of the page by default so pages will instead scroll to the top
                        // @link includes/lib/wp-pro-quiz/js/wpProQuiz_front.min.js
                        _self.ldQuizLoaded()

                        _self.show_lock_popup();

                        // _self.show_expert_bio();

                        // _self.timeline_result_build_chart();

                        // if ($("body").hasClass('blog-id-4')) { // Paramedics specific content
                        //     // K10 Survey result calculation
                        //     _self.k10Quiz_calculation();
                        // }


                        // Add is-selected class for inputs already checked on load (per quiz root).
                        setTimeout(function () {
                            $('.wpProQuiz_content').each(function () {
                                _self.applySelectedState($(this));
                            });
                        }, 50);

                        // Delegate radio/checkbox change → is-selected + tips sync.
                        _self.bindQuizSelection();

                        // Tips collapse panels (idempotent; also hooks its own event listeners).
                        _self.questionTips.init();

                    }

                    // if ($('body').hasClass('page-reflections-activities') || $('body').hasClass('page-reflections-journal') || $('body').hasClass('page-bookmark')) {

                    //     // Toolbox page  
                    //     _self.show_lock_popup();

                    // }

                },

                //Apply selected state (initial load)
                applySelectedState: function (context) {
                    $(context)
                        .find("li.wpProQuiz_listItem[data-type='single'], li.wpProQuiz_listItem[data-type='multiple'], li.wpProQuiz_listItem[data-type='assessment_answer']")
                        .each(function () {

                            const $question = $(this);

                            // 1. ALWAYS reset first (critical fix)
                            $question.find("label").removeClass("is-selected");

                            // 2. Apply only current checked state
                            $question.find("input.wpProQuiz_questionInput").each(function () {

                                if ($(this).is(":checked")) {
                                    $(this).closest("label").addClass("is-selected");
                                }

                            });

                        });
                },

                //Handle user interaction
                bindQuizSelection: function () {
                    $(document).on(
                        "change",
                        "li.wpProQuiz_listItem[data-type='single'] input.wpProQuiz_questionInput, \
                        li.wpProQuiz_listItem[data-type='multiple'] input.wpProQuiz_questionInput, \
                        li.wpProQuiz_listItem[data-type='assessment_answer'] input.wpProQuiz_questionInput",
                        function () {

                            const $question = $(this).closest("li.wpProQuiz_listItem");
                            const type = $question.data("type");

                            // Single (clear all first)
                            if (type === "single") {
                                $question.find("label").removeClass("is-selected");
                                $(this).closest("label").addClass("is-selected");
                                return;
                            }

                            //Multiple & Assessment answer (toggle)
                            $(this).closest("label").toggleClass("is-selected", $(this).is(":checked"));
                        }
                    );
                },

                /* =====================================================================
                 * questionTips
                 * Reads [ld_answer type="tips"] JSON payloads injected inside answer
                 * labels by the PHP shortcode and injects a Bootstrap 4.6 Collapse panel
                 * as the last item in .wpProQuiz_questionList. The panel is shown when
                 * the matching answer is selected (including saved-progress restore) and
                 * hidden when no answer with tips is selected.
                 * ===================================================================== */
                questionTips: {

                    _tipsUidCounter: 0,

                    // Bootstrap 4.6 alert contextual variants (for css= attribute swapping).
                    _alertVariants: [
                        'alert-primary', 'alert-secondary', 'alert-success', 'alert-danger',
                        'alert-warning', 'alert-info', 'alert-light', 'alert-dark'
                    ],

                    /**
                     * Keep alert-info unless another alert-* variant is on the panel.
                     */
                    syncAlertInfoClass: function ($body) {
                        var hasOtherVariant = false;
                        var variants = this._alertVariants;
                        for (var i = 0; i < variants.length; i++) {
                            if (variants[i] !== 'alert-info' && $body.hasClass(variants[i])) {
                                hasOtherVariant = true;
                                break;
                            }
                        }
                        $body.toggleClass('alert-info', !hasOtherVariant);
                    },

                    /**
                     * Call once on page load. Registers all recurring event hooks;
                     * the per-quiz scan (scanAll) is idempotent.
                     */
                    _pollId: null,

                    /**
                     * Start (or restart) a 6-second polling cycle that keeps calling
                     * refreshAll() until saved-progress restoration is detected.
                     * Safe to call multiple times — clears any running cycle first.
                     */
                    startPolling: function () {
                        var _tips = this;
                        if (_tips._pollId) {
                            clearInterval(_tips._pollId);
                            _tips._pollId = null;
                        }
                        var pollCount = 0;
                        var maxPolls  = 60; // 60 × 100 ms = 6 s
                        _tips._pollId = setInterval(function () {
                            pollCount++;
                            _tips.refreshAll();
                            if (pollCount >= maxPolls) {
                                clearInterval(_tips._pollId);
                                _tips._pollId = null;
                            }
                        }, 100);
                    },

                    init: function () {

                        var _tips = this;

                        // Initial scan + polling cycle so LD's first DOM setup is caught.
                        setTimeout(function () { _tips.scanAll(); }, 100);
                        _tips.startPolling();

                        // When a quiz becomes visible (enableShowQuiz fires this), scan for
                        // new sources and restart polling so saved-progress restores are caught.
                        $(document).on('learndash-quiz-loaded', function () {
                            _tips.scanAll();
                            _tips.startPolling();
                        });

                        // Re-scan on ProQuiz init and after every answer change (restore path).
                        $(document).on('learndash-quiz-init questionSolved', '.wpProQuiz_content', function () {
                            _tips.scanAll();
                            // Small delay so LD has finished applying :checked state.
                            setTimeout(function () { _tips.refreshAll(); }, 50);
                        });

                        // Delegated change handler for every quiz input → refresh visibility.
                        $(document).on(
                            'change',
                            '.wpProQuiz_questionList input.wpProQuiz_questionInput',
                            function () {
                                var $list = $(this).closest('.wpProQuiz_questionList');
                                _tips.refreshList($list);
                            }
                        );

                        // For converted questions (radio→dropdown): sync on dropdown change.
                        $(document).on(
                            'change',
                            '.wpProQuiz_content select[name$="_dropdown"]',
                            function () {
                                // The hidden radio change fires via the dropdown handler, but
                                // we also directly refresh the converted question's tips.
                                var $listItem = $(this).closest('li.wpProQuiz_listItem, div.wpProQuiz_listItem');
                                if ($listItem.length) {
                                    var $list = $listItem.closest('.wpProQuiz_list');
                                    _tips.refreshListByParent($list);
                                }
                            }
                        );

                    },

                    /**
                     * Scan every visible .wpProQuiz_questionList and, for those that have
                     * tips payloads, build and inject the collapse panel (once per list).
                     */
                    scanAll: function () {
                        var _tips = this;
                        $('.wpProQuiz_questionList').each(function () {
                            _tips.scanList($(this));
                        });
                    },

                    /**
                     * For a given .wpProQuiz_questionList:
                     *  - extract payload(s) from answer labels
                     *  - inject collapse panel as last child (idempotent)
                     *  - update visibility to match current selection
                     */
                    scanList: function ($list) {

                        if ($list.attr('data-ld-answer-tips-init')) {
                            return;
                        }

                        var _tips    = this;
                        var payloads = {}; // keyed by input value (or data-pos fallback)

                        $list.find('.wpProQuiz_questionListItem').each(function () {
                            var $item   = $(this);
                            var $source = $item.find('.ld-answer-tips__source').first();
                            if ($source.length === 0) {
                                return;
                            }

                            var raw     = $source.attr('data-ld-tips') || '';
                            var payload = null;
                            try { payload = JSON.parse(raw); } catch (e) { return; }
                            if (!payload || (!payload.title && !payload.body)) {
                                return;
                            }

                            // Determine the key: the input value, or data-pos as fallback.
                            var $input = $item.find('input.wpProQuiz_questionInput').first();
                            var key    = $input.length ? $input.val() : $item.data('pos');
                            if (key === undefined || key === null || key === '') {
                                key = $item.index();
                            }

                            payloads[String(key)] = payload;

                            // Remove source from label so it doesn't appear in the pill text.
                            $source.remove();
                        });

                        if (Object.keys(payloads).length === 0) {
                            return;
                        }

                        // Build the panel and append it as the last list item.
                        var uid  = 'ld-qt-' + (++_tips._tipsUidCounter);
                        var type = $list.data('type') || '';

                        var $wrapper = $(
                            '<div class="wpProQuiz_questionListItem ld-answer-tips__row w-100 d-none">' +
                                '<button type="button" ' +
                                        'class="btn btn-link ld-answer-tips__toggle collapsed sr-only" ' +
                                        'data-toggle="collapse" ' +
                                        'data-target="#' + uid + '" ' +
                                        'aria-expanded="false" ' +
                                        'aria-controls="' + uid + '">' +
                                    '<span class="ld-answer-tips__toggle-label"></span>' +
                                '</button>' +
                                '<div id="' + uid + '" class="collapse ld-answer-tips__panel">' +
                                    '<div class="alert alert-info ld-answer-tips__body" role="alert">' +
                                        '<h4 class="alert-heading ld-answer-tips__heading d-none"></h4>' +
                                        '<div class="ld-answer-tips__content"></div>' +
                                    '</div>' +
                                '</div>' +
                            '</div>'
                        );

                        // Store payload map on element for refreshList.
                        $wrapper.data('ld-tips-payloads', payloads);
                        $wrapper.data('ld-tips-type', type);

                        $list.append($wrapper);
                        // Use attr() so the DOM attribute selector in refreshAll() works.
                        $list.attr('data-ld-answer-tips-init', 'true');
                        $list.data('ld-tips-panel-id', uid);

                        _tips.refreshList($list);
                    },

                    /**
                     * Update the tips panel for a single .wpProQuiz_questionList.
                     */
                    refreshList: function ($list) {

                        if (!$list.attr('data-ld-answer-tips-init')) {
                            return;
                        }

                        var _tips    = this;
                        var $wrapper  = $list.find('.ld-answer-tips__row').first();
                        if ($wrapper.length === 0) {
                            return;
                        }

                        var payloads = $wrapper.data('ld-tips-payloads') || {};
                        var type     = $wrapper.data('ld-tips-type') || '';
                        var payload  = null;

                        // Find the currently selected answer that has tips.
                        if (type === 'single' || type === 'assessment_answer') {
                            // Single: first label with is-selected that maps to a payload.
                            $list.find('.wpProQuiz_questionListItem').each(function () {
                                if (payload) return false;
                                var $item  = $(this);
                                var $input = $item.find('input.wpProQuiz_questionInput').first();
                                var key    = $input.length ? String($input.val()) : String($item.data('pos'));
                                if (payloads[key] && ($item.find('label').hasClass('is-selected') || $input.is(':checked'))) {
                                    payload = payloads[key];
                                }
                            });
                        } else if (type === 'multiple') {
                            // Multiple: first checked answer that has tips.
                            $list.find('.wpProQuiz_questionListItem').each(function () {
                                if (payload) return false;
                                var $item  = $(this);
                                var $input = $item.find('input.wpProQuiz_questionInput').first();
                                var key    = $input.length ? String($input.val()) : String($item.data('pos'));
                                if (payloads[key] && $input.is(':checked')) {
                                    payload = payloads[key];
                                }
                            });
                        }

                        var $toggle  = $wrapper.find('.ld-answer-tips__toggle');
                        var $label   = $wrapper.find('.ld-answer-tips__toggle-label');
                        var $panel   = $wrapper.find('.ld-answer-tips__panel');
                        var $body    = $wrapper.find('.ld-answer-tips__body');
                        var $heading = $body.find('.ld-answer-tips__heading');
                        var $content = $body.find('.ld-answer-tips__content');

                        // Swap css classes on the alert body element whenever the active payload changes.
                        var prevCss = $body.data('ld-tips-applied-css') || '';
                        var nextCss = (payload && payload.css) ? payload.css : '';
                        if (prevCss !== nextCss) {
                            if (prevCss) { $body.removeClass(prevCss); }
                            if (nextCss) { $body.addClass(nextCss); }
                            $body.data('ld-tips-applied-css', nextCss);
                        }
                        _tips.syncAlertInfoClass($body);

                        if (payload) {
                            // sr-only toggle button label (accessible name).
                            $label.text(payload.title || 'Tips');

                            // Alert heading — only when title= was explicitly set in the shortcode.
                            if (payload.show_title && payload.title) {
                                $heading.text(payload.title).removeClass('d-none');
                            } else {
                                $heading.text('').addClass('d-none');
                            }

                            $content.html(payload.body || '');
                            $wrapper.removeClass('d-none');

                            // Re-open the panel if it was showing for a prior selection;
                            // if the panel was already open keep it open with new content.
                            if ($panel.hasClass('show')) {
                                // Content updated in place, Bootstrap handles the rest.
                            } else {
                                // Auto-expand when a selection with tips is made.
                                $panel.collapse('show');
                                $toggle.attr('aria-expanded', 'true').removeClass('collapsed');
                            }
                        } else {
                            // No matching selection → hide the entire row.
                            $heading.text('').addClass('d-none');
                            $content.html('');
                            $panel.collapse('hide');
                            $toggle.attr('aria-expanded', 'false').addClass('collapsed');
                            $wrapper.addClass('d-none');
                        }
                    },

                    /**
                     * Refresh all initialised question lists on the page.
                     */
                    refreshAll: function () {
                        var _tips = this;
                        $('.wpProQuiz_questionList[data-ld-answer-tips-init]').each(function () {
                            _tips.refreshList($(this));
                        });
                    },

                    /**
                     * Refresh tips for all question lists inside a given parent container.
                     * Used when the converted-question parent is the anchor, not the list.
                     */
                    refreshListByParent: function ($parent) {
                        var _tips = this;
                        $parent.find('.wpProQuiz_questionList').each(function () {
                            _tips.refreshList($(this));
                        });
                    }

                },

                /* =====================================================================
                 * quizConditionalQuestions
                 * Hides "source" LearnDash questions on load and shows them only when
                 * the single "target" (single-choice) question on the same quiz has a
                 * non-empty answer. When a source is re-hidden its input is reset to
                 * blank so stale data cannot be submitted.
                 *
                 * Rules are configured in the ACF repeater quiz_conditional_questions on
                 * the Survey block and bootstrapped per-quiz via a wp_footer inline script
                 * in block-learndash-quiz.php (priority 1000, after conversions at 999).
                 *
                 * Fail-open: if the target is absent from the quiz DOM the source is shown.
                 * ===================================================================== */
                quizConditionalQuestions: {

                    /**
                     * Locate the li.wpProQuiz_listItem for a given LearnDash pro question ID.
                     * Primary: .wpProQuiz_questionList[data-question_id] → closest listItem.
                     * Fallback: parse data-question-meta JSON on each li.wpProQuiz_listItem.
                     *
                     * @param  {jQuery} $quiz         Quiz wrapper.
                     * @param  {number} questionProId
                     * @return {jQuery}
                     */
                    findListItem: function ($quiz, questionProId) {
                        var $qList = $quiz.find('.wpProQuiz_questionList[data-question_id="' + questionProId + '"]');
                        if ($qList.length) {
                            var $li = $qList.closest('li.wpProQuiz_listItem');
                            if ($li.length) return $li;
                        }

                        var $found = $();
                        $quiz.find('li.wpProQuiz_listItem').each(function () {
                            var raw = $(this).attr('data-question-meta');
                            if (!raw) return;
                            try {
                                var meta = JSON.parse(raw);
                                if (parseInt(meta.question_pro_id, 10) === questionProId) {
                                    $found = $(this);
                                    return false;
                                }
                            } catch (e) { /* malformed JSON — skip */ }
                        });
                        return $found;
                    },

                    /**
                     * Determine whether a question list item has a non-empty user answer.
                     * Covers all question types and custom UI conversions.
                     *
                     * @param  {jQuery} $listItem  li.wpProQuiz_listItem
                     * @return {boolean}
                     */
                    questionHasValue: function ($listItem) {
                        // Custom: radio-to-dropdown conversion
                        var $dropdown = $listItem.find('select[name$="_dropdown"]');
                        if ($dropdown.length) {
                            var dVal = $dropdown.val();
                            return dVal !== null && dVal !== '' && dVal !== undefined;
                        }

                        // Custom: radio-to-range conversion (always has a numeric position)
                        if ($listItem.find('.ld-radio-range-wrapper').length) {
                            return $listItem.find('.ld-radio-range-wrapper input[type="range"]').length > 0;
                        }

                        var type = $listItem.data('type') || '';

                        if (type === 'single' || type === 'multiple' || type === 'assessment_answer') {
                            return $listItem.find('input.wpProQuiz_questionInput:checked').length > 0;
                        }

                        if (type === 'free_answer') {
                            return $.trim($listItem.find('input.wpProQuiz_questionInput').val()).length > 0;
                        }

                        if (type === 'cloze_answer') {
                            var allFilled = true;
                            $listItem.find('.wpProQuiz_cloze input').each(function () {
                                if ($.trim($(this).val()).length === 0) {
                                    allFilled = false;
                                    return false;
                                }
                            });
                            return allFilled && $listItem.find('.wpProQuiz_cloze input').length > 0;
                        }

                        if (type === 'essay') {
                            var $textarea = $listItem.find('textarea');
                            if ($textarea.length) return $.trim($textarea.val()).length > 0;
                            return $listItem.find('.uploadEssayFile[value!=""]').length > 0;
                        }

                        if (type === 'sort_answer' || type === 'matrix_sort_answer') {
                            return $listItem.find('.wpProQuiz_questionList_container_student li').length > 0
                                || $listItem.find('.wpProQuiz_questionList li').length > 0;
                        }

                        // LearnDash form fields (.wpProQuiz_forms)
                        var $forms = $listItem.find('.wpProQuiz_forms');
                        if ($forms.length) {
                            var hasValue = false;
                            $forms.find('input:not([type="hidden"]):not([type="radio"]):not([type="checkbox"]), textarea').each(function () {
                                if ($.trim($(this).val()).length > 0) { hasValue = true; return false; }
                            });
                            if (!hasValue) {
                                $forms.find('select:not([name$="_day"]):not([name$="_month"]):not([name$="_year"])').each(function () {
                                    var v = $(this).val();
                                    if (v && v.length > 0) { hasValue = true; return false; }
                                });
                            }
                            if (!hasValue) {
                                hasValue = $forms.find('input[type="radio"]:checked, input[type="checkbox"]:checked').length > 0;
                            }
                            return hasValue;
                        }

                        return false;
                    },

                    /**
                     * Reset a question list item to its blank / default state.
                     * Called whenever a source question is hidden so stale data
                     * is not submitted with the quiz.
                     *
                     * @param {jQuery} $listItem  li.wpProQuiz_listItem
                     */
                    resetQuestion: function ($listItem) {
                        // Custom: radio-to-dropdown — reset select to placeholder, which
                        // triggers the existing bidirectional sync that unchecks the hidden radio.
                        var $dropdown = $listItem.find('select[name$="_dropdown"]');
                        if ($dropdown.length) {
                            $dropdown.val('').trigger('change');
                            return;
                        }

                        // Custom: radio-to-range — reset to minimum value, sync hidden radio.
                        var $rangeWrapper = $listItem.find('.ld-radio-range-wrapper');
                        if ($rangeWrapper.length) {
                            var $rangeInput = $rangeWrapper.find('input[type="range"]');
                            if ($rangeInput.length) {
                                $rangeInput.val($rangeInput.attr('min') || 0).trigger('input').trigger('change');
                            }
                            return;
                        }

                        var type = $listItem.data('type') || '';

                        if (type === 'single' || type === 'assessment_answer') {
                            $listItem.find('input.wpProQuiz_questionInput:checked')
                                .prop('checked', false)
                                .trigger('change');
                            // Remove the is-selected highlight class from labels
                            $listItem.find('label').removeClass('is-selected');
                            return;
                        }

                        if (type === 'multiple') {
                            $listItem.find('input.wpProQuiz_questionInput:checked')
                                .prop('checked', false)
                                .trigger('change');
                            $listItem.find('label').removeClass('is-selected');
                            return;
                        }

                        if (type === 'free_answer') {
                            $listItem.find('input.wpProQuiz_questionInput').val('').trigger('change');
                            return;
                        }

                        if (type === 'cloze_answer') {
                            $listItem.find('.wpProQuiz_cloze input').val('').trigger('change');
                            return;
                        }

                        if (type === 'essay') {
                            $listItem.find('textarea').val('').trigger('change');
                            return;
                        }

                        // LearnDash form fields (.wpProQuiz_forms)
                        var $forms = $listItem.find('.wpProQuiz_forms');
                        if ($forms.length) {
                            $forms.find('input:not([type="hidden"]):not([type="radio"]):not([type="checkbox"]), textarea')
                                .val('').trigger('change');
                            $forms.find('select').prop('selectedIndex', 0).trigger('change');
                            $forms.find('input[type="radio"]:checked, input[type="checkbox"]:checked')
                                .prop('checked', false).trigger('change');
                        }
                    },

                    /**
                     * Return the currently selected answer value for a single-choice
                     * question list item, or null when nothing is selected.
                     * Handles standard radios and radio-to-dropdown conversions.
                     *
                     * @param  {jQuery} $listItem  li.wpProQuiz_listItem
                     * @return {string|null}
                     */
                    getSelectedValue: function ($listItem) {
                        // Custom: radio-to-dropdown conversion
                        var $dropdown = $listItem.find('select[name$="_dropdown"]');
                        if ($dropdown.length) {
                            var dVal = $dropdown.val();
                            return (dVal !== null && dVal !== '' && dVal !== undefined) ? String(dVal) : null;
                        }

                        // Standard radio
                        var $checked = $listItem.find('input.wpProQuiz_questionInput[type="radio"]:checked');
                        if ($checked.length) {
                            return String($checked.val());
                        }

                        return null;
                    },

                    /**
                     * Evaluate every rule for a quiz and show/hide source questions.
                     * A source is hidden when its target condition is not met; reset when re-hidden.
                     *
                     * Rule shape: { source: proId, target: proId, trigger_values: [] }
                     * - trigger_values empty → show source when target has ANY answer
                     * - trigger_values populated → show source only when target's selected
                     *   answer value is in the trigger_values array
                     *
                     * @param {jQuery} $quiz   Quiz wrapper (scoped to this quiz block).
                     * @param {Array}  rules   Array of rule objects.
                     */
                    applyRules: function ($quiz, rules) {
                        // Re-entrancy guard: resetQuestion triggers .trigger('change') which
                        // would call applyRules again before the source is marked as hidden,
                        // causing an infinite loop. Guard exits immediately on re-entry.
                        if ($quiz.data('ld-cq-applying')) { return; }
                        $quiz.data('ld-cq-applying', true);

                        var _cq = this;
                        $.each(rules, function (i, rule) {
                            var $targetItem = _cq.findListItem($quiz, rule.target);

                            // Support both 'sources' (array, new) and 'source' (scalar, legacy).
                            var sources = rule.sources
                                || (rule.source ? [rule.source] : []);

                            if (!sources.length) return;

                            if (!$targetItem.length) {
                                // Target not in DOM — fail-open: show all source questions
                                $.each(sources, function (j, srcId) {
                                    _cq.findListItem($quiz, srcId)
                                        .removeClass('ld-quiz-conditional-hidden').show();
                                });
                                return;
                            }

                            // Compute shouldShow once from the target state, then apply to all sources.
                            var triggerValues = (rule.trigger_values && rule.trigger_values.length)
                                ? rule.trigger_values
                                : [];

                            var shouldShow;
                            if (triggerValues.length) {
                                // Specific-answer mode: trigger_values are the answers that SHOW
                                // the sources. Visible when the selected value is one of the trigger
                                // answers; hidden for any other answer or no answer.
                                //
                                // ACF stores trigger values as 0-indexed keys ("0","1","2") from
                                // get_question_answer_choices(), but LearnDash radio inputs are
                                // 1-indexed ("1","2","3"). Offset each trigger value by +1 to align.
                                var selectedVal = _cq.getSelectedValue($targetItem);
                                var adjustedTriggerValues = $.map(triggerValues, function (v) {
                                    return String(parseInt(v, 10) + 1);
                                });
                                shouldShow = (selectedVal !== null)
                                    && ($.inArray(selectedVal, adjustedTriggerValues) !== -1);
                            } else {
                                // Any-answer mode: show as long as target has any value
                                shouldShow = _cq.questionHasValue($targetItem);
                            }

                            // Apply the same visibility decision to every source question.
                            $.each(sources, function (j, srcId) {
                                var $sourceItem = _cq.findListItem($quiz, srcId);
                                if (!$sourceItem.length) return; // absent from this quiz — skip

                                var wasHidden = $sourceItem.hasClass('ld-quiz-conditional-hidden');

                                if (shouldShow) {
                                    $sourceItem.removeClass('ld-quiz-conditional-hidden').show();
                                } else {
                                    // Mark as hidden FIRST, THEN reset.
                                    // resetQuestion triggers .trigger('change') which bubbles to the
                                    // delegated quiz listener. The re-entrancy guard above prevents
                                    // a second applyRules from running, but we also set the class
                                    // first so a future call after the guard is removed sees the
                                    // correct wasHidden state.
                                    $sourceItem.addClass('ld-quiz-conditional-hidden').hide();
                                    if (!wasHidden) {
                                        _cq.resetQuestion($sourceItem);
                                    }
                                }
                            });
                        });

                        $quiz.data('ld-cq-applying', false);
                    },

                    /**
                     * Initialise conditional visibility for one quiz instance.
                     * Idempotent: marks wrapper with data-ld-conditional-init.
                     *
                     * @param {object} config  { quizPostId, quizProId, rules }
                     */
                    init: function (config) {
                        var _cq    = this;
                        var postId = config.quizPostId;
                        var rules  = config.rules || [];

                        if (!rules.length) return;

                        var $quiz = $('[ld-quiz-post-id="' + postId + '"]');
                        if (!$quiz.length) $quiz = $('.learndash-quiz-' + postId);
                        if (!$quiz.length) return;

                        // Idempotency guard — prevents duplicate event listener registration
                        if (!$quiz.data('ld-conditional-init')) {
                            $quiz.data('ld-conditional-init', true);

                            // Re-evaluate whenever any quiz input changes
                            $quiz.on(
                                'change input',
                                'input, select, textarea',
                                function () { _cq.applyRules($quiz, rules); }
                            );
                        }

                        // Apply immediately (catches saved-progress already in DOM)
                        _cq.applyRules($quiz, rules);
                    }

                },

                // User bookmarks
                bookmark: {

                    elements: $('[role="bookmark"]'),

                    init: function () {
                        var _self = this;

                        if ($(_self.elements).length > 0) {

                            $(_self.elements).on('click', function (e) {

                                var _btn = $(this);

                                // Set activity type if is adding new bookmark or delete
                                let selected_mode = $(this).attr("aria-selected");

                                if (selected_mode == 'true') {
                                    $(this).attr("aria-selected", "false");
                                    // alert('1: true | ' +  $(this).attr('aria-selected') ) ;
                                } else {
                                    $(this).attr("aria-selected", "true");
                                    // alert('2: false | ' +  $(this).attr('aria-selected') ) ;
                                }

                                // Get WP post id (LearnDash Course)
                                const cid = $(this).attr('cid');
                                const ctitle = $(this).attr('ctitle');

                                // Get WP post id (LearnDash Lesson/Topic)
                                const pid = $(this).attr('pid');
                                const ptitle = $(this).attr('ptitle');

                                var is_disabled = $(_btn).attr('aria-disabled');

                                if (is_disabled != '' && is_disabled != undefined) {

                                    components.bs_modal.failed('Please wait!', '<p>Please wait while the previous process has been completed!</p>');
                                    e.preventDefault();
                                    return;
                                }

                                if (pid != '' && cid != undefined && pid != '' && pid != undefined) {

                                    $.when(

                                        $.ajax({
                                            url: global.ajax_endpoints.post_user_bookmark,
                                            method: "POST",
                                            dataType: "json",
                                            data: {
                                                pid: pid,
                                                cid: cid,
                                                mode: (selected_mode == "true" ? "false" : "true")
                                            },
                                            statusCode: {
                                                404: function () {
                                                    if (global.debug_mode) {
                                                        console.log("Request method not found");
                                                    }
                                                },
                                                406: function () {
                                                    if (global.debug_mode) {
                                                        console.log("Some data missing from your action");
                                                    }
                                                    // Show error if the response was unsuccessful
                                                    components.bs_modal.failed('We\'re unable to update the bookmark on this page', '<p>Please try again later or contact us if the issue persist.</p><p>We apologise for the inconvenience caused.</p>');
                                                },
                                                503: function () {
                                                    if (global.debug_mode) {
                                                        console.log("There was a problem registering bookmark");
                                                    }
                                                    // Show error if the response was unsuccessful
                                                    components.bs_modal.failed('We\'re unable to update the bookmark on this page', '<p>Please try again later or contact us if the issue persist.</p><p>We apologise for the inconvenience caused.</p>');
                                                }
                                            },
                                            beforeSend: function (xhr) {

                                                // Lock
                                                $(_btn).attr('aria-disabled', 'true')

                                                // console.log( global.wp_nonce );
                                                if (global.wp_nonce != undefined && global.wp_nonce != "") {
                                                    xhr.setRequestHeader('X-WP-Nonce', global.wp_nonce);
                                                }

                                            },
                                            complete: function () {

                                                // Unlock
                                                $(_btn).removeAttr('aria-disabled');


                                            },


                                        })

                                    ).then(

                                        function (response, textStatus, jqXHR) {

                                            if (global.debug_mode) {
                                                console.log(response);
                                            }

                                            // Success
                                            if (response.success != undefined && true == response.success) {

                                                // Store user form data and allow reuse for other contacts
                                                if (!!response.data) {
                                                    set_storage(global.storage_names.user_bookmark, response.data.data);
                                                }

                                                // DEBUG RELATED
                                                if (global.debug_mode) {
                                                    // alert('clicked CID: '+ cid+ ' | CTITLE: ' + ctitle + ' | PID: ' + pid + ' | PTITLE: ' + ptitle + ' | MODE: ' + mode);

                                                    console.log(response.data.data);
                                                }

                                                let action = 'update' == response.action ? 'added' : 'deleted';

                                                let bookmarks = response.data.data;
                                                let timestamp = response.data.timestamp;

                                                // Bookmark count
                                                let b_total = bookmarks.length;
                                                b_total = b_total == undefined ? 0 : b_total;

                                                if (b_total >= 30 && action == 'added') {
                                                    $(this).attr('disabled', 'disabled');
                                                }

                                                // Google Analytics Events - Add event with Document title
                                                components.gtm.dataLayerGAEventTracking('Bookmarks', action, $(document).attr('title'));

                                                // Update Bookmark state
                                                // $(element).attr('aria-selected', ( mode == 'false' ? 'false' : 'true' ) );

                                                components.bs_modal.show('Bookmark ' + action, '<p>Your bookmark has been ' + action + '. You have ' + b_total + '/30 bookmark' + (b_total > 0 ? 's' : '') + '</p> <p><a href="' + global.site_url + 'toolbox/bookmarks" class="btn rounded btn-primary d-block">View bookmarks</a></p>');

                                                e.preventDefault();
                                                return;

                                            }

                                            // Revert if selected state error 
                                            if (selected_mode == 'true') {
                                                $(this).attr("aria-selected", "true");
                                            } else {
                                                $(this).attr("aria-selected", "false");
                                            }

                                            // Show error if the response was unsuccessful
                                            components.bs_modal.failed('Bookmark update failed!', '<p>Please try again later or contact us if the issue persist.</p><p>We apologise for the inconvenience caused.</p>');

                                            e.preventDefault();
                                            return;

                                        }

                                    );

                                }


                            });

                        }

                    }
                },

                // Show Quiz after LD JS has been loaded and initialised
                ldQuizLoaded: function () {

                    var _self = this;

                    // $('body:not(.single-sfwd-quiz) .wpProQuiz_content').each(function(){
                    $('.wpProQuiz_content').each(function () {

                        var quizElement = $(this);

                        var startBtn = $(this).find('.wpProQuiz_button[name="startQuiz"]');

                        if (startBtn.length > 0) {

                            // alert( 'Found Button' );
                            var parentElement = $(startBtn).parents('.wpProQuiz_text');
                            if (parentElement.length > 0) {
                                // alert( 'Found Parent' );

                                if (window.MutationObserver != null && window.MutationObserver != undefined) {

                                    var observer = new MutationObserver(function (mutations) {
                                        mutations.forEach(function (mutation) {
                                            if (mutation.attributeName !== 'style') return;
                                            var currentValue = mutation.target.style.display;
                                            if (currentValue == "none") {
                                                // Show Quiz
                                                _self.enableShowQuiz($(quizElement));

                                                // User Email Quiz to themselves
                                                _self.quiz_email_user_progress.init();

                                                // Reformat quiz
                                                // _self.timeline_quizzes_reformat();

                                                //APPLY INITIAL STATE
                                                _self.applySelectedState($(quizElement));

                                                return;

                                            }
                                        });
                                    });

                                    var target = $(parentElement).get(0);

                                    observer.observe(target, {
                                        attributes: true
                                    });


                                } else {
                                    // Enabled immediately if browser doesn't support MutationObserver
                                    _self.enableShowQuiz($(quizElement));

                                    // User Email Quiz to themselves
                                    // _self.quiz_email_user_progress.init();

                                    // Reformat quiz
                                    // _self.timeline_quizzes_reformat();

                                    return;

                                }

                            }
                        }

                    });

                },

                // User Quiz Email progress
                quiz_email_user_progress: {

                    // Being very specific to Suicide Attempt 
                    elements: $('body.blog-id-3.theme-minds-together-programs .quiz-email-responses'),

                    init: function () {

                        const _self = this;

                        if ($(_self.elements).length > 0) {

                            $(_self.elements).each(function () {

                                let ld_quiz = $(this).find('[ld-quiz-post-id]');

                                // Ensure quiz element is found
                                if (ld_quiz.length == 0) return;

                                // Get WP post id (LearnDash Quiz ID)
                                var qid = $(ld_quiz).attr('ld-quiz-post-id');

                                // Ensure quiz element is found
                                if (qid.length == 0) return;

                                // Find the questions within the Quiz element
                                let quizQuestions = $(ld_quiz).find('.wpProQuiz_question');

                                // Block Container heading where quiz is set
                                let quizBlockTitle = $(this).find('.content-block-heading');
                                quizBlockTitle = quizBlockTitle.length > 0 ? (quizBlockTitle.text()).trim() : '';

                                if (quizQuestions.length > 0) {

                                    // Create container element
                                    let rowContainer = $("<div>", {
                                        "class": "d-flex justify-content-center",
                                    });

                                    // Create Email button
                                    let emailBtn = $("<a>", {
                                        id: "emailBtn",
                                        "class": "btn btn-secondary px-5",
                                        "title": "email",
                                        "text": "Email responses"
                                    }).on('click', function (e) {

                                        var _btn = $(this);

                                        // Quit if no quiz ID
                                        if (qid == '' || qid == undefined) {
                                            e.preventDefault();
                                            return;
                                        }

                                        // Back original text
                                        $(_btn).attr('aria-label', $(_btn).text());

                                        // Spinner
                                        $(_btn).html("Please wait &nbsp;&nbsp;<span class='spinner-border spinner-border-sm mr-auto' role='status' aria-hidden='true'></span>");

                                        var is_disabled = $(_btn).attr('aria-disabled');

                                        if (is_disabled != '' && is_disabled != undefined) {

                                            components.bs_modal.failed('Please wait!', '<p>Please wait while the previous process has been completed!</p>');
                                            e.preventDefault();
                                            return;
                                        }

                                        $.when(

                                            $.ajax({
                                                // url: global.ajax_endpoints.post_user_quiz_progress_data, // This only get the raw data
                                                url: global.ajax_endpoints.post_user_email_quiz_responses,
                                                method: "POST",
                                                dataType: "json",
                                                data: {
                                                    'qid': qid,
                                                    'qtitle': quizBlockTitle,
                                                    'title': $(document).attr('title'),
                                                    'url': document.URL,
                                                },
                                                statusCode: {
                                                    404: function () {
                                                        if (global.debug_mode) {
                                                            console.log("Request method not found");
                                                        }
                                                    },
                                                    406: function () {
                                                        if (global.debug_mode) {
                                                            console.log("Some data missing from the submission or no data exists");
                                                        }
                                                        // Show error if the response was unsuccessful
                                                        components.bs_modal.failed('Email failed', '<p>There are no responses or some unknown error has occured. Please try again later or contact us if the issue persist.</p><p>We apologise for the inconvenience caused.</p>');
                                                    },
                                                    503: function () {
                                                        if (global.debug_mode) {
                                                            console.log("There was a problem registering bookmark");
                                                        }
                                                        // Show error if the response was unsuccessful
                                                        components.bs_modal.failed('Email failed', '<p>Please try again later or contact us if the issue persist.</p><p>We apologise for the inconvenience caused.</p>');
                                                    }
                                                },
                                                beforeSend: function (xhr) {

                                                    // Lock
                                                    $(_btn).attr('aria-disabled', 'true')

                                                    // console.log( global.wp_nonce );
                                                    if (global.wp_nonce != undefined && global.wp_nonce != "") {
                                                        xhr.setRequestHeader('X-WP-Nonce', global.wp_nonce);
                                                    }

                                                },
                                                complete: function () {

                                                    // Unlock
                                                    $(_btn).removeAttr('aria-disabled');

                                                    // Restore label
                                                    $(_btn).html($(_btn).attr('aria-label'));

                                                },

                                            })

                                        ).then(

                                            function (response, textStatus, jqXHR) {

                                                // DEBUG RELATED
                                                if (global.debug_mode) {
                                                    console.log(response);
                                                }

                                                // Success
                                                if (response.success != undefined && true == response.success) {

                                                    // let user_email_address = response.data.email;
                                                    let user_email_address = response.email;

                                                    // Google Analytics Events - Add event with Document title
                                                    components.gtm.dataLayerGAEventTracking('Quizzes', 'Email Responses', $(document).attr('title') + (quizBlockTitle != '' ? ' (' + quizBlockTitle + ')' : ''));

                                                    components.bs_modal.show('Email Sent', '<p>Your responses has been sent to <strong>' + user_email_address + '</strong>.</p>');

                                                    // Remove 
                                                    // $(_btn).remove();

                                                    e.preventDefault();
                                                    return;

                                                }

                                                // Show error if the response was unsuccessful
                                                components.bs_modal.failed('We\'re unable email your responses', '<p>Please try again later or contact us if the issue persist.</p><p>We apologise for the inconvenience caused.</p>');

                                                e.preventDefault();
                                                return;

                                            }

                                        );


                                    });

                                    // Inject Container element
                                    $(ld_quiz).find('.wpProQuiz_quiz').append(rowContainer);

                                    // Inject Email button
                                    $(rowContainer).append(emailBtn);


                                }


                            });

                        }


                    },

                    check_form_fields: function (quizQuestions) {

                        const _self = this;

                        // Check existance
                        if (quizQuestions.length > 0) {

                            $(quizQuestions).each(function () {

                                // let q_arr = [
                                //     { 
                                //         'question' : $(this).find(wpProQuiz_question_text).text(), 
                                //         'question' : $(this).find(wpProQuiz_question_text).text(), 
                                //     }
                                // ];

                                let question = $(this).find('.wpProQuiz_question_text').text();
                                let questionResponseField = $(this).find('.wpProQuiz_questionList');

                                if (question.length > 0 && questionResponseField.length > 0) {

                                    // Remove whitespace before and after text
                                    question = question.trim();
                                    let questionResponseFieldType = $(questionResponseField).data('type');

                                    console.log("Type: " + questionResponseFieldType + " | Question: " + question);

                                }

                            });
                        }

                    },

                },

                // Show Quiz after LD JS has been loaded and initialised. This is to avoid scrollTo quiz auto by LD plugin
                // Force the quiz element to be at the top of the page by default so pages will instead scroll to the top
                // @link includes/lib/wp-pro-quiz/js/wpProQuiz_front.min.js
                enableShowQuiz: function (element) {
                    // console.log("display none has just been removed!");
                    $(element).hide();
                    $(element).addClass('loaded');
                    $(element).fadeIn(400);
                    // Notify listeners (e.g. block-learndash-quiz.php inline scripts and questionTips)
                    // that a quiz has started and its DOM is ready for manipulation.
                    $(document).trigger('learndash-quiz-loaded', [$(element)]);
                },

                // Disable next button if there's a quiz block on to the page that needs completing
                disable_paging_next_btn: function () {

                    _self = this;

                    var headerHeight = $("header.sticky-top").length > 0 ? parseInt($("header.sticky-top").css("height")) : 0;

                    var ld_custom_navigation_next_btn = $('[component-ld-custom-navigation-next]');

                    $(ld_custom_navigation_next_btn).on('click', function (e) {

                        var $btn = $(this);

                        // Guard: evaluate each quiz block individually using its own completion requirement mode.
                        var blocked = false;
                        var $blockedBlock = null;
                        var $blockedTargets = null;
                        var blockedMessage = '';

                        $('[ld-quiz-post-id]').each(function () {

                            var $wrapper = $(this);
                            var requirementMode = $wrapper.data('quiz-completion-requirement') || 'learndash';

                            // Skip blocks that never block navigation.
                            if (requirementMode === 'none') {
                                return true; // continue .each
                            }

                            // Scope all checks to the specific #wpProQuiz_{proId} element so that
                            // multiple quiz blocks on the same page are always evaluated independently.
                            var quizProId = parseInt($wrapper.attr('ld-quiz-pro-id'), 10);
                            var $quizRoot = quizProId ? $wrapper.find('#wpProQuiz_' + quizProId) : $wrapper;
                            if ($quizRoot.length === 0) {
                                $quizRoot = $wrapper; // fallback if LD hasn't rendered yet
                            }

                            // A quiz that has been submitted (results panel visible) is always treated as complete.
                            var $results = $quizRoot.find('.wpProQuiz_results');
                            if ($results.length > 0 && $results.is(':visible')) {
                                return true; // continue .each — already submitted
                            }

                            var $section = $wrapper.closest('section[id]');
                            if ($section.length === 0) {
                                $section = $wrapper.closest('.container-fluid');
                            }

                            if (requirementMode === 'learndash') {
                                // Legacy behaviour: only check blocks that carry the quiz-completion-required CSS class
                                // (set from LearnDash's own forcingQuestionSolve setting on the PHP side).
                                if (!$section.hasClass('quiz-completion-required')) {
                                    return true;
                                }
                                if ($results.length > 0 && !$results.is(':visible')) {
                                    blocked = true;
                                    $blockedBlock = $wrapper;
                                    $blockedTargets = _self.quiz_get_field_targets($quizRoot);
                                    blockedMessage = 'Please complete this survey by submitting your response(s) before proceeding.';
                                    return false; // break .each
                                }
                                return true;
                            }

                            // any / all modes: check response state directly from the DOM.
                            var validation = _self.quiz_validate_responses($quizRoot, requirementMode);

                            if (!validation.valid) {
                                blocked = true;
                                $blockedBlock = $wrapper;
                                $blockedTargets = validation.$targets;
                                blockedMessage = requirementMode === 'any'
                                    ? 'Please answer at least one of these question(s) before proceeding.'
                                    : 'Please answer all these required question(s) before proceeding.';
                                return false; // break .each
                            }

                        });

                        if (blocked && $blockedBlock !== null) {

                            var scroll_top = $blockedBlock.offset().top + 24;

                            if (global.breakpoint.index > 1) {
                                scroll_top = scroll_top - headerHeight;
                            } else {
                                scroll_top = scroll_top - headerHeight;
                            }

                            $('html, body').animate({ scrollTop: scroll_top }, 800);
                            _self.flash_quiz_validation_fields($blockedTargets);
                            components.bs_modal.show('Incomplete', '<p>' + blockedMessage + '</p>');
                            e.preventDefault();
                            return;
                        }

                        // Save any in-progress quiz answers to the server before navigating.
                        var href = $btn.attr('href');
                        if (href) {
                            e.preventDefault();
                            _self.save_quiz_progress_before_navigate($btn, href);
                        }

                    });

                    // Back/Previous button: save quiz progress then navigate (validation disabled for now).
                    $('[component-ld-custom-navigation-back]').on('click', function (e) {
                        var $btn = $(this);
                        var href = $btn.attr('href');
                        if (href) {
                            e.preventDefault();
                            _self.save_quiz_progress_before_navigate($btn, href);
                        }
                    });

                },

                /**
                 * Resolve the input-level element(s) to flash for a question or control.
                 *
                 * @param  {jQuery} $context  Question item, form field, select, or wrapper.
                 * @param  {object} options   { type, answered, emptyOnly }
                 * @return {jQuery}
                 */
                quiz_get_validation_highlight_targets: function ($context, options) {

                    options = options || {};
                    var type = options.type || '';
                    var answered = !!options.answered;
                    var $targets = $();

                    if (!$context || !$context.length) {
                        return $targets;
                    }

                    if ($context.is('input, select, textarea')) {
                        return answered ? $() : $context;
                    }

                    if ($context.is('select[name$="_dropdown"]')) {
                        return answered ? $() : $context;
                    }

                    if ($context.hasClass('ld-radio-range-wrapper')) {
                        var $range = $context.find('input[type="range"]');
                        return answered ? $() : ($range.length ? $range : $context);
                    }

                    if ($context.hasClass('wpProQuiz_forms')) {
                        if (answered) {
                            return $();
                        }

                        $context.find('input:not([type="hidden"]):not([type="radio"]):not([type="checkbox"]), textarea, select:not([name$="_day"]):not([name$="_month"]):not([name$="_year"])').each(function () {
                            var $input = $(this);
                            if ($.trim($input.val() || '').length === 0) {
                                $targets = $targets.add($input);
                            }
                        });

                        if ($context.find('input[type="radio"]').length > 0 && $context.find('input[type="radio"]:checked').length === 0) {
                            $targets = $targets.add($context.find('input[type="radio"]'));
                        }

                        if ($context.find('input[type="checkbox"]').length > 0 && $context.find('input[type="checkbox"]:checked').length === 0) {
                            $targets = $targets.add($context.find('input[type="checkbox"]'));
                        }

                        return $targets;
                    }

                    var $questionList = $context.find('.wpProQuiz_questionList').first();
                    if ($questionList.length > 0 && $questionList.is(':hidden')) {
                        return $();
                    }

                    if (type === 'free_answer') {
                        return answered ? $() : $context.find('input.wpProQuiz_questionInput');
                    }

                    if (type === 'cloze_answer') {
                        if (answered) {
                            return $();
                        }
                        $context.find('.wpProQuiz_cloze input').each(function () {
                            if ($.trim($(this).val()).length === 0) {
                                $targets = $targets.add($(this));
                            }
                        });
                        return $targets;
                    }

                    if (type === 'single' || type === 'multiple' || type === 'assessment_answer') {
                        return answered ? $() : $context.find('input.wpProQuiz_questionInput');
                    }

                    return $targets;

                },

                /**
                 * Briefly highlight quiz fields that failed validation.
                 * Applies a single transition in, holds for the duration of four pulses,
                 * then transitions back to the default state.
                 *
                 * @param  {jQuery} $targets  Input, select, or textarea elements to highlight.
                 */
                flash_quiz_validation_fields: function ($targets) {

                    var highlightClass = 'ld-quiz-validation-flash';
                    var pulseDurationMs = 700;
                    var pulseCount = 4;
                    var holdDurationMs = pulseDurationMs * pulseCount;

                    if (!$targets || !$targets.length) {
                        return;
                    }

                    $targets.each(function () {
                        var $el = $(this);
                        var el = $el.get(0);
                        var existingTimer = $el.data('ldQuizValidationFlashTimer');

                        if (existingTimer) {
                            clearTimeout(existingTimer);
                            $el.removeData('ldQuizValidationFlashTimer');
                        }

                        $el.removeClass(highlightClass);

                        if (el) {
                            void el.offsetWidth;
                        }

                        $el.addClass(highlightClass);
                        $el.data('ldQuizValidationFlashTimer', setTimeout(function () {
                            $el.removeClass(highlightClass);
                            $el.removeData('ldQuizValidationFlashTimer');
                        }, holdDurationMs));
                    });

                },

                /**
                 * Collect visible quiz input controls for broad validation feedback
                 * (e.g. LearnDash "submit before proceeding" mode).
                 *
                 * @param  {jQuery} $quizRoot
                 * @return {jQuery}
                 */
                quiz_get_field_targets: function ($quizRoot) {

                    var _self = this;
                    var $targets = $();

                    $quizRoot.find('li.wpProQuiz_listItem:visible').each(function () {
                        var $item = $(this);
                        $targets = $targets.add(_self.quiz_get_validation_highlight_targets($item, {
                            type: $item.data('type'),
                            answered: false
                        }));
                    });

                    $quizRoot.find('select[name$="_dropdown"]:visible').each(function () {
                        $targets = $targets.add($(this));
                    });

                    $quizRoot.find('.ld-radio-range-wrapper:visible').each(function () {
                        $targets = $targets.add(_self.quiz_get_validation_highlight_targets($(this), { answered: false }));
                    });

                    $quizRoot.find('.wpProQuiz_forms:visible').each(function () {
                        $targets = $targets.add(_self.quiz_get_validation_highlight_targets($(this), { answered: false }));
                    });

                    return $targets;

                },

                /**
                 * Inspect a quiz root element and return whether its responses satisfy `mode`,
                 * plus the unanswered field targets when validation fails.
                 *
                 * `$quizRoot` should be the specific `#wpProQuiz_{proId}` element (or the
                 * `[ld-quiz-post-id]` wrapper as a fallback) so that selectors never bleed
                 * into a neighbouring quiz block on the same page.
                 *
                 * @param  {jQuery} $quizRoot
                 * @param  {string} mode  'any' | 'all'
                 * @return {{ valid: boolean, $targets: jQuery }}
                 */
                quiz_validate_responses: function ($quizRoot, mode) {

                    var _self = this;
                    var totalQuestions  = 0;
                    var answeredCount   = 0;
                    var foundAny        = false;
                    var $unanswered     = $();

                    var trackQuestion = function ($highlightTargets, answered) {
                        totalQuestions++;
                        if (answered) {
                            answeredCount++;
                            foundAny = true;
                        } else if ($highlightTargets && $highlightTargets.length) {
                            $unanswered = $unanswered.add($highlightTargets);
                        }
                    };

                    // === LearnDash standard question items ===
                    $quizRoot.find('li.wpProQuiz_listItem:visible').each(function () {

                        var $item = $(this);
                        var type  = $item.data('type');

                        var $questionList = $item.find('.wpProQuiz_questionList').first();
                        if ($questionList.length > 0 && $questionList.is(':hidden')) {
                            return true;
                        }

                        var answered = false;

                        if (type === 'single' || type === 'multiple' || type === 'assessment_answer') {
                            answered = $item.find('input.wpProQuiz_questionInput:checked').length > 0;
                        } else if (type === 'free_answer') {
                            var val = $.trim($item.find('input.wpProQuiz_questionInput').val());
                            answered = val.length > 0;
                        } else if (type === 'cloze_answer') {
                            var allFilled = true;
                            $item.find('.wpProQuiz_cloze input').each(function () {
                                if ($.trim($(this).val()).length === 0) {
                                    allFilled = false;
                                    return false;
                                }
                            });
                            answered = allFilled && $item.find('.wpProQuiz_cloze input').length > 0;
                        } else {
                            return true;
                        }

                        trackQuestion(_self.quiz_get_validation_highlight_targets($item, { type: type, answered: answered }), answered);

                    });

                    // === Custom dropdown replacements (radio-to-dropdown conversion) ===
                    $quizRoot.find('select[name$="_dropdown"]:visible').each(function () {
                        var $select = $(this);
                        var val = $select.val();
                        var answered = val !== null && val !== '' && val !== undefined;
                        trackQuestion(_self.quiz_get_validation_highlight_targets($select, { answered: answered }), answered);
                    });

                    // === Custom range slider replacements (radio-to-range conversion) ===
                    $quizRoot.find('.ld-radio-range-wrapper:visible').each(function () {
                        var $wrapper = $(this);
                        var $rangeInput = $wrapper.find('input[type="range"]');
                        var answered = $rangeInput.length > 0;
                        trackQuestion(_self.quiz_get_validation_highlight_targets($wrapper, { answered: answered }), answered);
                    });

                    // === LearnDash form fields (.wpProQuiz_forms) ===
                    $quizRoot.find('.wpProQuiz_forms:visible').each(function () {
                        var $field = $(this);

                        $field.find('input:not([type="hidden"]):not([type="radio"]):not([type="checkbox"]), textarea').each(function () {
                            var $input = $(this);
                            var val = $.trim($input.val());
                            var answered = val.length > 0;
                            trackQuestion(_self.quiz_get_validation_highlight_targets($input, { answered: answered }), answered);
                        });

                        $field.find('select:not([name$="_day"]):not([name$="_month"]):not([name$="_year"])').each(function () {
                            var $select = $(this);
                            var val = $select.val();
                            var answered = val && val.length > 0;
                            trackQuestion(_self.quiz_get_validation_highlight_targets($select, { answered: answered }), answered);
                        });

                        var $radioGroup = $field.find('input[type="radio"]');
                        if ($radioGroup.length > 0) {
                            var radioAnswered = $radioGroup.filter(':checked').length > 0;
                            trackQuestion(_self.quiz_get_validation_highlight_targets($field, { answered: radioAnswered }), radioAnswered);
                        }

                        var $checkboxGroup = $field.find('input[type="checkbox"]');
                        if ($checkboxGroup.length > 0) {
                            var checkboxAnswered = $checkboxGroup.filter(':checked').length > 0;
                            trackQuestion(_self.quiz_get_validation_highlight_targets($field, { answered: checkboxAnswered }), checkboxAnswered);
                        }
                    });

                    if (totalQuestions === 0) {
                        return { valid: true, $targets: $() };
                    }

                    var valid = mode === 'any' ? foundAny : answeredCount >= totalQuestions;

                    return {
                        valid: valid,
                        $targets: valid ? $() : $unanswered
                    };

                },

                /**
                 * @param  {jQuery} $quizRoot
                 * @param  {string} mode  'any' | 'all'
                 * @return {boolean}
                 */
                quiz_has_responses: function ($quizRoot, mode) {
                    return this.quiz_validate_responses($quizRoot, mode).valid;
                },

                /**
                 * For each active (started, not yet submitted) LearnDash quiz on the page,
                 * flush the current in-progress answers to the server via LD's resume-save
                 * AJAX endpoint, then navigate to `href`. Navigation happens immediately if
                 * no quizzes need saving.
                 *
                 * @param {jQuery} $btn  The Continue button element.
                 * @param {string} href  Destination URL.
                 */
                save_quiz_progress_before_navigate: function ($btn, href) {

                    var SAVE_TIMEOUT_MS = 5000;
                    var pendingCount = 0;
                    var navigated = false;
                    // Unique event namespace per invocation to avoid cross-click contamination.
                    var namespace = '.ldQuizSaveNav' + Date.now();

                    function doNavigate() {
                        if (!navigated) {
                            navigated = true;
                            $(document).off(namespace);
                            window.location.href = href;
                        }
                    }

                    // Intercept LD quiz-resume save requests so we can wait for them to complete.
                    // jQuery fires ajaxSend synchronously inside jQuery.ajax(), so attaching this
                    // before calling prepareSendCookieData() guarantees we see every request.
                    $(document).on('ajaxSend' + namespace, function (e, xhr, settings) {
                        if (
                            settings.data &&
                            typeof settings.data === 'string' &&
                            settings.data.indexOf('wp_pro_quiz_cookie_save_quiz') !== -1
                        ) {
                            pendingCount++;
                            xhr.always(function () {
                                pendingCount--;
                                if (pendingCount <= 0) {
                                    doNavigate();
                                }
                            });
                        }
                    });

                    // Disable the button while saving to prevent double-click navigation.
                    $btn.attr('aria-disabled', 'true').addClass('disabled');

                    // For each quiz on the page that has been shown to the user (theme adds
                    // 'loaded' class via enableShowQuiz when the quiz starts), capture the
                    // current input state and flush to the server.
                    // The 'loaded' class is added AFTER questionTimer.startQuiz() has been
                    // called, so its presence guarantees a valid quiz_started timestamp.
                    $('.wpProQuiz_content.loaded').each(function () {
                        var instance = $(this).data('wpProQuizFront');
                        if (!instance || !instance.methode) return;

                        var $quiz = $(this);

                        // Skip quizzes that have already been submitted (results panel visible).
                        var $results = $quiz.find('.wpProQuiz_results');
                        if ($results.length > 0 && $results.is(':visible')) return;

                        // Skip if there are no question items (quiz may be initialising).
                        var $questions = $quiz.find('li.wpProQuiz_listItem');
                        if ($questions.length === 0) return;

                        try {
                            // Read the current state of every question into LD's resume store.
                            instance.methode.CookieProcessQuestionResponse($questions);
                            // Flush the resume store to the server (no-op if nothing has changed).
                            instance.methode.prepareSendCookieData();
                        } catch (err) {
                            // Catch LD internal errors (e.g. config.json not yet populated).
                        }
                    });

                    // If prepareSendCookieData had nothing to send, pendingCount stays 0.
                    // Allow one event-loop tick then navigate if still idle.
                    setTimeout(function () {
                        if (!navigated && pendingCount === 0) {
                            doNavigate();
                        }
                    }, 150);

                    // Hard failsafe: navigate after timeout even if save stalls.
                    setTimeout(doNavigate, SAVE_TIMEOUT_MS);

                },

                show_lock_popup: function () {
                    _self = this;
                    $(".is-locked").on('click', function (e) {

                        var locked_msg = 'This will unlock once you have completed prior modules.';

                        var access_time_message = $(this).attr('date-until-unlock');
                        if (access_time_message != undefined && access_time_message != '') {
                            // var locked_msg = 'This will unlock once you have completed prior modules and on <strong>' + access_time_message + '</strong>.';
                            var locked_msg = 'This will be available on <strong>' + access_time_message + '</strong>.';
                        }

                        components.bs_modal.show('Please note', '<div class="d-flex align-items-center"><div class="icon-shiled"></div><div><p>' + locked_msg + '</p></div></div>');
                        e.preventDefault();
                        return;
                    })
                },

                // show_expert_bio: function () {
                //     _self = this;
                //     $(".bio-link").on('click', function (e) {
                //         $(this).parents('.expert-item').find('.bio-content').slideToggle();
                //     })
                // },

                // k10Quiz_calculation: function () {
                //     _self = this;
                //     // Change the id here to match the real id on production
                //     var quizResBlock = $('section.quiz-results-only.learndash-quiz-678');
                //     if (quizResBlock && quizResBlock.length > 0) {
                //         // Change the id here to match the real id on production
                //         if (quiz_ld_6_completed_data) {
                //             var formattedJson = JSON.parse(quiz_ld_6_completed_data);
                //             var answerTextArray = [];
                //             // console.log('The formatted JSON array is: ', formattedJson);
                //             if (formattedJson.length == 10) {

                //                 // Extract users answers in an array
                //                 formattedJson.forEach(question => {
                //                     var answerOptions = question.question_options;
                //                     var userAnswer = Array.from(question.answer);
                //                     var selectedAnswerIndex = userAnswer.indexOf(true);
                //                     answerTextArray.push(answerOptions[selectedAnswerIndex]);
                //                 });
                //                 // console.log('The answerTextArray is: ', answerTextArray);

                //                 // Start interate user's answer to calculate score
                //                 var totalScore = 0;
                //                 answerTextArray.forEach(answer => {
                //                     if (answer.trim().toLowerCase() == 'none of the time') {
                //                         totalScore += 1;
                //                     } else if (answer.trim().toLowerCase() == 'a little of the time') {
                //                         totalScore += 2;
                //                     } else if (answer.trim().toLowerCase() == 'some of the time') {
                //                         totalScore += 3;
                //                     } else if (answer.trim().toLowerCase() == 'most of the time') {
                //                         totalScore += 4;
                //                     } else if (answer.trim().toLowerCase() == 'all of the time') {
                //                         totalScore += 5;
                //                     }
                //                 });

                //                 //Start build speed meter
                //                 var contentBlcok = $(quizResBlock).find('div.quiz-results-only-content');
                //                 // console.log('Start build meter');
                //                 $(contentBlcok).append('<div class="meter-holder"><canvas id="k10-quiz-res"></canvas><span></span><span></span><span></span><span></span></div>');
                //                 var opts = {   // High resolution support
                //                     angle: 0,
                //                     pointer: {
                //                         length: 0.3,
                //                     },
                //                     // // static zones
                //                     staticZones: [
                //                         { strokeStyle: "#3BAA34", min: 10, max: 15 },
                //                         { strokeStyle: "#7FD7B2", min: 15, max: 21 },
                //                         { strokeStyle: "#FDCA96", min: 21, max: 29 },
                //                         { strokeStyle: "#FB952E", min: 29, max: 50 },

                //                     ],
                //                     highDpiSupport: true

                //                 };
                //                 var target = document.getElementById('k10-quiz-res');
                //                 var gauge = new Gauge(target).setOptions(opts);
                //                 gauge.maxValue = 50;
                //                 gauge.setMinValue(10);
                //                 gauge.set(totalScore >= 10 ? totalScore : 10);
                //             } else {
                //                 var contentBlcok = $(quizResBlock).find('div.quiz-results-only-content');
                //                 $(contentBlcok).append('<h5>Please complete the k10 quiz to see the result!</h5>');
                //             }



                //         }
                //     }
                // },

                // timeline_quizzes_reformat: function () {

                //     _self = this;

                //     /**
                //      * Defines a variable to store all potential time line activities. 
                //      * If there is a new time line activity to be added to the coruse later, 
                //      * just need to add the id here. Don't need to change any of the code below!!!!!
                //      */
                //     // const potentialQuizzes = ['wpProQuiz_37', 'wpProQuiz_38'];  // put suicide program quiz pro id here
                //     // const potentialParamedicQuizzes = ['wpProQuiz_1', 'wpProQuiz_7']; // put paramedics program quiz pro id here
                //     //Define a variable to store all labels in the tab;

                //     let tabGroupLabels = [];
                //     let selectedQuizProId = null;

                //     $('.quiz-attached.quiz-layout-type--grouped-tabs [ld-quiz-pro-id][data-quiz-meta]').each(function () {

                //         if ($(this).attr('ld-quiz-pro-id') != '' && $(this).attr('ld-quiz-pro-id') != undefined) {

                //             selectedQuizProId = $(this).attr('ld-quiz-pro-id');

                //             // DEBUG RELATED
                //             if (global.debug_mode) {
                //                 console.log(selectedQuizProId);
                //             }

                //             let elQuestionsList = $('.wpProQuiz_content#wpProQuiz_' + selectedQuizProId + ' li.wpProQuiz_listItem');

                //             // Only add tab wwhen this is a timeline activity
                //             if (elQuestionsList.length > 0) {

                //                 // ** Start init tab labels **
                //                 $(elQuestionsList).each(function (index, value) {

                //                     // The title of each question
                //                     var questionTitle = $(value).find('div > p').text();
                //                     // console.log('questionTitle is', questionTitle);
                //                     if (questionTitle) {
                //                         // Extract the content in the braket(i.e. [])
                //                         const regex = /\[.+?\]/g
                //                         const groupCodeArr = questionTitle.match(regex);

                //                         if (groupCodeArr && groupCodeArr.length > 0) {
                //                             //Remove []
                //                             var groupCode = groupCodeArr[0].slice(1, -1);
                //                             var codeArray = groupCode.split(':');
                //                             if (codeArray && codeArray.length == 2) {
                //                                 // Get the group code (i.e. the substr after the column ':')
                //                                 var code = codeArray[codeArray.length - 1];
                //                                 // Add id to each question for further use
                //                                 $(value).attr('id', `${selectedQuizProId}_group_${code.toLowerCase().replace(/\s/g, "")}_${index}`)
                //                                 if (!tabGroupLabels.includes(code)) {
                //                                     // Only add different group code to the array as tab labels
                //                                     tabGroupLabels.push(code);
                //                                 }
                //                             }
                //                         }

                //                     }
                //                 });
                //                 // ** End init tab labels **

                //                 // ** Start init tab content **
                //                 // Only run the code when the quiz has tab labels                  
                //                 if (tabGroupLabels.length > 0) {
                //                     // console.log('The tab labels are', tabGroupLabels);
                //                     // Add tab-content to the div generated by LD
                //                     $('div.wpProQuiz_content#wpProQuiz_' + selectedQuizProId + ' div.wpProQuiz_quiz').addClass("tab-content");
                //                     var tabList = ''
                //                     // Loop all tab labels
                //                     for (i = 0; i < tabGroupLabels.length; i++) {
                //                         var elGroupIdPrefix = `li[id^="${selectedQuizProId}_group_` + tabGroupLabels[i].toLowerCase().replace(/\s/g, "") + '_"]';
                //                         var tempEls = $(elGroupIdPrefix);
                //                         // Remove the "ol" element generated by LD. Otherwise the quetions won't show
                //                         if (tempEls.parent().is("ol")) {
                //                             tempEls.unwrap();
                //                         }

                //                         // Add div required by the bootstrap tab and ol required by LD
                //                         $(tempEls).wrapAll(`<div class="tab-pane" id="group${tabGroupLabels[i].toLowerCase().replace(/\s/g, "")}" role="tabpanel"><ol class="wpProQuiz_list"></ol></div>`)
                //                         tabList += `<a class="list-group-item list-group-item-action" data-toggle="list" href="#group${tabGroupLabels[i].toLowerCase().replace(/\s/g, "")}" role="tab">${tabGroupLabels[i]}</a>`


                //                     }
                //                     // Add the div required by bootstrap
                //                     var htmlCode =
                //                         '<div class="list-group" id="timeLineActivityList" role="tablist">' + tabList + '</div>';

                //                     $('div#wpProQuiz_' + selectedQuizProId + ' > div.wpProQuiz_quiz').before(htmlCode);

                //                     // Select the first el by default
                //                     $('#timeLineActivityList a:first-child').tab('show');
                //                 }
                //                 // ** End init tab content **

                //                 // ** Start remove group code in p tag
                //                 $('div.wpProQuiz_question > div > p').each(function (index, value) {
                //                     var fullTitle = $(value).text();
                //                     var regex = /\[.+?\]/g
                //                     var groupCodeArr = fullTitle.match(regex);
                //                     if (groupCodeArr.length > 0) {
                //                         var groupCodeLength = groupCodeArr[0].length;
                //                         var bodyText = fullTitle.substring(groupCodeLength);
                //                         $(value).text(bodyText)
                //                     }
                //                 })
                //                 // console.log('The console log p tags are: ', ptags);

                //             }

                //         }

                //         return;

                //     });



                //     return;
                // },


                /**
                 * Build and format the line chart using ChartJs
                 * https://www.chartjs.org/docs/latest/
                 */
                // timeline_result_build_chart: function () {

                //     _self = this;

                //     // Set defaults
                //     let timelineResultBlock;
                //     let selectedQuizProId = null;
                //     let quizResultsDataSet1 = null;
                //     let selectedQuizProId2 = null;
                //     let quizResultsDataSet2 = null;

                //     $('.quiz-results-type--timeline [ld-quiz-pro-id][data-quiz-meta], .quiz-results-type--timeline-comparison [ld-quiz-pro-id][data-quiz-meta]').each(function () {

                //         if ($(this).data('quiz-meta') != '' && $(this).data('quiz-meta') != undefined) {

                //             // Get data 
                //             let quiz_meta_ref = $(this).data('quiz-meta');


                //             if (('quiz_pro_id' in quiz_meta_ref) && quiz_meta_ref.quiz_pro_id != '') {

                //                 selectedQuizProId = quiz_meta_ref.quiz_pro_id;
                //                 quizResultsDataSet1 = window['quiz_ld_' + selectedQuizProId + '_completed_data'];
                //                 quizResultsDataSet1 = quizResultsDataSet1 != '' && quizResultsDataSet1 != undefined ? JSON.parse(quizResultsDataSet1) : null;

                //                 // Comparison Quiz selected
                //                 if ('quiz_pro_id_comparison' in quiz_meta_ref) {

                //                     selectedQuizProId2 = quiz_meta_ref.quiz_pro_id_comparison;
                //                     quizResultsDataSet2 = selectedQuizProId2 != '' && selectedQuizProId2 != undefined ? window['quiz_ld_' + selectedQuizProId2 + '_completed_data'] : null;
                //                     quizResultsDataSet2 = quizResultsDataSet2 != '' && quizResultsDataSet2 != undefined ? JSON.parse(quizResultsDataSet2) : null;

                //                 }

                //                 // DEBUG RELATED
                //                 if (global.debug_mode) {

                //                     // console.log(quiz_meta_ref);

                //                     // console.log(selectedQuizProId);
                //                     // console.log(quizResultsDataSet1);

                //                     // console.log(selectedQuizProId2);
                //                     // console.log(quizResultsDataSet2);

                //                 }


                //                 // return;

                //                 // Start init default chart data
                //                 var chartData = [];
                //                 var chartData2 = [];
                //                 var startYear = new Date().getFullYear() - 4;
                //                 for (i = 0; i < 5; i++) {
                //                     for (j = 0; j < 12; j++) {
                //                         var xDate = new Date(startYear + i, j, 1);
                //                         // var xData = (startYear + i) + '-' + (j + 1) + '-1';
                //                         chartData.push({ x: xDate.getTime(), y: 0 });
                //                         if (quizResultsDataSet1 != null && quizResultsDataSet2 != null) {
                //                             chartData2.push({ x: xDate.getTime(), y: 0 });
                //                         }
                //                     }
                //                 }

                //                 // End init default chart data

                //                 if (quizResultsDataSet1.length > 0) {
                //                     for (i = 0; i < quizResultsDataSet1.length; i++) {

                //                         // console.log('Calculate item: ', quizResultsDataSet1[i]);

                //                         var singleJsonObj = quizResultsDataSet1[i];
                //                         var questionTitle = singleJsonObj.question;
                //                         var userAnswers = singleJsonObj.answer;
                //                         if (questionTitle) {
                //                             // Extract the content in the braket(i.e. [])
                //                             const regex = /\[.+?\]/g
                //                             const groupCodeArr = questionTitle.match(regex);

                //                             if (groupCodeArr && groupCodeArr.length > 0) {
                //                                 //Remove []
                //                                 var prefixLength = groupCodeArr[0].length;
                //                                 var questionBody = questionTitle.substring(prefixLength);
                //                                 var groupCode = groupCodeArr[0].slice(1, -1);
                //                                 var codeArray = groupCode.split(':');
                //                                 var code = '';
                //                                 if (codeArray && codeArray.length == 2) {
                //                                     // Get the group code (i.e. the substr after the column ':')
                //                                     code = codeArray[codeArray.length - 1];
                //                                     // console.log('The group code is: ', code);
                //                                 }

                //                                 // Start calculating itemIndex
                //                                 var itemIndex = 0;
                //                                 if (code.toLowerCase().trim() == 'this year') {
                //                                     itemIndex += 48;
                //                                 } else if (code.toLowerCase().trim() == 'last year') {
                //                                     itemIndex += 36;
                //                                 } else if (code.toLowerCase().trim() == '2 years ago') {
                //                                     itemIndex += 24;
                //                                 } else if (code.toLowerCase().trim() == '3 years ago') {
                //                                     itemIndex += 12;
                //                                 } else if (code.toLowerCase().trim() == '4 years ago') {
                //                                     itemIndex += 0;
                //                                 }

                //                                 // console.log('Complete calc index');


                //                                 // Start calculating score (For y axies)
                //                                 var answerScore = singleJsonObj.points - 2;
                //                                 // if (questionBody == 'Over the last couple of years can you please plot the crisis points of the person you care for?') {
                //                                 //     answerScore = 2
                //                                 // } else if (questionBody == 'When were things good for your friend/family member?') {
                //                                 //     answerScore = 1
                //                                 // } else if (questionBody == 'When were things not necessarily easy but calm?') {
                //                                 //     answerScore = -1
                //                                 // } else if (questionBody == 'When were quite tough but not at crisis point?') {
                //                                 //     answerScore = -2
                //                                 // }

                //                                 // console.log('Complete calc Body');

                //                                 // // Start update dataset
                //                                 for (j = 0; j < userAnswers.length; j++) {
                //                                     if (userAnswers[j]) {

                //                                         // console.log('user answers is: ', j);

                //                                         var chartDataValue = chartData[itemIndex + j].y;
                //                                         if (!chartDataValue) {

                //                                             // console.log('Set chart with values', itemIndex + j, answerScore);

                //                                             chartData[itemIndex + j].y = answerScore
                //                                         }
                //                                     }
                //                                 }
                //                             }

                //                         }
                //                     }

                //                     // console.log('The first char data set is: ', chartData);

                //                 }
                //                 if (quizResultsDataSet2 != null && quizResultsDataSet2.length > 0) {
                //                     for (i = 0; i < quizResultsDataSet2.length; i++) {
                //                         var singleJsonObj2 = quizResultsDataSet2[i];
                //                         var questionTitle2 = singleJsonObj2.question;
                //                         var userAnswers2 = singleJsonObj2.answer;
                //                         if (questionTitle2) {
                //                             // Extract the content in the braket(i.e. [])
                //                             const regex = /\[.+?\]/g
                //                             const groupCodeArr = questionTitle2.match(regex);

                //                             if (groupCodeArr && groupCodeArr.length > 0) {
                //                                 //Remove []
                //                                 var prefixLength = groupCodeArr[0].length;
                //                                 // var questionBody = questionTitle.substring(prefixLength);
                //                                 var groupCode = groupCodeArr[0].slice(1, -1);
                //                                 var codeArray = groupCode.split(':');
                //                                 var code = '';
                //                                 if (codeArray && codeArray.length == 2) {
                //                                     // Get the group code (i.e. the substr after the column ':')
                //                                     code = codeArray[codeArray.length - 1];
                //                                 }

                //                                 // Start calculating itemIndex
                //                                 var itemIndex = 0;
                //                                 if (code.toLowerCase().trim() == 'this year') {
                //                                     itemIndex += 48;
                //                                 } else if (code.toLowerCase().trim() == 'last year') {
                //                                     itemIndex += 36;
                //                                 } else if (code.toLowerCase().trim() == '2 years ago') {
                //                                     itemIndex += 24;
                //                                 } else if (code.toLowerCase().trim() == '3 years ago') {
                //                                     itemIndex += 12;
                //                                 } else if (code.toLowerCase().trim() == '4 years ago') {
                //                                     itemIndex += 0;
                //                                 }
                //                                 // Start calculating score (For y axies)
                //                                 var answerScore = singleJsonObj2.points - 2;
                //                                 // // Start update dataset
                //                                 for (j = 0; j < userAnswers2.length; j++) {
                //                                     if (userAnswers2[j]) {

                //                                         // console.log('user answers is: ', j);

                //                                         var chartDataValue = chartData2[itemIndex + j].y;
                //                                         if (!chartDataValue) {

                //                                             // console.log('Set chart with values', itemIndex + j, answerScore);

                //                                             chartData2[itemIndex + j].y = answerScore
                //                                         }
                //                                     }
                //                                 }
                //                             }

                //                         }
                //                     }

                //                     // console.log('The second char data set is: ', chartData2);


                //                 }


                //                 $(this).append(`<div class="timeline-chart-wrapper"><div class="timeline-chart-inner"><canvas id="myChart-${selectedQuizProId}"></canvas></div></div>`);
                //                 const ctx = document.getElementById(`myChart-${selectedQuizProId}`).getContext('2d');
                //                 var chartDataSet = [{
                //                     label: 'Your own journey',
                //                     data: chartData,
                //                     borderColor: 'rgb(60, 16, 83)',
                //                     pointRadius: 0,
                //                 }];
                //                 // if (selectedQuizProId == '38') {
                //                 if (quizResultsDataSet1 != null && quizResultsDataSet2 != null) {
                //                     chartDataSet.push({
                //                         label: 'Journey of the person you support',
                //                         data: chartData2,
                //                         borderColor: 'rgb(0, 175, 102)',
                //                         pointRadius: 0,
                //                     });
                //                 }


                //                 // console.log('The ctx is: ', ctx);


                //                 const myChart = new Chart(ctx, {
                //                     type: 'line',
                //                     data: {
                //                         datasets: chartDataSet
                //                     },
                //                     options: {
                //                         responsive: true,
                //                         scaleShowValues: true,
                //                         plugins: {
                //                             legend: {
                //                                 display: (quizResultsDataSet1 != null && quizResultsDataSet2 != null)
                //                             }
                //                         },
                //                         scales: {
                //                             x: {

                //                                 type: 'time',
                //                                 time: {
                //                                     unit: 'quarter',
                //                                     displayFormats: {
                //                                         quarter: 'MM-YYYY'
                //                                     }
                //                                 },
                //                                 grid: {
                //                                     display: false,
                //                                 },
                //                                 // offsetAfterAutoskip: true,
                //                                 ticks: {
                //                                     display: true,
                //                                     color: 'rgb(0,0,0)',
                //                                     autoSkip: false,
                //                                     // maxRotation: 0,
                //                                     // minRotation: 0
                //                                     callback: function (value, index, ticks) {
                //                                         var currentYear = new Date().getFullYear();
                //                                         if (value == '07-' + currentYear.toString()) {
                //                                             return 'This year';
                //                                         } else if (value == '07-' + (currentYear - 1).toString()) {
                //                                             return 'Last year'
                //                                         } else if (value == '07-' + (currentYear - 2).toString()) {
                //                                             return '2 years ago'
                //                                         } else if (value == '07-' + (currentYear - 3).toString()) {
                //                                             return '3 years ago'
                //                                         } else if (value == '07-' + (currentYear - 4).toString()) {
                //                                             return '4 years ago'
                //                                         } else {
                //                                             return '';
                //                                         }
                //                                     }
                //                                 }
                //                             },
                //                             y: {

                //                                 min: -2.2,
                //                                 max: 2.2,
                //                                 grid: {
                //                                     display: false
                //                                 },
                //                                 beginAtZero: true,
                //                                 ticks: {
                //                                     autoSkip: false,
                //                                     display: true,
                //                                     color: 'rgb(0,0,0)',
                //                                     stepSize: 0.1,
                //                                     callback: function (value, index, ticks) {

                //                                         if (value == 2) {
                //                                             return 'Very easy';
                //                                         } else if (value == 0) {
                //                                             return '';
                //                                         } else if (value == -2) {
                //                                             return 'Very tough';
                //                                         } else {
                //                                             return '';
                //                                         }
                //                                     }
                //                                 }
                //                             }
                //                         },
                //                         elements: {
                //                             line: {
                //                                 tension: 0.5
                //                             }
                //                         }
                //                     }
                //                 });

                //                 // console.log('The content block is: ', contentBlock);
                //                 // $('.quiz-results-only [ld-quiz-pro-id]')

                //             }
                //         }
                //     });



                //     return;


                // }


            },

            // Login Modal - User authentication via AJAX
            loginModal: {
                
            init: function() {
                const _self = this;
                
                // Check for #login hash on page load and hash change
                _self.checkHashAndOpenModal();
                
                // Listen for hash changes
                $(window).on('hashchange', function() {
                    _self.checkHashAndOpenModal();
                });
                
                // Handle modal close event - remove hash from URL
                $('#loginModal').on('hidden.bs.modal', function() {
                    if (window.location.hash === '#login') {
                        // Remove hash without triggering hashchange or page jump
                        history.pushState('', document.title, window.location.pathname + window.location.search);
                    }
                    // Reset to login section when modal closes
                    _self.showLogin();
                });
                
                // Handle clicks on links with #login href
                $(document).on('click', 'a[href="#login"], a[href*="#login"]:not([href*="switch_to_olduser"])', function(e) {
                    e.preventDefault();
                    
                    // Don't show modal if in wp-admin area
                    if ($('body').hasClass('wp-admin')) {
                        return;
                    }

                    
                    // Don't show modal if user is already logged in
                    if ($('body').hasClass('logged-in')) {
                        // Remove #login hash from URL if it gets added
                        if (window.location.hash === '#login') {
                            history.pushState('', document.title, window.location.pathname + window.location.search);
                        }
                        return;
                    }
                    
                    // Capture redirect_url from URL parameters
                    _self.setRedirectUrl();
                    $('#loginModal').modal('show');
                    // Update URL hash
                    if (window.location.hash !== '#login') {
                        window.location.hash = '#login';
                    }
                });
                
                // Toggle between login and forgot password sections
                $('#forgotPasswordLink').on('click', function(e) {
                    e.preventDefault();
                    _self.showForgotPassword();
                });
                
                $('#backToLoginLink').on('click', function(e) {
                    e.preventDefault();
                    _self.showLogin();
                });
                
                // Handle login form submission
                $('#loginForm').on('submit', function(e) {
                    e.preventDefault();
                    _self.submitLogin();
                });
                
                // Handle forgot password form submission
                $('#forgotPasswordForm').on('submit', function(e) {
                    e.preventDefault();
                    _self.submitForgotPassword();
                });
                
                // Heartbeat API - Check login status
                _self.setupHeartbeat();
            },
                
            checkHashAndOpenModal: function() {
                // Don't show modal if in wp-admin area
                if ($('body').hasClass('wp-admin')) {
                    return;
                }
                
                // Don't show modal if user is already logged in
                if ($('body').hasClass('logged-in')) {
                    // Remove #login hash from URL if user is already logged in
                    if (window.location.hash === '#login') {
                        history.pushState('', document.title, window.location.pathname + window.location.search);
                    }
                    return;
                }
                
                var urlParams = new URLSearchParams(window.location.search);
                var hasWflsToken = !!urlParams.get('wfls-email-verification');

                if (window.location.hash === '#login' || hasWflsToken) {
                    // Capture redirect_url and Wordfence verification token before showing modal
                    this.setRedirectUrl();
                    $('#loginModal').modal('show');
                }
            },
                
            isValidRedirectUrl: function(url) {
                if (!url || url.trim() === '') {
                    return true; // Empty is valid (will default to homepage)
                }
                
                try {
                    // Handle relative URLs (always safe)
                    if (url.startsWith('/') && !url.startsWith('//')) {
                        return true;
                    }
                    
                    // Parse and check absolute URLs
                    const redirectUrl = new URL(url, window.location.origin);
                    const currentOrigin = window.location.origin;
                    
                    // Only allow same-origin URLs
                    if (redirectUrl.origin !== currentOrigin) {
                        if (global.debug_mode) {
                            console.warn('Rejected redirect URL (different origin):', url);
                        }
                        return false;
                    }
                    
                    return true;
                } catch (e) {
                    // Invalid URL format
                    if (global.debug_mode) {
                        console.warn('Rejected redirect URL (invalid format):', url, e);
                    }
                    return false;
                }
            },
                
            setRedirectUrl: function() {
                // Get redirect_url from URL parameters
                const urlParams = new URLSearchParams(window.location.search);
                const redirectUrl = urlParams.get('redirect_url') || urlParams.get('redirect_to') || '';
                
                // Validate the redirect URL is same-origin
                if (redirectUrl && !this.isValidRedirectUrl(redirectUrl)) {
                    if (global.debug_mode) {
                        console.warn('Invalid redirect URL blocked:', redirectUrl);
                    }
                    $('#loginRedirect').val(''); // Clear invalid URL
                } else {
                    // Set the hidden field value
                    $('#loginRedirect').val(redirectUrl);
                    
                    if (global.debug_mode && redirectUrl) {
                        console.log('Login modal redirect URL set to:', redirectUrl);
                    }
                }

                // Capture Wordfence email-verification token so it can be forwarded
                // to the REST login endpoint, which injects it into $_REQUEST before wp_signon().
                const wflsToken = urlParams.get('wfls-email-verification') || '';
                $('#loginWflsVerification').val(wflsToken);

                if (global.debug_mode && wflsToken) {
                    console.log('Wordfence verification token captured from URL');
                }
            },
            
            showForgotPassword: function() {
                $('#loginSection').hide();
                $('#forgotPasswordSection').show();
                $('#loginAlert').hide();
                $('#forgotPasswordAlert').hide();
            },
            
            showLogin: function() {
                $('#forgotPasswordSection').hide();
                $('#loginSection').show();
                $('#loginAlert').hide();
                $('#forgotPasswordAlert').hide();
            },
            
            showAlert: function(message, type, isLoginSection) {
                const alertDiv = isLoginSection !== false ? $('#loginAlert') : $('#forgotPasswordAlert');
                alertDiv.removeClass('alert-success alert-danger alert-warning');
                alertDiv.addClass('alert-' + type);
                alertDiv.html(message);
                alertDiv.show();
            },
            
            hideAlert: function() {
                $('#loginAlert').hide();
                $('#forgotPasswordAlert').hide();
            },
                
                getRecaptchaToken: function(action) {
                    return new Promise(function(resolve, reject) {
                        if (typeof grecaptcha !== 'undefined' && global.google_recaptcha) {
                            grecaptcha.ready(function() {
                                grecaptcha.execute(global.google_recaptcha, {action: action}).then(function(token) {
                                    resolve(token);
                                }).catch(function(error) {
                                    reject(error);
                                });
                            });
                        } else {
                            resolve(''); // No recaptcha configured
                        }
                    });
                },
                
            submitLogin: function() {
                const _self = this;
                const form = $('#loginForm');
                const submitBtn = form.find('button[type="submit"]');
                const username = $('#loginEmail').val();
                const password = $('#loginPassword').val();
                const redirect = $('#loginRedirect').val();
                const wflsVerification = $('#loginWflsVerification').val();
                
                // Disable submit button
                submitBtn.prop('disabled', true).text('Please wait...');
                _self.hideAlert();
                
                // Get recaptcha token
                _self.getRecaptchaToken('login').then(function(token) {
                    
                    // Prepare AJAX data
                    const ajaxData = {
                        username: username,
                        password: password,
                        remember: false
                    };
                    
                    // Add redirect URL if present
                    if (redirect) {
                        ajaxData.redirect = redirect;
                    }

                    // Forward Wordfence email-verification token so the REST endpoint can
                    // inject it into $_REQUEST before wp_signon(), satisfying Wordfence's
                    // validate_email_verification_token() check and preventing a new email.
                    if (wflsVerification) {
                        ajaxData.wfls_verification = wflsVerification;
                    }
                    
                    $.ajax({
                        url: global.ajax_endpoints.post_login,
                        method: 'POST',
                        dataType: 'json',
                        data: ajaxData,
                        beforeSend: function(xhr) {
                            if (token) {
                                xhr.setRequestHeader('X-Recaptcha-Token', token);
                            }
                            
                            // Debug logging
                            if (global.debug_mode) {
                                console.log('Login AJAX request:', {
                                    url: global.ajax_endpoints.post_login,
                                    username: username,
                                    hasToken: !!token
                                });
                            }
                        },
                        success: function(response) {
                            if (global.debug_mode) {
                                console.log('Login response:', response);
                            }
                            
                            if (response.success) {
                                // Redirect immediately without showing success message
                                window.location.href = response.redirect || global.site_url;
                            } else {
                                _self.showAlert(response.message || 'Login failed. Please try again.', 'danger', true);
                                submitBtn.prop('disabled', false).text('Submit');
                            }
                        },
                        error: function(xhr, status, error) {
                            if (global.debug_mode) {
                                console.error('Login error:', {xhr: xhr, status: status, error: error});
                            }
                            
                            let errorMessage = 'An error occurred. Please try again.';
                            if (xhr.responseJSON && xhr.responseJSON.message) {
                                errorMessage = xhr.responseJSON.message;
                            } else if (xhr.status === 0) {
                                errorMessage = 'Network error. Please check your connection.';
                            } else if (xhr.status === 404) {
                                errorMessage = 'Login endpoint not found. Please contact support.';
                            }
                            _self.showAlert(errorMessage, 'danger', true);
                            submitBtn.prop('disabled', false).text('Submit');
                        }
                    });
                    
                }).catch(function(error) {
                    if (global.debug_mode) {
                        console.error('ReCAPTCHA error:', error);
                    }
                    _self.showAlert('reCAPTCHA verification failed. Please try again.', 'danger', true);
                    submitBtn.prop('disabled', false).text('Submit');
                });
            },
                
            submitForgotPassword: function() {
                const _self = this;
                const form = $('#forgotPasswordForm');
                const submitBtn = form.find('button[type="submit"]');
                const username = $('#forgotEmail').val();
                
                // Disable submit button
                submitBtn.prop('disabled', true).text('Please wait...');
                _self.hideAlert();
                
                // Get recaptcha token
                _self.getRecaptchaToken('forgot_password').then(function(token) {
                    
                    $.ajax({
                        url: global.ajax_endpoints.post_forgot_password,
                        method: 'POST',
                        dataType: 'json',
                        data: {
                            username: username
                        },
                        beforeSend: function(xhr) {
                            if (token) {
                                xhr.setRequestHeader('X-Recaptcha-Token', token);
                            }
                        },
                        success: function(response) {
                            // Always show success message (security: prevents user enumeration)
                            _self.showAlert(response.message || 'If an account exists with this email address, you will receive a password reset link. Please check your inbox and spam folder.', 'info', false);
                            submitBtn.prop('disabled', false).text('Submit');
                            // Clear form
                            form[0].reset();
                        },
                        error: function(xhr) {
                            let errorMessage = 'An error occurred. Please try again.';
                            if (xhr.responseJSON && xhr.responseJSON.message) {
                                errorMessage = xhr.responseJSON.message;
                            }
                            _self.showAlert(errorMessage, 'danger', false);
                            submitBtn.prop('disabled', false).text('Submit');
                        }
                    });
                    
                }).catch(function(error) {
                    _self.showAlert('reCAPTCHA verification failed. Please try again.', 'danger', false);
                    submitBtn.prop('disabled', false).text('Submit');
                });
            },
                
            setupHeartbeat: function() {
                const _self = this;
                let wasLoggedIn = typeof global.wp_uid !== 'undefined' && global.wp_uid;
                
                // Listen to heartbeat tick event
                $(document).on('heartbeat-tick', function(event, data) {
                    if (data.is_user_logged_in !== undefined) {
                        // User was logged in but now is logged out
                        if (wasLoggedIn && !data.is_user_logged_in) {
                            // Don't show modal if in wp-admin - let WordPress handle it
                            if ($('body').hasClass('wp-admin')) {
                                return;
                            }
                            
                            // Set redirect to current page so user returns here after login
                            $('#loginRedirect').val(window.location.href);
                            
                            // Hide register section when triggered by heartbeat
                            $('.register-section').hide();
                            $('#loginModal').modal('show');
                            _self.showAlert('Your session has expired. Please log in again.', 'warning', true);
                        }
                        wasLoggedIn = data.is_user_logged_in;
                    }
                });
                
                // Send custom data with heartbeat
                $(document).on('heartbeat-send', function(event, data) {
                    data.check_login_status = true;
                });
            }
            },

            // Standard Drinks Chart Modal - opens when URL hash is #standard-drinks-chart
            standardDrinksChartModal: {
                
                init: function() {
                    const _self = this;
                    
                    // Check for #standard-drinks-chart hash on page load and hash change
                    _self.checkHashAndOpenModal();
                    
                    // Listen for hash changes
                    $(window).on('hashchange', function() {
                        _self.checkHashAndOpenModal();
                    });
                    
                    // Handle modal close event - remove hash from URL
                    $('#standardDrinksChartModal').on('hidden.bs.modal', function() {
                        if (window.location.hash === '#standard-drinks-chart') {
                            // Remove hash without triggering hashchange or page jump
                            history.pushState('', document.title, window.location.pathname + window.location.search);
                        }
                    });
                    
                    // Handle clicks on links with #standard-drinks-chart href
                    $(document).on('click', 'a[href="#standard-drinks-chart"], a[href*="#standard-drinks-chart"]', function(e) {
                        e.preventDefault();
                        $('#standardDrinksChartModal').modal('show');
                        // Update URL hash
                        if (window.location.hash !== '#standard-drinks-chart') {
                            window.location.hash = '#standard-drinks-chart';
                        }
                    });
                },
                
                checkHashAndOpenModal: function() {
                    if (window.location.hash === '#standard-drinks-chart') {
                        $('#standardDrinksChartModal').modal('show');
                    }
                }
            },

            drinksCalendarLogger: {
                _mutationLogOnce: false,

                _log: function (msg, extra) {
                    if (typeof extra !== 'undefined') {
                        console.log('[HMHB DrinksCalendar]', msg, extra);
                    } else {
                        console.log('[HMHB DrinksCalendar]', msg);
                    }
                },

                defaults: {
                    containerSelector: '.js-drinks-calendar-logger, [data-drinks-calendar-logger]',
                    modalId: 'drinksCalendarEntryModal',
                    daysCount: 28,
                    /** Optional Formidable field key whose integer value overrides daysCount at runtime. */
                    fieldKeyDaysCount: '',
                    windowEndOffsetDays: 1, // Yesterday (today - 1)
                    fieldPrefix: 'drinking-log-d-',
                    fieldSuffixDrinks: 'num-of-drinks',
                    /** Formidable field key for hidden text field storing first day YYYY-MM-DD (empty = set from generated range). */
                    fieldKeyStartDate: 'drinking-log-start-date',
                    /** Optional single text field: JSON `{"YYYY-MM-DD": { drinks, mood }}` (see sync); legacy scalar per day = drinks only. */
                    fieldKeyDrinksJson: '',
                    /** Per-day field suffix for mood (hidden text); UI enabled when moodOptions non-empty. */
                    fieldSuffixMood: 'mood',
                    /** Parsed from data-mood-options (comma-separated labels). */
                    moodOptions: [],
                    /** Maximum drinks count allowed in the entry modal number field. */
                    drinksInputMax: 99,
                    /** Optional Formidable field key: integer sum of drinks across all days in the grid. */
                    fieldKeyDrinksTotal: '',
                    requireAllDays: false,
                    calendarTitle: '',
                    modalTitle: 'Log Drinks',
                    /** True when the wrapper was rendered by [drinks_calendar_logger_simple]. */
                    inlineSimple: false
                },

                _scheduleTimer: null,

                /**
                 * Coalesce init after Formidable/AJAX/DOM batches so the calendar runs when lazy HTML is present.
                 */
                scheduleInitContainers: function (reason) {
                    var _self = this;
                    clearTimeout(_self._scheduleTimer);
                    _self._scheduleTimer = setTimeout(function () {
                        _self._scheduleTimer = null;
                        _self._log('schedule: debounced flush → initContainers', reason || '(no reason)');
                        if (typeof window.requestAnimationFrame === 'function') {
                            window.requestAnimationFrame(function () {
                                _self.initContainers();
                            });
                        } else {
                            _self.initContainers();
                        }
                    }, 50);
                },

                init: function () {
                    var _self = this;

                    _self._log('init: start', {
                        readyState: document.readyState,
                        hasBody: !!document.body,
                        hasJquery: typeof jQuery !== 'undefined',
                        hasSparkDigitalInit: typeof SparkDigital !== 'undefined' && typeof SparkDigital.init === 'function',
                        selector: _self.defaults.containerSelector
                    });

                    _self.bindEvents();
                    _self._log('init: after bindEvents');

                    _self.initContainers();

                    // Reinitialise for Formidable dynamic/lazy-loaded content (debounced).
                    $(document)
                        .off('frmPageChanged.drinksCalendar frmFormComplete.drinksCalendar frmFormErrors.drinksCalendar')
                        .on('frmPageChanged.drinksCalendar frmFormComplete.drinksCalendar frmFormErrors.drinksCalendar', function (ev) {
                            _self._log('event: Formidable document event', ev.type);
                            _self.scheduleInitContainers(ev.type);
                        });

                    // After Formidable finishes loading state (AJAX replace / page change).
                    $(document)
                        .off('frmEndFormLoading.drinksCalendar')
                        .on('frmEndFormLoading.drinksCalendar', 'form', function () {
                            _self._log('event: frmEndFormLoading on form', this.className || this.id);
                            _self.scheduleInitContainers('frmEndFormLoading');
                        });

                    // jQuery AJAX (custom lazy loaders, some Formidable edge paths).
                    $(document)
                        .off('ajaxComplete.drinksCalendar')
                        .on('ajaxComplete.drinksCalendar', function (_event, _xhr, settings) {
                            _self._log('event: ajaxComplete', settings && settings.url ? settings.url : '');
                            _self.scheduleInitContainers('ajaxComplete');
                        });

                    // MutationObserver intentionally omitted — it fires on every Formidable
                    // conditional-logic DOM update causing an infinite reinitialisation loop.
                    // frmEndFormLoading, ajaxComplete, timers and the poll cover lazy-load detection.

                    // window.load: forms injected after DOMContentLoaded (images, deferred scripts, lazy blocks).
                    $(window).off('load.drinksCalendar').on('load.drinksCalendar', function () {
                        _self._log('event: window load');
                        _self.scheduleInitContainers('window.load');
                    });

                    // Fallback for HTML injected after load without firing Formidable events (debounced).
                    setTimeout(function () {
                        _self._log('timer: 300ms fallback');
                        _self.scheduleInitContainers('timer300');
                    }, 300);
                    setTimeout(function () {
                        _self._log('timer: 1200ms fallback');
                        _self.scheduleInitContainers('timer1200');
                    }, 1200);

                    // Poll until each wrapper has calendar markup or cap (fetch/non-jQuery lazy injectors).
                    var pollCount = 0;
                    var pollId = setInterval(function () {
                        pollCount += 1;
                        if (pollCount === 1 || pollCount % 10 === 0) {
                            _self._log('poll: tick', { n: pollCount, wrappers: $('.js-drinks-calendar-logger').length });
                        }
                        _self.scheduleInitContainers('poll/' + pollCount);
                        var $wrappers = $('.js-drinks-calendar-logger');
                        var allBuilt = $wrappers.length > 0;
                        $wrappers.each(function () {
                            if (!$(this).children('.drinks-calendar-logger').length) {
                                allBuilt = false;
                                return false;
                            }
                        });
                        if (allBuilt) {
                            _self._log('poll: all wrappers built — stopping', { ticks: pollCount });
                            clearInterval(pollId);
                        }
                        if (pollCount >= 75) {
                            _self._log('poll: max ticks — stopping', { wrappers: $wrappers.length, allBuilt: allBuilt });
                            clearInterval(pollId);
                        }
                    }, 400);

                    _self._log('init: done (hooks + poll registered)');
                },

                bindEvents: function () {
                    var _self = this;

                    $(document)
                        .off('click.drinksCalendarDay')
                        .on('click.drinksCalendarDay', '.drinks-calendar-logger__day', function (e) {
                            var $wrap = $(this).closest('.js-drinks-calendar-logger');
                            if ($wrap.attr('data-drinks-calendar-logger-simple') === '1') {
                                return;
                            }
                            e.preventDefault();
                            var containerId = $wrap.attr('id');
                            var dateKey = $(this).attr('data-date-key');
                            _self.openEntryModal(containerId, dateKey);
                        });

                    $(document)
                        .off('keydown.drinksCalendarInline')
                        .on('keydown.drinksCalendarInline', '.js-drinks-calendar-inline-input', function (e) {
                            if (e.ctrlKey || e.metaKey || e.altKey) {
                                return;
                            }
                            var allowedKeys = [
                                'Backspace',
                                'Delete',
                                'Tab',
                                'Escape',
                                'Enter',
                                'ArrowLeft',
                                'ArrowRight',
                                'ArrowUp',
                                'ArrowDown',
                                'Home',
                                'End'
                            ];
                            if (allowedKeys.indexOf(e.key) !== -1) {
                                return;
                            }
                            if (/^[0-9]$/.test(e.key)) {
                                return;
                            }
                            e.preventDefault();
                        });

                    $(document)
                        .off('paste.drinksCalendarInline')
                        .on('paste.drinksCalendarInline', '.js-drinks-calendar-inline-input', function (e) {
                            e.preventDefault();
                            var clip = e.originalEvent && e.originalEvent.clipboardData;
                            var pasted = clip ? clip.getData('text') : '';
                            var $input = $(this);
                            var $wrap = $input.closest('.js-drinks-calendar-logger');
                            var config = _self.getConfig($wrap);
                            var sanitized = _self.sanitizeInlineDrinksInputValue(pasted, config.drinksInputMax);
                            $input.val(sanitized).trigger('input');
                        });

                    $(document)
                        .off('input.drinksCalendarInline change.drinksCalendarInline')
                        .on('input.drinksCalendarInline change.drinksCalendarInline', '.js-drinks-calendar-inline-input', function () {
                            var $input = $(this);
                            var $wrap = $input.closest('.js-drinks-calendar-logger');
                            var containerId = _self.ensureContainerId($wrap);
                            var config = _self.getConfig($wrap);
                            var dateKey = $input.attr('data-date-key');
                            var state = _self.getStateStore(containerId);
                            var maxDrinks = config.drinksInputMax;

                            if (!state[dateKey]) {
                                return;
                            }

                            var drinksValue = _self.sanitizeInlineDrinksInputValue($input.val(), maxDrinks);
                            if (String($input.val()) !== drinksValue) {
                                $input.val(drinksValue);
                            }
                            state[dateKey].drinks = drinksValue;

                            _self.syncToFormidable($wrap, config, state[dateKey]);

                            var cid = $wrap.attr('id');
                            var dates = _self.getDateDefinitions($wrap, config);
                            _self.syncDrinksJsonFromState($wrap, cid, config, dates);
                            _self.syncDrinksTotalFromState($wrap, cid, config, dates);

                            // Refresh UI without touching this focused input.
                            $wrap.find('.drinks-calendar-logger__day').each(function () {
                                var $day = $(this);
                                var dk = $day.attr('data-date-key');
                                var row = state[dk] || {};
                                var drinksOk = row.drinks !== '' && typeof row.drinks !== 'undefined';
                                $day.removeClass('is-complete is-partial');
                                if (drinksOk) {
                                    $day.addClass('is-complete');
                                }
                                var $dayInput = $day.find('.js-drinks-calendar-inline-input');
                                if ($dayInput.length && $dayInput[0] !== document.activeElement) {
                                    var displayVal = drinksOk ? String(row.drinks) : '';
                                    if ($dayInput.val() !== displayVal) {
                                        $dayInput.val(displayVal);
                                    }
                                }
                            });
                        });

                    $(document)
                        .off('click.drinksCalendarQuick')
                        .on('click.drinksCalendarQuick', '.drinks-calendar-entry-modal__quick-btn', function (e) {
                            e.preventDefault();
                            var value = parseInt($(this).attr('data-value'), 10);
                            var $modal = $(this).closest('.drinks-calendar-entry-modal');
                            if (!isNaN(value)) {
                                value = Math.max(0, Math.min(_self.defaults.drinksInputMax, value));
                                $modal.find('.js-drinks-input').val(value).trigger('change');
                            }
                        });

                    $(document)
                        .off('click.drinksCalendarAdjust')
                        .on('click.drinksCalendarAdjust', '.drinks-calendar-entry-modal__adjust', function (e) {
                            e.preventDefault();
                            var delta = parseInt($(this).attr('data-delta'), 10);
                            var $modal = $(this).closest('.drinks-calendar-entry-modal');
                            var $input = $modal.find('.js-drinks-input');
                            var maxD = _self.defaults.drinksInputMax;
                            var current = parseInt($input.val(), 10);
                            current = isNaN(current) ? 0 : current;
                            current = Math.max(0, Math.min(maxD, current + delta));
                            $input.val(current).trigger('change');
                        });

                    $(document)
                        .off('change.drinksCalendarLive')
                        .on('change.drinksCalendarLive', '.drinks-calendar-entry-modal .js-drinks-input', function () {
                            var $modal = $(this).closest('.drinks-calendar-entry-modal');
                            _self.updateDrinksFromModal($modal);
                        });

                    $(document)
                        .off('click.drinksCalendarSave')
                        .on('click.drinksCalendarSave', '.drinks-calendar-entry-modal .js-drinks-save', function () {
                            var $modal = $(this).closest('.drinks-calendar-entry-modal');
                            _self.updateStateFromModal($modal);
                            $modal.modal('hide');
                        });

                    $(document)
                        .off('click.drinksCalendarMoodPick')
                        .on('click.drinksCalendarMoodPick', '.drinks-calendar-entry-modal .js-mood-pick', function (e) {
                            e.preventDefault();
                            var $modal = $(this).closest('.drinks-calendar-entry-modal');
                            $modal.find('.js-mood-pick').removeClass('is-selected').attr('aria-pressed', 'false');
                            $(this).addClass('is-selected').attr('aria-pressed', 'true');
                            _self.updateMoodFromModal($modal, $(this).attr('data-mood-value'));
                        });

                    // Block Formidable next/final submit when require_all_days calendar is incomplete.
                    // Allow Save progress (draft) and previous page — same signals Formidable uses to skip JS validation.
                    $(document)
                        .off('submit.drinksCalendarValidate')
                        .on('submit.drinksCalendarValidate', 'form', function (e) {
                            var $form = $(this);
                            if (_self.shouldSkipDrinksCalendarGate($form)) {
                                return;
                            }
                            if (!_self.validateFormSubmission($form)) {
                                e.preventDefault();
                                e.stopImmediatePropagation();
                                return false;
                            }
                        });

                    $(document)
                        .off('click.drinksCalendarValidate')
                        .on(
                            'click.drinksCalendarValidate',
                            '.frm_submit button, .frm_submit input[type="submit"], .frm_button_submit, input[name="frm_prev_page"], button[name="frm_prev_page"], .frm_page_back, .frm_save_draft',
                            function (e) {
                                var $btn = $(this);
                                if (_self.isSaveProgressOrPreviousClick($btn)) {
                                    return;
                                }
                                var $form = $btn.closest('form');
                                if ($form.length && !_self.validateFormSubmission($form)) {
                                    e.preventDefault();
                                    e.stopImmediatePropagation();
                                    return false;
                                }
                            }
                        );
                },

                initContainers: function () {
                    var _self = this;
                    var $containers = $(_self.defaults.containerSelector);

                    _self._log('initContainers: run', {
                        matched: $containers.length,
                        selector: _self.defaults.containerSelector
                    });

                    if (!$containers.length) {
                        _self._log('initContainers: no jQuery matches — native probe', {
                            byClass: document.querySelectorAll('.js-drinks-calendar-logger').length,
                            byDataAttr: document.querySelectorAll('[data-drinks-calendar-logger]').length,
                            byPartialClass: document.querySelectorAll('[class*="drinks-calendar"]').length
                        });
                        return;
                    }

                    $containers.each(function (idx) {
                        var $source = $(this);
                        var config = _self.getConfig($source);
                        var containerId = _self.ensureContainerId($source);
                        var hasInner = $source.children('.drinks-calendar-logger').length > 0;

                        _self._log('initContainers: container #' + idx, {
                            containerId: containerId,
                            tag: this.tagName,
                            hasInnerCalendar: hasInner,
                            outerHTMLPreview: (typeof this.outerHTML === 'string' ? this.outerHTML.substring(0, 220) : '')
                        });

                        if ($source.attr('data-drinks-calendar-initialized') !== '1') {
                            $source.attr('data-drinks-calendar-initialized', '1');
                        }

                        // Re-render when daysCount changes (e.g. field_key_days_count value resolved after lazy load).
                        var renderedDays = parseInt($source.attr('data-rendered-days-count'), 10);
                        var needsRender = !$source.children('.drinks-calendar-logger').length ||
                            (!isNaN(renderedDays) && renderedDays !== config.daysCount);
                        if (needsRender) {
                            try {
                                _self.renderCalendar($source, containerId, config);
                                _self._log('initContainers: renderCalendar finished', containerId);
                            } catch (err) {
                                _self._log('initContainers: renderCalendar ERROR', err);
                            }
                        } else {
                            _self._log('initContainers: skip render (days count unchanged)', containerId);
                        }
                        try {
                            _self.readExistingValues($source, containerId, config);
                            _self.refreshCalendarUI(containerId);
                            _self._log('initContainers: read + refresh OK', containerId);
                        } catch (err2) {
                            _self._log('initContainers: read/refresh ERROR', err2);
                        }
                    });
                },

                getConfig: function ($container) {
                    var cfg = $.extend(true, {}, this.defaults);

                    cfg.daysCount = parseInt($container.attr('data-days-count'), 10) || cfg.daysCount;

                    var daysCountKeyAttr = $container.attr('data-field-key-days-count');
                    if (typeof daysCountKeyAttr === 'string') {
                        cfg.fieldKeyDaysCount = $.trim(daysCountKeyAttr);
                    } else {
                        cfg.fieldKeyDaysCount = this.defaults.fieldKeyDaysCount;
                    }
                    if (cfg.fieldKeyDaysCount) {
                        var $daysCountField = this.getFieldInput($container, cfg.fieldKeyDaysCount);
                        if ($daysCountField.length) {
                            var fieldDaysCount = parseInt($daysCountField.val(), 10);
                            if (!isNaN(fieldDaysCount) && fieldDaysCount > 0) {
                                cfg.daysCount = fieldDaysCount;
                            }
                        }
                    }

                    cfg.windowEndOffsetDays = parseInt($container.attr('data-window-end-offset-days'), 10);
                    cfg.windowEndOffsetDays = isNaN(cfg.windowEndOffsetDays) ? this.defaults.windowEndOffsetDays : cfg.windowEndOffsetDays;
                    cfg.requireAllDays = this.parseRequireAllDays($container.attr('data-require-all-days'));
                    var jsonKeyAttr = $container.attr('data-field-key-drinks-json');
                    if (typeof jsonKeyAttr === 'string') {
                        cfg.fieldKeyDrinksJson = $.trim(jsonKeyAttr);
                    } else {
                        cfg.fieldKeyDrinksJson = this.defaults.fieldKeyDrinksJson;
                    }
                    cfg.fieldPrefix = $container.attr('data-field-prefix') || cfg.fieldPrefix;
                    cfg.fieldSuffixDrinks = $container.attr('data-field-suffix-drinks') || cfg.fieldSuffixDrinks;
                    var startDateAttr = $container.attr('data-field-key-start-date');
                    if (typeof startDateAttr === 'string') {
                        cfg.fieldKeyStartDate = $.trim(startDateAttr);
                    } else {
                        cfg.fieldKeyStartDate = this.defaults.fieldKeyStartDate;
                    }
                    var calendarTitleAttr = $container.attr('data-calendar-title');
                    cfg.calendarTitle = typeof calendarTitleAttr === 'string' ? calendarTitleAttr : cfg.calendarTitle;
                    cfg.modalTitle = $container.attr('data-modal-title') || cfg.modalTitle;
                    cfg.fieldSuffixMood = $container.attr('data-field-suffix-mood') || cfg.fieldSuffixMood;
                    cfg.moodOptions = this.parseMoodOptionsAttr($container.attr('data-mood-options'));
                    var totalAttr = $container.attr('data-field-key-drinks-total');
                    if (typeof totalAttr === 'string') {
                        cfg.fieldKeyDrinksTotal = $.trim(totalAttr);
                    } else {
                        cfg.fieldKeyDrinksTotal = this.defaults.fieldKeyDrinksTotal;
                    }

                    cfg.inlineSimple = $container.attr('data-drinks-calendar-logger-simple') === '1';
                    if (cfg.inlineSimple) {
                        cfg.moodOptions = [];
                    }

                    return cfg;
                },

                /** @param {string} [raw] */
                parseMoodOptionsAttr: function (raw) {
                    if (raw == null || typeof raw !== 'string') {
                        return [];
                    }
                    var s = raw.replace(/^\s+|\s+$/g, '');
                    if (s === '') {
                        return [];
                    }
                    var parts = s.split(',');
                    var out = [];
                    var i = 0;
                    for (i = 0; i < parts.length; i++) {
                        var one = parts[i].replace(/^\s+|\s+$/g, '');
                        if (one !== '') {
                            out.push(one);
                        }
                    }
                    return out;
                },

                /**
                 * Map stored mood (JSON / fields) to a mood_options label so pills and grid stay in sync.
                 * Trims; if no mood_options, returns trimmed raw; unknown values pass through trimmed.
                 *
                 * @param {object} config
                 * @param {string|number} moodRaw
                 * @return {string}
                 */
                canonicalMood: function (config, moodRaw) {
                    var s = moodRaw == null ? '' : String(moodRaw).replace(/^\s+|\s+$/g, '');
                    if (s === '') {
                        return '';
                    }
                    if (!config.moodOptions || !config.moodOptions.length) {
                        return s;
                    }
                    var i = 0;
                    for (i = 0; i < config.moodOptions.length; i++) {
                        var opt = config.moodOptions[i];
                        var ot = String(opt).replace(/^\s+|\s+$/g, '');
                        if (ot === s || ot.toLowerCase() === s.toLowerCase()) {
                            return opt;
                        }
                    }
                    return s;
                },

                /**
                 * Parse require_all_days attribute.
                 *
                 * Returns:
                 *   false     – validation disabled (0 / false / empty)
                 *   'all'     – every day must be complete (1 / true / "All")
                 *   N (int>0) – at least N days must be complete
                 *
                 * @param {string|number|boolean} value
                 * @return {false|'all'|number}
                 */
                parseRequireAllDays: function (value) {
                    if (value == null || value === '' || value === false) {
                        return false;
                    }
                    var s = String(value).replace(/^\s+|\s+$/g, '').toLowerCase();
                    if (s === '0' || s === 'false' || s === 'no' || s === 'off') {
                        return false;
                    }
                    if (s === 'all' || s === 'true' || s === 'yes' || s === 'on') {
                        return 'all';
                    }
                    var n = parseInt(s, 10);
                    if (!isNaN(n) && n > 0) {
                        return n;
                    }
                    return false;
                },

                parseBool: function (value, fallback) {
                    if (typeof value === 'boolean') {
                        return value;
                    }
                    if (value == null || value === '') {
                        return !!fallback;
                    }
                    var normalized = String(value).toLowerCase().replace(/^\s+|\s+$/g, '');
                    if (normalized === '1' || normalized === 'true' || normalized === 'yes' || normalized === 'on') {
                        return true;
                    }
                    if (normalized === '0' || normalized === 'false' || normalized === 'no' || normalized === 'off') {
                        return false;
                    }
                    return !!fallback;
                },

                /**
                 * Inline drinks field: digits only, clamped 0..max. Returns '' when empty.
                 *
                 * @param {string|number|null} rawVal
                 * @param {number} maxDrinks
                 * @return {string}
                 */
                sanitizeInlineDrinksInputValue: function (rawVal, maxDrinks) {
                    if (rawVal === '' || rawVal == null) {
                        return '';
                    }
                    var digits = String(rawVal).replace(/\D/g, '');
                    if (digits === '') {
                        return '';
                    }
                    var n = parseInt(digits, 10);
                    if (isNaN(n)) {
                        return '';
                    }
                    return String(Math.max(0, Math.min(maxDrinks, n)));
                },

                ensureContainerId: function ($container) {
                    var existingId = $container.attr('id');
                    if (existingId) {
                        return existingId;
                    }

                    var generatedId = 'drinks-calendar-' + String(Math.random()).replace('.', '');
                    $container.attr('id', generatedId);
                    return generatedId;
                },

                /**
                 * Parse YYYY-MM-DD in local calendar (reject invalid dates).
                 *
                 * @param {string} s
                 * @return {Date|null}
                 */
                parseYyyyMmDd: function (s) {
                    if (s == null || typeof s !== 'string') {
                        return null;
                    }
                    s = s.replace(/^\s+|\s+$/g, '');
                    if (!/^\d{4}-\d{2}-\d{2}$/.test(s)) {
                        return null;
                    }
                    var p = s.split('-');
                    var y = parseInt(p[0], 10);
                    var m = parseInt(p[1], 10);
                    var d = parseInt(p[2], 10);
                    var dt = new Date(y, m - 1, d);
                    if (dt.getFullYear() !== y || dt.getMonth() !== m - 1 || dt.getDate() !== d) {
                        return null;
                    }
                    return dt;
                },

                /**
                 * Build day rows for the grid. Uses hidden start-date field when set (YYYY-MM-DD);
                 * otherwise rolling window from today + windowEndOffsetDays, then writes first day to that field when empty.
                 *
                 * @param {jQuery} $container Logger wrapper (.js-drinks-calendar-logger)
                 * @param {object} config
                 * @return {Array}
                 */
                getDateDefinitions: function ($container, config) {
                    var days = [];
                    var startDate;
                    var parsedAnchor = null;

                    if (config.fieldKeyStartDate && $container && $container.length) {
                        var $anchorInput = this.getFieldInput($container, config.fieldKeyStartDate);
                        if ($anchorInput.length) {
                            parsedAnchor = this.parseYyyyMmDd(($anchorInput.val() || '').replace(/^\s+|\s+$/g, ''));
                        }
                    }

                    if (parsedAnchor) {
                        startDate = new Date(parsedAnchor.getFullYear(), parsedAnchor.getMonth(), parsedAnchor.getDate());
                    } else {
                        var today = new Date();
                        var endDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
                        endDate.setDate(endDate.getDate() - config.windowEndOffsetDays);
                        startDate = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate());
                        startDate.setDate(startDate.getDate() - (config.daysCount - 1));

                        if (config.fieldKeyStartDate && $container && $container.length) {
                            var $anchorField = this.getFieldInput($container, config.fieldKeyStartDate);
                            if ($anchorField.length) {
                                $anchorField.val(this.getDateKey(startDate)).trigger('change');
                            }
                        }
                    }

                    for (var i = 0; i < config.daysCount; i++) {
                        var current = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
                        current.setDate(startDate.getDate() + i);
                        var dayIndex = i + 1;
                        var dayIndexPadded = dayIndex < 10 ? '0' + dayIndex : String(dayIndex);
                        days.push({
                            index: dayIndex,
                            indexPadded: dayIndexPadded,
                            dateObj: current,
                            dateKey: this.getDateKey(current),
                            displayDate: this.formatDisplayDate(current),
                            weekday: this.formatWeekday(current)
                        });
                    }
                    return days;
                },

                getDateKey: function (dateObj) {
                    var y = dateObj.getFullYear();
                    var m = dateObj.getMonth() + 1;
                    var d = dateObj.getDate();
                    return y + '-' + (m < 10 ? '0' + m : m) + '-' + (d < 10 ? '0' + d : d);
                },

                formatDisplayDate: function (dateObj) {
                    var day = dateObj.getDate();
                    var dayStr = day < 10 ? '0' + day : String(day);
                    return dayStr + ' ' + this.formatMonthAbbrThreeChar(dateObj);
                },

                formatWeekday: function (dateObj) {
                    return dateObj.toLocaleDateString('en-AU', { weekday: 'short' });
                },

                /**
                 * Three-letter month label (Jan–Dec) for consistent calendar display across browsers.
                 *
                 * @param {Date} dateObj
                 * @return {string}
                 */
                formatMonthAbbrThreeChar: function (dateObj) {
                    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
                    return months[dateObj.getMonth()];
                },

                /** Calendar date for modal header (e.g. Friday, 1 May 2026). */
                formatModalEntryDate: function (dateKey) {
                    var dt = this.parseYyyyMmDd(dateKey);
                    if (!dt) {
                        return '';
                    }
                    var weekday = dt.toLocaleDateString('en-AU', { weekday: 'long' });
                    return weekday + ', ' + dt.getDate() + ' ' + this.formatMonthAbbrThreeChar(dt) + ' ' + dt.getFullYear();
                },

                buildFieldKey: function (config, dayIndexPadded, suffix) {
                    return config.fieldPrefix + dayIndexPadded + '-' + suffix;
                },

                /**
                 * Parse the JSON aggregate field.
                 *
                 * Supported shapes (newest first):
                 *   Array  – `[{ "date": "YYYY-MM-DD", "drinks": n, "mood": "…" }, …]`  (current)
                 *   Object – `{ "YYYY-MM-DD": { drinks, mood } }`                        (legacy v2)
                 *   Object – `{ "YYYY-MM-DD": number }`                                  (legacy v1, drinks only)
                 *
                 * Always returns a plain object keyed by date string (same shape internally)
                 * so the rest of the code requires no changes.
                 *
                 * @param {jQuery} $container
                 * @param {object} config
                 * @return {object|null}
                 */
                parseDrinksJsonAggregate: function ($container, config) {
                    if (!config.fieldKeyDrinksJson) {
                        return null;
                    }
                    var $field = this.getFieldInput($container, config.fieldKeyDrinksJson);
                    if (!$field.length) {
                        return null;
                    }
                    var raw = ($field.val() || '').replace(/^\s+|\s+$/g, '');
                    if (raw === '') {
                        return null;
                    }
                    try {
                        var parsed = JSON.parse(raw);
                        if (parsed === null || typeof parsed !== 'object') {
                            return null;
                        }
                        if (Array.isArray(parsed)) {
                            var map = {};
                            var i = 0;
                            for (i = 0; i < parsed.length; i++) {
                                var entry = parsed[i];
                                if (entry && typeof entry === 'object' && typeof entry.date === 'string' && entry.date) {
                                    map[entry.date] = entry;
                                }
                            }
                            return map;
                        }
                        return parsed;
                    } catch (ignore) {}
                    return null;
                },

                /**
                 * Writes the JSON field as an array of per-day objects:
                 *   `[{ "date": "YYYY-MM-DD", "drinks": n|null [, "mood": "…"|null] }, …]`
                 * The `mood` key is included only when mood_options is configured.
                 */
                syncDrinksJsonFromState: function ($container, containerId, config, datesOpt) {
                    if (!config.fieldKeyDrinksJson) {
                        return;
                    }
                    var $jsonField = this.getFieldInput($container, config.fieldKeyDrinksJson);
                    if (!$jsonField.length) {
                        return;
                    }
                    var dates = datesOpt || this.getDateDefinitions($container, config);
                    var state = this.getStateStore(containerId);
                    var out = [];
                    var i = 0;
                    for (i = 0; i < dates.length; i++) {
                        var dk = dates[i].dateKey;
                        var row = state[dk];
                        var drinksOut = null;
                        if (row && row.drinks !== '' && typeof row.drinks !== 'undefined') {
                            var n = parseInt(row.drinks, 10);
                            drinksOut = isNaN(n) ? null : n;
                        }
                        var entryObj = { date: dk, drinks: drinksOut };
                        if (config.moodOptions.length) {
                            var m =
                                row && row.mood !== '' && typeof row.mood !== 'undefined'
                                    ? String(row.mood).replace(/^\s+|\s+$/g, '')
                                    : '';
                            entryObj.mood = m === '' ? null : m;
                        }
                        out.push(entryObj);
                    }
                    var serialized = JSON.stringify(out);
                    if ($jsonField.val() !== serialized) {
                        $jsonField.val(serialized).trigger('change');
                    }
                },

                syncDrinksTotalFromState: function ($container, containerId, config, datesOpt) {
                    if (!config.fieldKeyDrinksTotal) {
                        return;
                    }
                    var $totalField = this.getFieldInput($container, config.fieldKeyDrinksTotal);
                    if (!$totalField.length) {
                        return;
                    }
                    var dates = datesOpt || this.getDateDefinitions($container, config);
                    var state = this.getStateStore(containerId);
                    var sum = 0;
                    var i = 0;
                    for (i = 0; i < dates.length; i++) {
                        var dk = dates[i].dateKey;
                        var row = state[dk];
                        if (row && row.drinks !== '' && typeof row.drinks !== 'undefined') {
                            var n = parseInt(row.drinks, 10);
                            if (!isNaN(n)) {
                                sum += n;
                            }
                        }
                    }
                    var serialized = String(sum);
                    if ($totalField.val() !== serialized) {
                        $totalField.val(serialized).trigger('change');
                    }
                },

                getStateStore: function (containerId) {
                    window.__hmhbDrinksCalendarStore = window.__hmhbDrinksCalendarStore || {};
                    window.__hmhbDrinksCalendarStore[containerId] = window.__hmhbDrinksCalendarStore[containerId] || {};
                    return window.__hmhbDrinksCalendarStore[containerId];
                },

                renderCalendar: function ($container, containerId, config) {
                    var _self = this;
                    _self._log('renderCalendar: start', {
                        containerId: containerId,
                        daysCount: config.daysCount,
                        calendarTitle: config.calendarTitle
                    });

                    var dates = this.getDateDefinitions($container, config);
                    var markup = '';
                    var i = 0;

                    markup += '<div class="drinks-calendar-logger" data-container-id="' + containerId + '">';
                    if (config.calendarTitle !== '') {
                        markup += '<div class="drinks-calendar-logger__header"><h4 class="drinks-calendar-logger__title">' + config.calendarTitle + '</h4></div>';
                    }
                    markup += '<div class="drinks-calendar-logger__grid">';

                    for (i = 0; i < dates.length; i++) {
                        if (config.inlineSimple) {
                            markup +=
                                '<div class="drinks-calendar-logger__day" data-container-id="' +
                                containerId +
                                '" data-date-key="' +
                                dates[i].dateKey +
                                '" data-day-index="' +
                                dates[i].indexPadded +
                                '">';
                            markup += '<span class="drinks-calendar-logger__weekday">' + dates[i].weekday + '</span>';
                            markup += '<span class="drinks-calendar-logger__date">' + dates[i].displayDate + '</span>';
                            markup += '<span class="drinks-calendar-logger__metric-line text-center d-block mt-1">';
                            markup +=
                                '<input type="number" min="0" max="' +
                                config.drinksInputMax +
                                '" step="1" tabindex="0" inputmode="numeric" pattern="[0-9]*"' +
                                ' class="form-control drinks-calendar-logger__drinks-input js-drinks-calendar-inline-input"' +
                                ' aria-label="Number of drinks for ' + dates[i].displayDate + '"' +
                                ' data-date-key="' + dates[i].dateKey + '"' +
                                ' data-day-index="' + dates[i].indexPadded + '"' +
                                ' placeholder="-">';
                            markup += '</span></div>';
                        } else {
                            markup +=
                                '<button type="button" class="drinks-calendar-logger__day" data-container-id="' +
                                containerId +
                                '" data-date-key="' +
                                dates[i].dateKey +
                                '" data-day-index="' +
                                dates[i].indexPadded +
                                '">';
                            markup += '<span class="drinks-calendar-logger__weekday">' + dates[i].weekday + '</span>';
                            markup += '<span class="drinks-calendar-logger__date">' + dates[i].displayDate + '</span>';
                            markup +=
                                '<span class="drinks-calendar-logger__metric-line text-center d-block mt-1">';
                            markup +=
                                '<span class="drinks-calendar-logger__drinks display-3 lh-1 d-block" data-role="drinks-label" data-value="">-</span>';
                            if (config.moodOptions.length) {
                                markup +=
                                    '<span class="drinks-calendar-logger__mood text-capitalize d-block mt-1 d-none" data-role="mood-label" data-value=""></span>';
                            }
                            markup += '</span></button>';
                        }
                    }

                    markup += '</div></div>';
                    $container.attr('data-rendered-days-count', config.daysCount);
                    $container.html(markup);
                    _self._log('renderCalendar: markup injected', {
                        containerId: containerId,
                        directChildren: $container.children().length,
                        dayButtons: $container.find('.drinks-calendar-logger__day').length
                    });

                    if (!config.inlineSimple) {
                        this.ensureModal(config);
                    }
                    _self._log('renderCalendar: complete', containerId);
                },

                ensureModal: function (config) {
                    var _self = this;
                    var modalSelector = '#' + config.modalId;
                    if ($(modalSelector).length) {
                        _self._log('ensureModal: already present — skip', config.modalId);
                        return;
                    }
                    _self._log('ensureModal: appending modal to body', config.modalId);

                    var quickSelect = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
                    var i = 0;

                    var quickMarkup = '';
                    for (i = 0; i < quickSelect.length; i++) {
                        quickMarkup += '<button type="button" class="btn rounded-pill drinks-calendar-entry-modal__quick-btn" data-value="' + quickSelect[i] + '">' + quickSelect[i] + '</button>';
                    }

                    var modalHtml = '';
                    modalHtml += '<div class="modal fade drinks-calendar-entry-modal" id="' + config.modalId + '" tabindex="-1" role="dialog" aria-hidden="true">';
                    modalHtml += '  <div class="modal-dialog modal-dialog-centered" role="document">';
                    modalHtml += '    <div class="modal-content">';
                    modalHtml += '      <div class="modal-body">';
                    modalHtml += '        <button type="button" class="close position-absolute" style="top: 1rem; right: 1rem;" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>';
                    modalHtml += '        <h3 class="drinks-calendar-entry-modal__title">' + config.modalTitle + '</h3>';
                    modalHtml += '        <p class="drinks-calendar-entry-modal__date js-entry-date-label mb-3"></p>';
                    modalHtml += '        <div class="form-group">';
                    modalHtml += '          <label class="drinks-calendar-entry-modal__label">Number of drinks</label>';
                    modalHtml += '          <div class="drinks-calendar-entry-modal__counter">';
                    modalHtml += '            <button type="button" class="btn rounded-pill drinks-calendar-entry-modal__adjust" data-delta="-1" aria-label="Decrease number of drinks">-</button>';
                    modalHtml +=
                        '            <input type="number" min="0" max="' +
                        config.drinksInputMax +
                        '" step="1" class="form-control js-drinks-input" value="0">';
                    modalHtml += '            <button type="button" rounded-pill class="btn rounded-pill drinks-calendar-entry-modal__adjust" data-delta="1" aria-label="Increase number of drinks">+</button>';
                    modalHtml += '          </div>';
                    modalHtml += '        </div>';
                    modalHtml += '        <div class="form-group">';
                    modalHtml += '          <label class="drinks-calendar-entry-modal__label hidden">Quick select</label>';
                    modalHtml += '          <div class="drinks-calendar-entry-modal__quick hidden">' + quickMarkup + '</div>';
                    modalHtml += '        </div>';
                    modalHtml += '        <div class="form-group js-mood-modal-wrap d-none">';
                    modalHtml += '          <label class="drinks-calendar-entry-modal__label">Mood</label>';
                    modalHtml += '          <div class="drinks-calendar-entry-modal__radio-group js-mood-radio-root"></div>';
                    modalHtml += '        </div>';
                    modalHtml += '        <div class="d-flex justify-content-end">';
                    modalHtml += '          <button type="button" class="btn btn-block btn-primary js-drinks-save" data-dismiss="modal">Close</button>';
                    modalHtml += '        </div>';
                    modalHtml += '      </div>';
                    modalHtml += '    </div>';
                    modalHtml += '  </div>';
                    modalHtml += '</div>';

                    $('body').append(modalHtml);
                    _self._log('ensureModal: appended', { modalId: config.modalId, inDom: $(modalSelector).length });
                },

                getFieldInput: function ($container, fieldKey) {
                    var $scope = $container.closest('form');
                    if (!$scope.length) {
                        $scope = $container.closest('.frm_forms');
                    }
                    if (!$scope.length) {
                        $scope = $(document);
                    }
                    var escaped = fieldKey.replace(/"/g, '\\"');
                    var $input = $scope.find('[name="item_meta[' + escaped + ']"]');

                    if (!$input.length) {
                        $input = $scope.find('[name="' + escaped + '"]');
                    }
                    if (!$input.length) {
                        $input = $scope.find('#field_' + escaped);
                    }
                    return $input.first();
                },

                readExistingValues: function ($container, containerId, config) {
                    var _self = this;
                    var state = _self.getStateStore(containerId);
                    var dates = _self.getDateDefinitions($container, config);
                    var jsonMap = _self.parseDrinksJsonAggregate($container, config);

                    $.each(dates, function (_, day) {
                        var drinksKey = _self.buildFieldKey(config, day.indexPadded, config.fieldSuffixDrinks);
                        var $drinksInput = _self.getFieldInput($container, drinksKey);

                        var drinksVal = '';
                        var fromJson = false;
                        var moodVal = '';
                        var fromJsonMood = false;

                        if (jsonMap && Object.prototype.hasOwnProperty.call(jsonMap, day.dateKey)) {
                            var jv = jsonMap[day.dateKey];
                            if (jv === null || typeof jv === 'undefined') {
                                drinksVal = '';
                            } else if (
                                typeof jv === 'object' &&
                                !Array.isArray(jv) &&
                                ('drinks' in jv || 'mood' in jv || 'date' in jv)
                            ) {
                                var dPart = jv.drinks;
                                if (dPart === null || typeof dPart === 'undefined') {
                                    drinksVal = '';
                                } else if (typeof dPart === 'number' && !isNaN(dPart)) {
                                    drinksVal = String(dPart);
                                    fromJson = true;
                                } else {
                                    drinksVal = String(dPart).replace(/^\s+|\s+$/g, '');
                                    fromJson = drinksVal !== '';
                                }
                                if (config.moodOptions.length) {
                                    var mPart = jv.mood;
                                    if (mPart === null || typeof mPart === 'undefined') {
                                        moodVal = '';
                                    } else {
                                        moodVal = String(mPart).replace(/^\s+|\s+$/g, '');
                                        fromJsonMood = moodVal !== '';
                                    }
                                }
                            } else if (typeof jv === 'number' && !isNaN(jv)) {
                                drinksVal = String(jv);
                                fromJson = true;
                            } else if (typeof jv === 'string') {
                                drinksVal = jv.replace(/^\s+|\s+$/g, '');
                                fromJson = drinksVal !== '';
                            }
                        }
                        if (!fromJson && $drinksInput.length) {
                            var rawD = $drinksInput.val();
                            drinksVal = rawD === '' || rawD == null ? '' : String(rawD);
                        }

                        if (config.moodOptions.length) {
                            var moodKey = _self.buildFieldKey(config, day.indexPadded, config.fieldSuffixMood);
                            var $moodInput = _self.getFieldInput($container, moodKey);

                            if (!fromJsonMood && $moodInput.length) {
                                var rawM = $moodInput.val();
                                moodVal = rawM === '' || rawM == null ? '' : String(rawM).replace(/^\s+|\s+$/g, '');
                            }

                            if (fromJsonMood && $moodInput.length) {
                                var nextM = _self.canonicalMood(config, moodVal);
                                if ($moodInput.val() !== nextM) {
                                    $moodInput.val(nextM);
                                }
                            }
                        }

                        state[day.dateKey] = {
                            drinks: drinksVal,
                            dayIndexPadded: day.indexPadded,
                            displayDate: day.weekday + ', ' + day.displayDate
                        };
                        if (config.moodOptions.length) {
                            var resolvedMood = _self.canonicalMood(config, moodVal);
                            state[day.dateKey].mood = resolvedMood;
                            // Only push the resolved mood back to the hidden field when we have a positive
                            // value — never blank-out a field that Formidable already has data for.
                            var moodKeyCanon = _self.buildFieldKey(config, day.indexPadded, config.fieldSuffixMood);
                            var $moodInputCanon = _self.getFieldInput($container, moodKeyCanon);
                            if ($moodInputCanon.length) {
                                var canonStr = state[day.dateKey].mood;
                                if (canonStr !== '' && String($moodInputCanon.val() || '') !== canonStr) {
                                    $moodInputCanon.val(canonStr);
                                }
                            }
                        }

                        if (fromJson && $drinksInput.length) {
                            var next = drinksVal === '' ? '' : String(drinksVal);
                            if ($drinksInput.val() !== next) {
                                $drinksInput.val(next);
                            }
                        }
                    });

                    // syncDrinksJsonFromState / syncDrinksTotalFromState intentionally NOT called here.
                    // readExistingValues is read-only; those syncs trigger field change events which
                    // re-run Formidable conditional logic → more DOM mutations → reinitialisation loop.
                    // They are called by syncToFormidable on every user interaction instead.
                },

                openEntryModal: function (containerId, dateKey) {
                    this._log('openEntryModal', { containerId: containerId, dateKey: dateKey });
                    if (!containerId) {
                        this._log('openEntryModal: missing containerId — cannot open');
                        return;
                    }
                    var $container = $('#' + containerId);
                    var config = this.getConfig($container);
                    var modalSelector = '#' + config.modalId;
                    var state = this.getStateStore(containerId);
                    var current = state[dateKey] || {};
                    var modal = $(modalSelector);

                    modal.attr('data-container-id', containerId);
                    modal.attr('data-date-key', dateKey);
                    modal.find('.js-entry-date-label').text(this.formatModalEntryDate(dateKey) || dateKey);
                    modal.find('.js-drinks-input').attr({ min: 0, max: config.drinksInputMax });
                    // Preserve '' for un-entered days so Save/Close without interaction keeps state empty.
                    // Only coerce to a number when a value has already been explicitly saved.
                    var openDrinks;
                    if (current.drinks === '' || typeof current.drinks === 'undefined') {
                        openDrinks = '';
                    } else {
                        openDrinks = parseInt(current.drinks, 10);
                        openDrinks = isNaN(openDrinks) ? '' : Math.max(0, Math.min(config.drinksInputMax, openDrinks));
                    }
                    modal.find('.js-drinks-input').val(openDrinks);

                    var $moodWrap = modal.find('.js-mood-modal-wrap');
                    var $moodRoot = modal.find('.js-mood-radio-root');
                    $moodRoot.empty();
                    if (config.moodOptions.length) {
                        // Resolve saved mood from state, then per-day field, then JSON (most-reliable order).
                        var sel = this.canonicalMood(config, current.mood);

                        if (sel === '' && current.dayIndexPadded) {
                            var moodFieldKey = this.buildFieldKey(config, current.dayIndexPadded, config.fieldSuffixMood);
                            var $moodFieldEl = this.getFieldInput($container, moodFieldKey);
                            if ($moodFieldEl.length) {
                                sel = this.canonicalMood(config, $moodFieldEl.val());
                            }
                        }

                        if (sel === '' && config.fieldKeyDrinksJson) {
                            var jsonData = this.parseDrinksJsonAggregate($container, config);
                            if (
                                jsonData &&
                                Object.prototype.hasOwnProperty.call(jsonData, dateKey) &&
                                jsonData[dateKey] &&
                                typeof jsonData[dateKey] === 'object' &&
                                !Array.isArray(jsonData[dateKey]) &&
                                jsonData[dateKey].mood != null
                            ) {
                                sel = this.canonicalMood(config, jsonData[dateKey].mood);
                            }
                        }

                        // Keep state in sync with whatever was resolved.
                        if (sel !== '' && state[dateKey]) {
                            state[dateKey].mood = sel;
                        }

                        var mi = 0;
                        for (mi = 0; mi < config.moodOptions.length; mi++) {
                            var label = config.moodOptions[mi];
                            var $btn = $(
                                '<button type="button" class="btn rounded-pill drinks-calendar-entry-modal__radio-pill js-mood-pick"></button>'
                            );
                            $btn.attr('data-mood-value', label);
                            $btn.attr('aria-pressed', 'false');
                            $btn.text(label);
                            if (sel !== '' && sel === label) {
                                $btn.addClass('is-selected');
                                $btn.attr('aria-pressed', 'true');
                            }
                            $moodRoot.append($btn);
                        }
                        $moodWrap.removeClass('d-none');
                    } else {
                        $moodWrap.addClass('d-none');
                    }

                    modal.modal('show');
                },

                /**
                 * Called only when drinks input changes (+/-, quick select, typing).
                 * Only syncs drinks — mood is never read or modified.
                 * Empty input stores '' so un-entered days remain distinguishable from explicit 0.
                 */
                updateDrinksFromModal: function ($modal) {
                    var containerId = $modal.attr('data-container-id');
                    var dateKey = $modal.attr('data-date-key');
                    var $container = $('#' + containerId);
                    var config = this.getConfig($container);
                    var state = this.getStateStore(containerId);
                    var maxDrinks = config.drinksInputMax;

                    if (!state[dateKey]) {
                        return;
                    }

                    var $drinksIn = $modal.find('.js-drinks-input');
                    var rawVal = $drinksIn.val();
                    var drinksValue;
                    if (rawVal === '' || rawVal == null) {
                        drinksValue = '';
                    } else {
                        var parsed = parseInt(rawVal, 10);
                        drinksValue = isNaN(parsed) ? '' : Math.max(0, Math.min(maxDrinks, parsed));
                    }
                    if (drinksValue !== '' && String($drinksIn.val()) !== String(drinksValue)) {
                        $drinksIn.val(drinksValue);
                    }

                    state[dateKey].drinks = drinksValue;

                    this.syncToFormidable($container, config, state[dateKey]);
                    this.refreshCalendarUI(containerId);

                    if (config.requireAllDays && !config.inlineSimple) {
                        this.validateRequiredContainer($container, containerId, config);
                    }
                },

                /**
                 * Called only when a mood pill is clicked — stores the explicit pill value.
                 * Never reads from DOM to infer mood; the value comes directly from the click handler.
                 *
                 * @param {jQuery} $modal
                 * @param {string} moodRaw  value of data-mood-value on the clicked pill
                 */
                updateMoodFromModal: function ($modal, moodRaw) {
                    var containerId = $modal.attr('data-container-id');
                    var dateKey = $modal.attr('data-date-key');
                    var $container = $('#' + containerId);
                    var config = this.getConfig($container);
                    var state = this.getStateStore(containerId);

                    if (!state[dateKey]) {
                        return;
                    }

                    var moodCanonical = this.canonicalMood(config, moodRaw || '');
                    state[dateKey].mood = moodCanonical;

                    this.syncToFormidable($container, config, state[dateKey]);
                    this.refreshCalendarUI(containerId);

                    if (config.requireAllDays && !config.inlineSimple) {
                        this.validateRequiredContainer($container, containerId, config);
                    }
                },

                /**
                 * Called when Save is clicked — commits current drinks and the currently
                 * selected mood pill to state.  Mood is read from the selected pill; if
                 * nothing is selected the existing state.mood is preserved unchanged.
                 * Empty input stores '' so un-entered days remain distinguishable from explicit 0.
                 */
                updateStateFromModal: function ($modal) {
                    var containerId = $modal.attr('data-container-id');
                    var dateKey = $modal.attr('data-date-key');
                    var $container = $('#' + containerId);
                    var config = this.getConfig($container);
                    var state = this.getStateStore(containerId);
                    var maxDrinks = config.drinksInputMax;

                    if (!state[dateKey]) {
                        return;
                    }

                    var $drinksIn = $modal.find('.js-drinks-input');
                    var rawVal = $drinksIn.val();
                    var drinksValue;
                    if (rawVal === '' || rawVal == null) {
                        drinksValue = '';
                    } else {
                        var parsed = parseInt(rawVal, 10);
                        drinksValue = isNaN(parsed) ? '' : Math.max(0, Math.min(maxDrinks, parsed));
                    }
                    if (drinksValue !== '' && String($drinksIn.val()) !== String(drinksValue)) {
                        $drinksIn.val(drinksValue);
                    }

                    state[dateKey].drinks = drinksValue;

                    if (config.moodOptions.length) {
                        var $picked = $modal.find('.js-mood-pick.is-selected').first();
                        if ($picked.length) {
                            state[dateKey].mood = this.canonicalMood(
                                config,
                                String($picked.attr('data-mood-value') || '')
                            );
                        }
                        // If no pill is selected, keep state[dateKey].mood unchanged.
                    }

                    this.syncToFormidable($container, config, state[dateKey]);
                    this.refreshCalendarUI(containerId);

                    if (config.requireAllDays && !config.inlineSimple) {
                        this.validateRequiredContainer($container, containerId, config);
                    }
                },

                syncToFormidable: function ($container, config, stateRow) {
                    if (!stateRow || !stateRow.dayIndexPadded) {
                        return;
                    }

                    var drinksKey = this.buildFieldKey(config, stateRow.dayIndexPadded, config.fieldSuffixDrinks);
                    var $drinksInput = this.getFieldInput($container, drinksKey);

                    if ($drinksInput.length) {
                        $drinksInput.val(stateRow.drinks).trigger('change');
                    }

                    if (config.moodOptions.length) {
                        var moodKey = this.buildFieldKey(config, stateRow.dayIndexPadded, config.fieldSuffixMood);
                        var $moodInput = this.getFieldInput($container, moodKey);
                        if ($moodInput.length) {
                            var mv =
                                stateRow.mood !== '' && typeof stateRow.mood !== 'undefined'
                                    ? String(stateRow.mood)
                                    : '';
                            $moodInput.val(mv).trigger('change');
                        }
                    }

                    var cid = $container.attr('id');
                    if (cid) {
                        this.syncDrinksJsonFromState($container, cid, config);
                        this.syncDrinksTotalFromState($container, cid, config);
                    }
                },

                refreshCalendarUI: function (containerId) {
                    var state = this.getStateStore(containerId);
                    var $container = $('#' + containerId);
                    var config = this.getConfig($container);

                    $container.find('.drinks-calendar-logger__day').each(function () {
                        var $day = $(this);
                        var dateKey = $day.attr('data-date-key');
                        var row = state[dateKey] || {};
                        var drinksRaw = row.drinks !== '' && typeof row.drinks !== 'undefined' ? String(row.drinks) : '';

                        if (config.inlineSimple) {
                            var $inlineInput = $day.find('.js-drinks-calendar-inline-input');
                            if ($inlineInput.length && $inlineInput[0] !== document.activeElement) {
                                if ($inlineInput.val() !== drinksRaw) {
                                    $inlineInput.val(drinksRaw);
                                }
                            }
                        } else {
                            var displayVal = drinksRaw !== '' ? drinksRaw : '-';
                            var $drinksEl = $day.find('[data-role="drinks-label"]');
                            $drinksEl.text(displayVal).attr('data-value', drinksRaw);

                            var $moodEl = $day.find('[data-role="mood-label"]');
                            if ($moodEl.length) {
                                var moodRaw =
                                    row.mood !== '' && typeof row.mood !== 'undefined' ? String(row.mood).replace(/^\s+|\s+$/g, '') : '';
                                $moodEl.text(moodRaw).attr('data-value', moodRaw);
                                $moodEl.toggleClass('d-none', moodRaw === '');
                            }
                        }

                        var drinksOk = row.drinks !== '' && typeof row.drinks !== 'undefined';
                        var dayComplete = drinksOk;
                        if (config.moodOptions.length) {
                            dayComplete =
                                dayComplete &&
                                row.mood !== '' &&
                                typeof row.mood !== 'undefined';
                        }

                        $day.removeClass('is-complete is-partial');
                        if (dayComplete) {
                            $day.addClass('is-complete');
                        }
                    });
                },

                updateRequiredError: function ($container, config, isValid) {
                    var $calendar = $container.find('.drinks-calendar-logger').first();
                    if (!$calendar.length) {
                        return;
                    }

                    var $err = $container.children('.js-drinks-calendar-error').first();
                    if (isValid) {
                        if ($err.length) {
                            $err.remove();
                        }
                        return;
                    }

                    var daysGenerated = config.daysCount;
                    var requiredCount = config.requireAllDays === 'all'
                        ? config.daysCount
                        : config.requireAllDays;
                    var message;
                    if (config.moodOptions.length) {
                        if (requiredCount === daysGenerated) {
                            message = 'Please enter drinks and mood for every day.';
                        } else {
                            var dayWordMood = requiredCount === 1 ? 'day' : 'days';
                            message =
                                'Please enter drinks and mood for at least ' +
                                requiredCount +
                                ' ' +
                                dayWordMood +
                                '.';
                        }
                    } else if (requiredCount === daysGenerated) {
                        message = 'Please enter drinks for every day.';
                    } else {
                        var dayWord = requiredCount === 1 ? 'day' : 'days';
                        message =
                            'Please enter drinks for at least ' + requiredCount + ' ' + dayWord + '.';
                    }
                    if (!$err.length) {
                        $err = $('<div class="invalid-feedback d-block drinks-calendar-logger__error js-drinks-calendar-error" role="alert"></div>');
                        $calendar.after($err);
                    }
                    $err.text(message);
                },

                validateRequiredContainer: function ($container, containerId, config) {
                    var _self = this;
                    var state = this.getStateStore(containerId);
                    var requiredCount = config.requireAllDays === 'all'
                        ? config.daysCount
                        : config.requireAllDays;
                    var completedCount = 0;

                    $container.find('.drinks-calendar-logger__day').each(function () {
                        var $day = $(this);
                        var dateKey = $day.attr('data-date-key');
                        var row = state[dateKey] || {};
                        var hasDrinks = row.drinks !== '' && typeof row.drinks !== 'undefined';
                        var hasMood = true;
                        if (config.moodOptions.length) {
                            hasMood = row.mood !== '' && typeof row.mood !== 'undefined';
                        }
                        var dayOk = hasDrinks && hasMood;
                        $day.removeClass('is-missing');
                        if (config.inlineSimple) {
                            var $inlineInput = $day.find('.js-drinks-calendar-inline-input');
                            if ($inlineInput.length) {
                                $inlineInput.removeClass('is-invalid');
                                if (!dayOk) {
                                    $inlineInput.addClass('is-invalid');
                                }
                            }
                        }
                        if (dayOk) {
                            completedCount += 1;
                        } else {
                            $day.addClass('is-missing');
                        }
                    });

                    var valid = completedCount >= requiredCount;
                    _self.updateRequiredError($container, config, valid);
                    return valid;
                },

                /**
                 * True when Formidable is saving a draft / save-progress or moving to the previous page.
                 * Aligns with frmProForm.savingDraft / goingToPreviousPage and .frm_saving_draft hidden field.
                 *
                 * @param {jQuery} $form
                 * @return {boolean}
                 */
                shouldSkipDrinksCalendarGate: function ($form) {
                    if (!$form || !$form.length) {
                        return false;
                    }
                    var formNode = $form.get(0);
                    if (typeof window.frmProForm !== 'undefined' && window.frmProForm !== null) {
                        if (window.frmProForm.savingDraft(formNode)) {
                            return true;
                        }
                        if (window.frmProForm.goingToPreviousPage(formNode)) {
                            return true;
                        }
                    }
                    var draftVal = $form.find('.frm_saving_draft').val();
                    if (draftVal === 1 || draftVal === '1') {
                        return true;
                    }
                    return false;
                },

                /**
                 * @param {jQuery} $trigger Click target (button/input).
                 * @return {boolean}
                 */
                isSaveProgressOrPreviousClick: function ($trigger) {
                    if (!$trigger || !$trigger.length) {
                        return false;
                    }
                    var el = $trigger.get(0);
                    var name = el.name || '';
                    var cls = typeof el.className === 'string' ? el.className : '';
                    if (name === 'frm_save_draft' || cls.indexOf('frm_save_draft') !== -1) {
                        return true;
                    }
                    if (name === 'frm_prev_page' || cls.indexOf('frm_prev_page') !== -1) {
                        return true;
                    }
                    if (cls.indexOf('frm_page_back') !== -1) {
                        return true;
                    }
                    return false;
                },

                /**
                 * Scroll viewport so the calendar wrapper is visible after blocking submit/next.
                 *
                 * @param {jQuery} $container `.js-drinks-calendar-logger` wrapper
                 */
                scrollToCalendar: function ($container) {
                    if (!$container || !$container.length) {
                        return;
                    }
                    var el = $container[0];
                    if (typeof el.scrollIntoView !== 'function') {
                        return;
                    }
                    try {
                        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    } catch (ignore) {
                        el.scrollIntoView(true);
                    }
                },

                /**
                 * For inline-simple calendars: flush every visible number input into state and
                 * Formidable hidden fields so values typed without blur are captured before
                 * validation runs.
                 *
                 * @param {jQuery} $container
                 * @param {string} containerId
                 * @param {object} config
                 */
                flushInlineInputs: function ($container, containerId, config) {
                    var _self = this;
                    var state = _self.getStateStore(containerId);
                    var maxDrinks = config.drinksInputMax;
                    var dates = _self.getDateDefinitions($container, config);

                    $container.find('.js-drinks-calendar-inline-input').each(function () {
                        var $input = $(this);
                        var dateKey = $input.attr('data-date-key');
                        if (!state[dateKey]) {
                            return;
                        }
                        var drinksValue = _self.sanitizeInlineDrinksInputValue($input.val(), maxDrinks);
                        if (String($input.val()) !== drinksValue) {
                            $input.val(drinksValue);
                        }
                        state[dateKey].drinks = drinksValue;
                        _self.syncToFormidable($container, config, state[dateKey]);
                    });

                    _self.syncDrinksJsonFromState($container, containerId, config, dates);
                    _self.syncDrinksTotalFromState($container, containerId, config, dates);
                },

                validateFormSubmission: function ($form) {
                    var _self = this;
                    var isValid = true;
                    var $firstInvalid = null;
                    var $allContainers = $form.find(this.defaults.containerSelector);

                    // Flush inline inputs for simple calendars (values typed without blur).
                    $allContainers.each(function () {
                        var $container = $(this);
                        var config = _self.getConfig($container);
                        if (!config.inlineSimple) {
                            return;
                        }
                        var containerId = _self.ensureContainerId($container);
                        _self.flushInlineInputs($container, containerId, config);
                    });

                    var $requiredContainers = $allContainers.filter(function () {
                        return !!_self.getConfig($(this)).requireAllDays;
                    });

                    $requiredContainers.each(function () {
                        var $container = $(this);
                        var config = _self.getConfig($container);

                        var containerId = _self.ensureContainerId($container);
                        _self.readExistingValues($container, containerId, config);
                        _self.refreshCalendarUI(containerId);
                        if (!_self.validateRequiredContainer($container, containerId, config)) {
                            isValid = false;
                            if (!$firstInvalid) {
                                $firstInvalid = $container;
                            }
                        }
                    });

                    if (!isValid && $firstInvalid) {
                        _self.scrollToCalendar($firstInvalid);
                    }

                    return isValid;
                }
            },

            // Sonnar Audio Chapters Modal
            audioChaptersModal: {

                init: function () {

                    $(document).on('click', '.btn-audio-chapters-modal', function (e) {
                        e.preventDefault();

                        var sourceId = $(this).data('source');
                        var $sourceList = $(sourceId).find('.audio-chapters__list');

                        if ($sourceList.length === 0) return;

                        var $clonedList = $sourceList.clone(true, true);

                        var $modal = $('#bs_modal_audio_chapters');

                        if ($modal.length > 0) {
                            $modal.find('.modal-body').empty().append($clonedList);
                            $modal.modal('show');
                        } else {
                            $modal = $('\
                                <div id="bs_modal_audio_chapters" class="modal fade" tabindex="-1" aria-hidden="true">\
                                    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">\
                                        <div class="modal-content">\
                                            <div class="modal-header">\
                                                <h5 class="modal-title">Audio chapters</h5>\
                                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">\
                                                    <span aria-hidden="true">&times;</span>\
                                                </button>\
                                            </div>\
                                            <div class="modal-body"></div>\
                                        </div>\
                                    </div>\
                                </div>\
                            ');

                            $modal.find('.modal-body').append($clonedList);
                            $('body').append($modal);
                            $modal.modal('show');
                        }
                    });
                }
            },

            // Follow-up lesson sticky notification banner
            // Hides the #ld-follow-up-notification banner when a mapped Formidable form is submitted via AJAX.
            // Form IDs to watch are stored on the banner element as data-form-ids (comma-separated integers).
            followUpNotification: {

                init: function () {
                    var $banner = $('#ld-follow-up-notification');
                    if ($banner.length === 0) {
                        return;
                    }

                    // Parse the form IDs from the banner element attribute.
                    var formIds = $banner.data('form-ids')
                        ? String($banner.data('form-ids')).split(',').map(function (id) { return parseInt(id, 10); }).filter(Boolean)
                        : [];

                    if (formIds.length === 0) {
                        return;
                    }

                    // Listen for Formidable's completion event (fires on AJAX form submit via frm_load_form).
                    // Rule 22: forms load via AJAX by default; use event delegation on document.
                    $(document).on('frmFormComplete', function (event, form, response) {
                        var submittedFormId = form && form.id ? parseInt(form.id, 10) : 0;

                        // If the submitted form is one of the follow-up mapped forms, hide the banner.
                        if (submittedFormId > 0 && formIds.indexOf(submittedFormId) !== -1) {
                            $banner.slideUp(300, function () {
                                $banner.attr('aria-hidden', 'true');
                            });
                        }
                    });
                }

            },

            // Weekly check-in gate: editor toast dismiss + reload the full lesson after the
            // gated check-in form is submitted on a .hmhb-weekly-checkin-gate page.
            // Rule 22: forms load via AJAX; use event delegation on document.
            weeklyCheckIn: {

                init: function () {

                    // --- Editor toast ---
                    var $toast   = $('#hmhb-weekly-checkin-toast');
                    var $wrapper = $toast.closest('.hmhb-weekly-checkin-toast-wrapper');

                    if ($toast.length) {
                        if (typeof $toast.toast === 'function') {
                            $toast.toast({ autohide: false });
                        }

                        // Direct handler: hide the fixed wrapper completely on close click.
                        $toast.find('[data-dismiss="toast"]').on('click.weeklyCheckIn', function () {
                            $wrapper.fadeOut(200);
                        });
                    }

                    // --- Reload after form submit on check-in lesson pages ---
                    var $gate = $('.hmhb-weekly-checkin-gate');
                    if ($gate.length === 0) {
                        return;
                    }

                    var mappedFormId = parseInt($gate.data('form-id'), 10) || 0;
                    if (mappedFormId <= 0) {
                        return;
                    }

                    // Listen for Formidable's AJAX completion event (Rule 22 — delegated).
                    $(document).on('frmFormComplete.weeklyCheckIn', function (event, form) {
                        var submittedFormId = form && form.id ? parseInt(form.id, 10) : 0;
                        if (submittedFormId > 0 && submittedFormId === mappedFormId) {
                            // Reload without the test query string so the full lesson renders.
                            var url = window.location.href.replace(/[?&]hmhb_weekly_checkin_test=1/, '');
                            window.location.href = url;
                        }
                    });
                }

            }


        },

        /***********************************************************
        // PAGE SPECIFIC FUNCTIONS
        ***********************************************************/
        pages = function () {

            // Specific functions only required Use CSS classname on body tag
            if ($("body").hasClass('page-home')) { // Home or Front-Page

            }


            if ($("body").hasClass('page')) {

            }

            if ($("body").hasClass('post')) { // Post or Page

            }

            if ($("body").hasClass('search')) { // Search

            }

            if ($("body").hasClass('archives') || $("body").hasClass('category')) { // Archives, Catgory, Tags, etc.

            }

            if ($("body").hasClass('page-template-default')) {
                // Inline Code here ...
            }

            if ($("body").hasClass('page-register')) { // Registration page 
                components.forms.registration.init()
            }


            /* Other non-page specific functions for every page */

            // Bootstrap Tooltips
            $(function () {
                $('[data-toggle="tooltip"]').tooltip({
                    // 'boundary': 'window',
                    'trigger' : 'hover click',
                })
            });
              

            // Contact form
            // components.forms.contact.init();
            // $("#formSubmit").click(function (e) {
            //     var form = $("#form");
            //     console.log('submit button is clicked!!', e);
            // });
            $("#form").on("submit", function (e) {
                var eligibleLink = $(this).data("url-eligible");
                var ineligibleLink = $(form).data("url-ineligible");
                var _actionLink = eligibleLink;
                $(this).find("div.form-group").each(function (index, value) {
                    var answer = $(value).find("div.hidden-answer").text();
                    var userOption = $(value).find("input[type=radio]:checked").val();
                    if (answer != userOption) {
                        _actionLink = ineligibleLink
                        return false;
                    }
                });
                $(this).attr("action", _actionLink);
            });
            $("a[id^='btn_option_']").on('click', function (e) {
                $(this).addClass("selected");
                var element_id = e.target.id;
                var item_array = String(element_id).split('_');
                var item_index = item_array[item_array.length - 2];
                $("a[id^='btn_option_" + item_index + "_']").each(function (index) {
                    var current_element_id = $(this).attr('id');
                    console.log('The current id is: ', current_element_id);
                    if (current_element_id != element_id) {
                        $(this).removeClass('selected');
                    }
                });
                var content_element_id = `add_content_${item_index}`;
                // console.log('button is clicked with: ', content_element_id);
                var e = $(`#${content_element_id}`);
                // console.log('The item is: ', e);
                e.css('display', 'block');
                $('#interactiveQuiz').trigger('refresh.owl.carousel');

            });

            //Custom button to go to the next quetion
            var owlQuiz = $('#interactiveQuiz');
            $('#interactiveQuiz a.nextQuestion').on('click', function (e) {
                owlQuiz.trigger('next.owl.carousel');
            });

            $(function () {
                $("div[id^='draggable_']").draggable({
                    revert: "invalid",
                    containment: "#card-drag-area"
                });

                $("div[id^='droppable_']").droppable({
                    classes: {
                        "ui-droppable-active": "ui-state-active",
                        "ui-droppable-hover": "ui-state-hover"
                    },
                    drop: function (event, ui) {

                        var draggableId = $(ui.draggable).attr('id');
                        var content = $(ui.draggable).text();
                        // console.log('The drop function is called!!! with content', content);
                        var droppableId = $(event.target).attr('id');    // Can be 1, 2, 3
                        // $(ui.draggable).addClass("sorted");
                        console.log('The drop id is : ', droppableId);
                        var fullCardList = $(".drag-area-card-list > .drag-area-card");
                        // console.log('The card list is: ', fullCardList.length);
                        if (draggableId) {
                            $(ui.draggable).addClass('sorted');
                            var unsortedCardList = $(fullCardList).not('.sorted');
                            $("span#drag-amount").text(unsortedCardList.length);
                            var draggableIdArray = draggableId.split("_");
                            if (draggableIdArray && draggableIdArray.length != 0) {
                                var draggableIdIndex = draggableIdArray[draggableIdArray.length - 1];
                                var draggableIdIndexInt = +draggableIdIndex;
                                if (draggableIdIndexInt < fullCardList.length - 1) {
                                    // Enable next card
                                    console.log("The next one is: ", draggableIdIndexInt + 1);
                                    // $(`#draggable_${draggableIdIndexInt + 1}`).addClass('card-active');
                                    $(`#draggable_${draggableIdIndexInt + 1}`).removeClass('card-inactive');
                                }
                                if (droppableId == 'droppable_1') {
                                    $("#sortable1").append(`<li class="ui-state-default">${content}</li>`);
                                    $("span#drop-amount-1").text($("#sortable1 > li").length);
                                } else if (droppableId == 'droppable_2') {
                                    $("#sortable2").append(`<li class="ui-state-default">${content}</li>`);
                                    $("span#drop-amount-2").text($("#sortable2 > li").length);
                                } else if (droppableId == 'droppable_3') {
                                    // 12
                                    $("#sortable3").append(`<li class="ui-state-default">${content}</li>`);
                                    $("span#drop-amount-3").text($("#sortable3 > li").length);
                                }
                            }
                        }
                        // $(ui.draggable).removeClass('card-active');
                        $(ui.draggable).addClass('card-inactive');
                        console.log("The dragged ui is: ", draggableId);
                    }
                });

                $("#sortable1, #sortable2, #sortable3").sortable({
                    connectWith: ".connectedSortable",
                    stop: function (event, ui) {
                        // console.log('sorted!!');
                        $("span#drop-amount-1").text($("#sortable1 > li").length);
                        $("span#drop-amount-2").text($("#sortable2 > li").length);
                        $("span#drop-amount-3").text($("#sortable3 > li").length);
                    }
                }).disableSelection();

                $('.drag-drop-reset').click(function () {
                    console.log("Restart button clicked!!!");
                    $("#sortable1").empty();
                    $("span#drop-amount-1").text('0');
                    $("#sortable2").empty();
                    $("span#drop-amount-2").text('0');
                    $("#sortable3").empty();
                    $("span#drop-amount-3").text('0');
                    $("div[id^='draggable_']").each(function (index) {
                        $(this).css("left", 0);
                        $(this).css("top", 0);
                        $(this).removeClass('sorted');
                        $(this).addClass("card-inactive")
                        if (index == 0) {
                            $(this).removeClass('card-inactive');
                        }
                    });
                    var fullCardList = $(".drag-area-card-list > .drag-area-card");
                    $("span#drag-amount").text(fullCardList.length);

                });
            });


            $(".owl-carousel:not([data-video])").each(function (index) {

                var elementId = $(this).attr('id');
                var owl_settings;
                var autoplay = $(this).data('autoplay');
                var animateIn = $(this).data('animatein');
                var items_no = $(this).data('slides');
                var nav = $(this).data('nav');
                var dots = $(this).data('dots');
                var loop = $(this).data('loop');
                var margin = $(this).data('margin');
                var isVerticalCarousel = $(this).hasClass('vertical-carousel-images') || $(this).hasClass('vertical-carousel-content');

                if (elementId && elementId == 'interactiveQuiz') {
                    //animateIn cases issue here, so get rid of it
                    owl_settings = {
                        autoplay: autoplay,
                        loop: loop,       //Loop has to be set to false to avoid potential plugin issue
                        margin: 0,
                        nav: nav,
                        dots: dots,
                        autoHeight: true,
                        navText: ["", ""]
                    };
                } else {
                    owl_settings = {
                        autoplay: autoplay,
                        autoplayTimeout: 5000,
                        autoplayHoverPause: true,
                        animateIn: animateIn,
                        //animateOut: animateOut,
                        center: false,
                        loop: loop,
                        margin: margin,
                        nav: nav,
                        dots: dots,
                        autoHeight: true,
                        navText: ["", ""],
                        startPosition: isVerticalCarousel ? 0 : undefined,
                        slideBy: isVerticalCarousel ? 1 : undefined
                    };
                }


                // Owl Carousel shared config


                // If data attribute for slides has been defined
                if (items_no != '' && items_no !== undefined && items_no !== null) {
                    owl_settings.items = parseInt(items_no);
                    
                    if (isVerticalCarousel) {
                        owl_settings.items = 1;
                        owl_settings.responsive = false;
                        owl_settings.stagePadding = 0;
                        owl_settings.margin = 0;
                    }

                } else {
                    // items: items_no,
                    owl_settings.responsive = {
                        0: {
                            items: 1
                        },
                        600: {
                            items: 2
                        },
                        960: {
                            items: 3
                        }
                    }

                }

                // Debug
                if(global.debug_mode && isVerticalCarousel){
                    console.log('Vertical Carousel Settings:', owl_settings);
                }

                $(this).owlCarousel(owl_settings);


            });

            // Video
            $(".owl-carousel[data-video='true']").each(function (index) {

                var currentOwlElement = $(this);

                var elementId = $(this).attr('id');
                var owl_settings;
                var autoplay = $(this).data('autoplay');
                var animateIn = $(this).data('animatein');
                var items_no = $(this).data('slides');
                var video_slides = $(this).data('video');
                var nav = $(this).data('nav');
                var dots = $(this).data('dots');
                var loop = $(this).data('loop');

                owl_settings = {
                    items: items_no,
                    autoplay: autoplay,
                    animateIn: animateIn,
                    mouseDrag: false,
                    touchDrag: false,
                    pullDrag: false, 
                    // videoWidth: true, // Default false; Type: Boolean/Number
                    // videoHeight: true, // Default false; Type: Boolean/Number
                    center: false,
                    loop: false,
                    margin: 0,
                    nav: nav,
                    dots: dots,
                    // autoHeight: true,
                    navText: ["", ""],
                    onChange: function(e){
                        // Pause all medjs players on carousel change
                        // @link https://stackoverflow.com/questions/7729305/pause-mediaelement-js-using-jquery
                        $('.mejs-video video, .mejs-video audio').each(function(){
                            this.player.pause()
                        });
                    }
                };

                // Fixes Vimeo videos not hiding play icon on play resume
                // $(".mejs-overlay.mejs-layer.mejs-overlay-play").on("click", function(){
                //     console.log('hide');
                //     $(this).css('display', 'none');
                // });

                // alert( $(".mejs-overlay.mejs-layer.mejs-overlay-play").length );

        

                // Debug
                // if(global.debug_mode){
                //     console.log(owl_settings);
                // }

                $(this).owlCarousel(owl_settings);


            });

            $('a[data-type="iframe"]').on("click", function (e) {
                setTimeout(function () {
                    $('.fancybox-content').prepend($('<span data-fancybox-close class="iframe-close-btn">X</span>'));
                }, 1000);
            });

            // if ($(".learndash-quiz-889").length > 0) {
            //     setTimeout(function () {
            //         $(".learndash-quiz-889 ul.wpProQuiz_questionList li input.wpProQuiz_questionInput").each(function (e) {
            //             if ($(this).is(':checked')) {
            //                 $(this).parent().addClass('is-selected')
            //             }
            //         });
            //     }, 3500);
            // }

            // if ($(".learndash-quiz-1037").length > 0) {
            //     setTimeout(function () {
            //         $(".learndash-quiz-1037 ul.wpProQuiz_questionList[data-type='multiple'] li input.wpProQuiz_questionInput").each(function (e) {
            //             if ($(this).is(':checked')) {
            //                 $(this).parent().addClass('is-selected')
            //             }
            //         });
            //     }, 2000);
            // }

            // if ($(".learndash-quiz-2001").length > 0) {
            //     setTimeout(function () {
            //         $(".learndash-quiz-2001 ul.wpProQuiz_questionList[data-type='multiple'] li input.wpProQuiz_questionInput").each(function (e) {
            //             if ($(this).is(':checked')) {
            //                 $(this).parent().addClass('is-selected')
            //             }
            //         });
            //     }, 2000);
            // }

            // if ($(".learndash-quiz-2240").length > 0) {
            //     setTimeout(function () {
            //         $(".learndash-quiz-2240 ul.wpProQuiz_questionList[data-type='single'] li input.wpProQuiz_questionInput").each(function (e) {
            //             if ($(this).is(':checked')) {
            //                 $(this).parent().addClass('is-selected')
            //             }
            //         });
            //     }, 2000);
            // }

            // if ($(".learndash-quiz-2512").length > 0) {
            //     setTimeout(function () {
            //         $(".learndash-quiz-2512 ul.wpProQuiz_questionList[data-type='single'] li input.wpProQuiz_questionInput").each(function (e) {
            //             if ($(this).is(':checked')) {
            //                 $(this).parent().addClass('is-selected')
            //             }
            //         });
            //         $(".learndash-quiz-2512 ul.wpProQuiz_questionList[data-type='multiple'] li input.wpProQuiz_questionInput").each(function (e) {
            //             if ($(this).is(':checked')) {
            //                 $(this).parent().addClass('is-selected')
            //             }
            //         });
            //     }, 3000);
            // }

            if ($(".emotion-grid").length > 0) {
                $(".emotion-single").click(function (e) {
                    $(this).toggleClass('active');
                });
            }

            //Index menu
            $('.menu-trigger').on('click', function (e) {
                $('.index-menu-drawer').toggleClass("open");
                $('body').toggleClass("open");
                $(this).toggleClass("open");
            });

            $('.content-block-list-group--type-p1 .card').on('click', function (e) {
                $(this).find(".card-img-container").addClass('is-viewed');
            });


            //Modules landing page
            if ($(".lessons-list").length > 0) {
                $('.view-more-trigger').on('click', function (e) {
                    $(this).toggleClass("active");
                    $(this).parents(".lesson-footer-links").find(".lesson-footer-links-grid").toggleClass("active");
                    $(this).parents(".card-body-content").find(".lesson-actions").toggleClass("active");
                });
                // Trigger click on page load for mobile screens
                if ($(window).width() < 768) {
                    $('.card:not(.is-locked):not(.is-completed) .view-more-trigger').trigger('click');
                }

            }

            //Remove <p></p> (not <p>&nbsp;</p>)tags from wysiwyg editor
            $('.wysiwyg p').each(function () {
                if ($(this).html().trim() === '') {
                    $(this).remove();
                }
            });

            //Wrap tables bootsrap class 
            $('.wysiwyg table').each(function () {
                $(this).wrap('<div class="table-responsive"></div>');
            })
            
           

        },

        /***********************************************************
        // Other functions as required
        ***********************************************************/
        misc_func = function () { };


    /***********************************************************
    // Utility functions
    ***********************************************************/

    // Bootstrap breakpoint
    // @link https://unpkg.com/bootstrap-detect-breakpoint@1.0.8/src/bootstrap-detect-breakpoint.js
    bootstrapDetectBreakpoint = function () {
        // cache some values on first call
        if (!this.breakpointValues) {
            this.breakpointNames = ["xl", "lg", "md", "sm", "xs"]
            this.breakpointValues = []
            for (const breakpointName of this.breakpointNames) {
                this.breakpointValues[breakpointName] = window.getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-' + breakpointName)
            }
        }
        let i = this.breakpointNames.length
        for (const breakpointName of this.breakpointNames) {
            i--
            if (window.matchMedia("(min-width: " + this.breakpointValues[breakpointName] + ")").matches) {
                return { name: breakpointName, index: i }
            }
        }
        return null
    };

    // Utility method to get browser data
    get_storage = function (storageName, is_persistentStorage = true) {

        if (storageName != "") {

            // Store data permenantly or temporarily browser tab/window session
            if (is_persistentStorage == true) {
                // LocalStorage
                storageData = window.localStorage.getItem(storageName);

            } else {
                // SessionStorage
                storageData = window.sessionStorage.getItem(storageName);
            }

            if (storageData != null || storageData != "undefined") {

                // Always try to return as data as JS object if JSON or other data types
                try {
                    return JSON.parse(storageData);
                } catch (e) {
                    return storageData;
                }
            } else {
                return false;
            }

        }
        else {
            return false;
        }

    };

    // Utility method to store browser data
    set_storage = function (storageName, storageData, is_persistentStorage = true) {

        if (storageName != "") {

            // Always assume data is for JSON and escape data were necessary
            var storageData = JSON.stringify(storageData);

            // Store data permenantly or temporarily browser tab/window session
            if (is_persistentStorage == true) {
                // LocalStorage
                window.localStorage.setItem(storageName, storageData);

            } else {
                // SessionStorage
                window.sessionStorage.setItem(storageName, storageData);
            }
            return true;
        }
        else {
            return false;
        }

    };

    // Update HTML Document Title
    updateDocumentTitle = function (pageTitle, currentDocumentTitle) {

        let documentTitleSeparator = "|";
        let regExp = new RegExp('[\'' + documentTitleSeparator + ']', "g");

        currentDocumentTitle = !!!currentDocumentTitle ? document.title : currentDocumentTitle;

        let separatorCount = (currentDocumentTitle.match(regExp) || []).length;

        if (separatorCount > 1) {
            currentDocumentTitle = currentDocumentTitle.substring(currentDocumentTitle.indexOf(documentTitleSeparator + " ") + 1);
        }

        return document.title = pageTitle + " " + documentTitleSeparator + " " + currentDocumentTitle.trim();

    };

    // Initialise JS Class and functions
    return {

        /**
         * Expose internal components object so external bootstrap scripts
         * (e.g. wp_footer inline scripts) can reference named components.
         */
        components: components,

        /**
         * Re-scan DOM for [drinks_calendar_logger] wrappers (lazy Formidable, fetch-injected HTML).
         */
        refreshDrinksCalendar: function () {
            console.log('[HMHB DrinksCalendar] refreshDrinksCalendar() invoked');
            try {
                components.drinksCalendarLogger.scheduleInitContainers('manual refreshDrinksCalendar()');
            } catch (e) {
                console.log('[HMHB DrinksCalendar] refreshDrinksCalendar failed', e);
            }
        },

        init: function () {
            // DEBUG RELATED
            if (global.debug_mode) {
                console.log("Debug Mode: " + global.debug_mode);
            }

            // Update breakpoint/viewport
            global.breakpoint = bootstrapDetectBreakpoint();

            // Update breakpoint/viewport
            window.addEventListener('resize', function () {

                if (!!global.breakpoint) {
                    let currentBreakpointIndex = global.breakpoint;
                    global.breakpoint = bootstrapDetectBreakpoint();
                }
                else {
                    global.breakpoint = bootstrapDetectBreakpoint();
                }


                if (global.debug_mode) {
                    console.log(global.breakpoint);
                }

            });

            // Components Used throughout the site

            // components.gtm.dataLayerUserID(); // Google User-ID tracking via DataLayer
            // components.bs_carousel();
            // Drinks calendar first: lazy-loaded Formidable HTML must run even if a later component throws during init.
            try {
                components.drinksCalendarLogger.init();
                console.log('[HMHB DrinksCalendar] SparkDigital: drinksCalendarLogger.init() completed without throw');
            } catch (e) {
                console.log('[HMHB DrinksCalendar] SparkDigital: drinksCalendarLogger.init() THREW', e);
            }
            components.formidableForms();
            components.noPasteFields();
            components.stickyHeader();
            components.wow();
            components.lazyLoad();
            components.verticalCarouselSync();
            components.modal.inline();
            components.modal.iframe();
            //components.privacy_consent();
            components.smoothScroll();
            components.navBarToggle();
            components.forms.init(); // Standard Boostrap validation https://getbootstrap.com/docs/4.6/components/forms/#validation
            components.learndash.init();
            
            // Only initialize custom login modal on frontend (not in wp-admin)
            // WordPress admin has its own native session expiry modal (auth-check.js)
            if (!$('body').hasClass('wp-admin')) {
                components.loginModal.init(); // Login modal for unauthorized access
            }
            
            components.standardDrinksChartModal.init(); // Standard drinks chart modal
            components.audioChaptersModal.init(); // Audio chapters mobile modal
            components.followUpNotification.init(); // Follow-up lesson sticky notification
            components.weeklyCheckIn.init(); // Weekly check-in gate — editor toast + post-submit reload
            
            // Sonaar Audio Milestone Tracking
            // Note: Sonaar tracker is loaded separately via Sonaar_Tracker class
            // and initializes automatically for logged-in users
            // See: wpThemes/hmhb/inc/Sonaar_Tracker.php and sonaar-milestone-tracker.js
            
            // Page Specific functions
            pages();


            

        },
    };

}());

window.SparkDigital = SparkDigital;

jQuery(function () {

    console.log('[HMHB DrinksCalendar] jQuery ready: running SparkDigital.init()');
    SparkDigital.init();
    console.log('[HMHB DrinksCalendar] jQuery ready: SparkDigital.init() returned');

});

}(jQuery));

